(function ($, undefined) {
    
    var LoadSMAPI = sm.portal.vm.custom.callCustomization('LoadRequiredSMAPI');
    if(!sm.portal.utility.isNullOrEmpty(LoadSMAPI)){
        return;
    }

    var smapi = window.smapi = window.smapi || {},
        extend = $.extend,
        each = $.each,
        proxy = $.proxy,
        noop = $.noop,
        isFunction = $.isFunction,
        globalize = window.Globalize;
    
    if (typeof smapi.admissions === "undefined") {
        extend(smapi, { admissions: {} });
    }
    
    function ACTModel(options) {
        var defaults = {
            PersonID: 0,
            TestDate: null,
            Math: 0,
            English: 0,
            Reading: 0,
            Science: 0,
            Composite: 0,
            UsageMech: 0,
            RhetSkills: 0,
            PreAlgEleAlg: 0,
            AlgCooGeo: 0,
            PlaneGeoTrig: 0,
            SocStuSci: 0,
            ArtLit: 0,
            UseForPlacement: false,
            SourceID: null,
            DataStepID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.TestDate = ko.validatedObservable(settings.TestDate);
        this.Math = ko.validatedObservable(settings.Math);
        this.English = ko.validatedObservable(settings.English);
        this.Reading = ko.validatedObservable(settings.Reading);
        this.Science = ko.validatedObservable(settings.Science);
        this.Composite = ko.validatedObservable(settings.Composite);
        this.UsageMech = ko.validatedObservable(settings.UsageMech);
        this.RhetSkills = ko.validatedObservable(settings.RhetSkills);
        this.PreAlgEleAlg = ko.validatedObservable(settings.PreAlgEleAlg);
        this.AlgCooGeo = ko.validatedObservable(settings.AlgCooGeo);
        this.PlaneGeoTrig = ko.validatedObservable(settings.PlaneGeoTrig);
        this.SocStuSci = ko.validatedObservable(settings.SocStuSci);
        this.ArtLit = ko.validatedObservable(settings.ArtLit);
        this.UseForPlacement = ko.validatedObservable(settings.UseForPlacement);
        this.SourceID = ko.validatedObservable(settings.SourceID);
        this.DataStepID = ko.validatedObservable(settings.DataStepID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.DataStep = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.TestDate != undefined) {
                loaded.TestDate(responseData.TestDate);
            }
            if (responseData.Math != undefined) {
                loaded.Math(responseData.Math);
            }
            if (responseData.English != undefined) {
                loaded.English(responseData.English);
            }
            if (responseData.Reading != undefined) {
                loaded.Reading(responseData.Reading);
            }
            if (responseData.Science != undefined) {
                loaded.Science(responseData.Science);
            }
            if (responseData.Composite != undefined) {
                loaded.Composite(responseData.Composite);
            }
            if (responseData.UsageMech != undefined) {
                loaded.UsageMech(responseData.UsageMech);
            }
            if (responseData.RhetSkills != undefined) {
                loaded.RhetSkills(responseData.RhetSkills);
            }
            if (responseData.PreAlgEleAlg != undefined) {
                loaded.PreAlgEleAlg(responseData.PreAlgEleAlg);
            }
            if (responseData.AlgCooGeo != undefined) {
                loaded.AlgCooGeo(responseData.AlgCooGeo);
            }
            if (responseData.PlaneGeoTrig != undefined) {
                loaded.PlaneGeoTrig(responseData.PlaneGeoTrig);
            }
            if (responseData.SocStuSci != undefined) {
                loaded.SocStuSci(responseData.SocStuSci);
            }
            if (responseData.ArtLit != undefined) {
                loaded.ArtLit(responseData.ArtLit);
            }
            if (responseData.UseForPlacement != undefined) {
                loaded.UseForPlacement(responseData.UseForPlacement);
            }
            if (responseData.SourceID != undefined) {
                loaded.SourceID(responseData.SourceID);
            }
            if (responseData.DataStepID != undefined) {
                loaded.DataStepID(responseData.DataStepID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.DataStep != null) {
                loaded.DataStep(new smapi.admissions.ACTStepModel().LoadFromResponse(responseData.DataStep));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.ACT', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TestDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.Math.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.English.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Reading.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Science.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Composite.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.UsageMech.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RhetSkills.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PreAlgEleAlg.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AlgCooGeo.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PlaneGeoTrig.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SocStuSci.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ArtLit.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.UseForPlacement.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.SourceID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DataStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ACTStepModel(options) {
        var defaults = {
            ClassType: 0,
            Comments: '',
            AdmissionsAttemptID: 0,
            ProcessStageID: null,
            ParentStepID: null,
            StatusID: 0,
            RequiredOptionID: null,
            StepStartDate: null,
            StepEndDate: null,
            NavigatorScreenPath: '',
            ExpectedStepEndDate: null,
            AdHoc: false,
            ProgressOveridden: false,
            ExternalStage: false,
            MinExternalData: 0,
            MaxExternalData: 0,
            DueDate: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.Comments = ko.validatedObservable(settings.Comments);
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.ProcessStageID = ko.validatedObservable(settings.ProcessStageID);
        this.ParentStepID = ko.validatedObservable(settings.ParentStepID);
        this.StatusID = ko.validatedObservable(settings.StatusID);
        this.RequiredOptionID = ko.validatedObservable(settings.RequiredOptionID);
        this.StepStartDate = ko.validatedObservable(settings.StepStartDate);
        this.StepEndDate = ko.validatedObservable(settings.StepEndDate);
        this.NavigatorScreenPath = ko.validatedObservable(settings.NavigatorScreenPath);
        this.ExpectedStepEndDate = ko.validatedObservable(settings.ExpectedStepEndDate);
        this.AdHoc = ko.validatedObservable(settings.AdHoc);
        this.ProgressOveridden = ko.validatedObservable(settings.ProgressOveridden);
        this.ExternalStage = ko.validatedObservable(settings.ExternalStage);
        this.MinExternalData = ko.validatedObservable(settings.MinExternalData);
        this.MaxExternalData = ko.validatedObservable(settings.MaxExternalData);
        this.DueDate = ko.validatedObservable(settings.DueDate);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.ACTTestScores = ko.observableArray([]);
        this.AdmissionsAttempt = ko.observable();
        this.ProcessStage = ko.observable();
        this.ReviewerComments = ko.observableArray([]);
        this.ExternalData = ko.observableArray([]);
        this.Parent = ko.observable();
        this.ChildSteps = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.Comments != undefined) {
                loaded.Comments(responseData.Comments);
            }
            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.ProcessStageID != undefined) {
                loaded.ProcessStageID(responseData.ProcessStageID);
            }
            if (responseData.ParentStepID != undefined) {
                loaded.ParentStepID(responseData.ParentStepID);
            }
            if (responseData.StatusID != undefined) {
                loaded.StatusID(responseData.StatusID);
            }
            if (responseData.RequiredOptionID != undefined) {
                loaded.RequiredOptionID(responseData.RequiredOptionID);
            }
            if (responseData.StepStartDate != undefined) {
                loaded.StepStartDate(responseData.StepStartDate);
            }
            if (responseData.StepEndDate != undefined) {
                loaded.StepEndDate(responseData.StepEndDate);
            }
            if (responseData.NavigatorScreenPath != undefined) {
                loaded.NavigatorScreenPath(responseData.NavigatorScreenPath);
            }
            if (responseData.ExpectedStepEndDate != undefined) {
                loaded.ExpectedStepEndDate(responseData.ExpectedStepEndDate);
            }
            if (responseData.AdHoc != undefined) {
                loaded.AdHoc(responseData.AdHoc);
            }
            if (responseData.ProgressOveridden != undefined) {
                loaded.ProgressOveridden(responseData.ProgressOveridden);
            }
            if (responseData.ExternalStage != undefined) {
                loaded.ExternalStage(responseData.ExternalStage);
            }
            if (responseData.MinExternalData != undefined) {
                loaded.MinExternalData(responseData.MinExternalData);
            }
            if (responseData.MaxExternalData != undefined) {
                loaded.MaxExternalData(responseData.MaxExternalData);
            }
            if (responseData.DueDate != undefined) {
                loaded.DueDate(responseData.DueDate);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.ACTTestScores != null && responseData.ACTTestScores.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ACTTestScores.length; i++) {
                    items.push(new smapi.admissions.ACTModel().LoadFromResponse(responseData.ACTTestScores[i]));
                }
                loaded.ACTTestScores(items);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }
            if (responseData.ProcessStage != null) {
                loaded.ProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.ProcessStage));
            }
            if (responseData.ReviewerComments != null && responseData.ReviewerComments.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ReviewerComments.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationCommentModel().LoadFromResponse(responseData.ReviewerComments[i]));
                }
                loaded.ReviewerComments(items);
            }
            if (responseData.ExternalData != null && responseData.ExternalData.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ExternalData.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepDataModel().LoadFromResponse(responseData.ExternalData[i]));
                }
                loaded.ExternalData(items);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.ChildSteps != null && responseData.ChildSteps.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ChildSteps.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.ChildSteps[i]));
                }
                loaded.ChildSteps(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.ACTStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Comments.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProcessStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RequiredOptionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StepStartDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.StepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.NavigatorScreenPath.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ExpectedStepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AdHoc.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ExternalStage.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.MinExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MaxExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DueDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsAcademicLevelModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            AcademicLevelID: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.AcademicLevelID = ko.validatedObservable(settings.AcademicLevelID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AcademicLevel = ko.observable();
        this.AvailableGoals = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.AcademicLevelID != undefined) {
                loaded.AcademicLevelID(responseData.AcademicLevelID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AcademicLevel != null) {
                loaded.AcademicLevel(new smapi.academic.AcademicLevelModel().LoadFromResponse(responseData.AcademicLevel));
            }
            if (responseData.AvailableGoals != null && responseData.AvailableGoals.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.AvailableGoals.length; i++) {
                    items.push(new smapi.admissions.AdmissionsEducationalGoalModel().LoadFromResponse(responseData.AvailableGoals[i]));
                }
                loaded.AvailableGoals(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsAcademicLevel', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.AcademicLevelID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsApplicationRankModel(options) {
        var defaults = {
            Score: 0,
            StudentRank: 0,
            IsStudentRankEnforced: false,
            ApplicationEvaluationID: 0,
            AdmissionsRankingListID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Score = ko.validatedObservable(settings.Score);
        this.StudentRank = ko.validatedObservable(settings.StudentRank);
        this.IsStudentRankEnforced = ko.validatedObservable(settings.IsStudentRankEnforced);
        this.ApplicationEvaluationID = ko.validatedObservable(settings.ApplicationEvaluationID);
        this.AdmissionsRankingListID = ko.validatedObservable(settings.AdmissionsRankingListID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.ApplicationEvaluation = ko.observable();
        this.AdmissionsRankingList = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Score != undefined) {
                loaded.Score(responseData.Score);
            }
            if (responseData.StudentRank != undefined) {
                loaded.StudentRank(responseData.StudentRank);
            }
            if (responseData.IsStudentRankEnforced != undefined) {
                loaded.IsStudentRankEnforced(responseData.IsStudentRankEnforced);
            }
            if (responseData.ApplicationEvaluationID != undefined) {
                loaded.ApplicationEvaluationID(responseData.ApplicationEvaluationID);
            }
            if (responseData.AdmissionsRankingListID != undefined) {
                loaded.AdmissionsRankingListID(responseData.AdmissionsRankingListID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.ApplicationEvaluation != null) {
                loaded.ApplicationEvaluation(new smapi.admissions.ApplicationEvaluationModel().LoadFromResponse(responseData.ApplicationEvaluation));
            }
            if (responseData.AdmissionsRankingList != null) {
                loaded.AdmissionsRankingList(new smapi.admissions.AdmissionsRankingListModel().LoadFromResponse(responseData.AdmissionsRankingList));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsApplicationRank', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Score.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StudentRank.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.IsStudentRankEnforced.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ApplicationEvaluationID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionsRankingListID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsAttemptModel(options) {
        var defaults = {
            PersonID: 0,
            AdmissionsStageID: null,
            AdmissionsAcademicLevelID: null,
            AdmissionsTypeID: null,
			ExpectedEntrancePeriodID: null,
			ExpectedStartPeriodID: null,
            EarliestStartDate: null,
            HierarchyNodeID: 0,
            ReviewingHierarchyNodeID: 0,
            AdmissionsSourceID: null,
            ExpectedLoadID: null,
            EnrollmentStatusID: null,
            RecruiterID: null,
            AdmissionsCounselorID: null,
            AttendanceTypeID: null,
            AttendanceReasonID: null,
            EverAttended: false,
            IsMatriculated: false,
            Transfer: false,
            TransferWithinCountry: false,
            EverSuspendedDismissed: false,
            CampusID: null,
            CarPool: false,
            BypassCommunicationPlan: false,
            SurveyQuestion: false,
            Referrer: '',
            BrowserInfo: '',
            AllowCounselorRule: true,
            AllowRecruiterRule: true,
            Surname: '',
            GivenName: '',
            MiddleName: '',
            NumericalRank: 0,
            PreferredCommunicationTypeID: null,
            CompletionDate: null,
            StudentCategoryID: null,
            DeliveryMethodID: null,
            LevelOfStudyID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
            HeardAboutInstituteFrom: '',
            InstituteCoursesPreviouslyTaken: '',
            InstituteRelationship: false,
            InstituteRelationshipName: '',
            InstituteRelationshipDescription: '',
            InterviewViaSkype: false,
            InterviewViaPhone: false,
            InterviewInPerson: false
        };
        var ukFeatureEnabled = sm.portal.utility.isUKFeatureEnabled();
        var euFeatureEnabled = sm.portal.utility.isEUFeatureEnabled();
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.AdmissionsStageID = ko.validatedObservable(settings.AdmissionsStageID);
        this.AdmissionsAcademicLevelID = ko.validatedObservable(settings.AdmissionsAcademicLevelID);
        this.AdmissionsTypeID = ko.validatedObservable(settings.AdmissionsTypeID);
		this.ExpectedEntrancePeriodID = ko.validatedObservable(settings.ExpectedEntrancePeriodID);
		this.ExpectedStartPeriodID = ko.validatedObservable(settings.ExpectedStartPeriodID);
        this.EarliestStartDate = ko.validatedObservable(settings.EarliestStartDate);
        this.HierarchyNodeID = ko.validatedObservable(settings.HierarchyNodeID);
        this.ReviewingHierarchyNodeID = ko.validatedObservable(settings.ReviewingHierarchyNodeID);
        this.AdmissionsSourceID = ko.validatedObservable(settings.AdmissionsSourceID);
        this.ExpectedLoadID = ko.validatedObservable(settings.ExpectedLoadID);
        this.EnrollmentStatusID = ko.validatedObservable(settings.EnrollmentStatusID);
        this.RecruiterID = ko.validatedObservable(settings.RecruiterID);
        this.AdmissionsCounselorID = ko.validatedObservable(settings.AdmissionsCounselorID);
        this.AttendanceTypeID = ko.validatedObservable(settings.AttendanceTypeID);
        this.AttendanceReasonID = ko.validatedObservable(settings.AttendanceReasonID);
        this.EverAttended = ko.validatedObservable(settings.EverAttended);
        this.Transfer = ko.validatedObservable(settings.Transfer);
        this.IsMatriculated = ko.validatedObservable(settings.IsMatriculated);
        this.TransferWithinCountry = ko.validatedObservable(settings.TransferWithinCountry);
        this.EverSuspendedDismissed = ko.validatedObservable(settings.EverSuspendedDismissed);
        this.CampusID = ko.validatedObservable(settings.CampusID);
        this.CarPool = ko.validatedObservable(settings.CarPool);
        this.BypassCommunicationPlan = ko.validatedObservable(settings.BypassCommunicationPlan);
        this.SurveyQuestion = ko.validatedObservable(settings.SurveyQuestion);
        this.Referrer = ko.validatedObservable(settings.Referrer);
        this.BrowserInfo = ko.validatedObservable(settings.BrowserInfo);
        this.AllowCounselorRule = ko.validatedObservable(settings.AllowCounselorRule);
        this.AllowRecruiterRule = ko.validatedObservable(settings.AllowRecruiterRule);
        this.Surname = ko.validatedObservable(settings.Surname);
        this.GivenName = ko.validatedObservable(settings.GivenName);
        this.MiddleName = ko.validatedObservable(settings.MiddleName);
        this.NumericalRank = ko.validatedObservable(settings.NumericalRank);
        this.PreferredCommunicationTypeID = ko.validatedObservable(settings.PreferredCommunicationTypeID);
        this.CompletionDate = ko.validatedObservable(settings.CompletionDate);
        this.StudentCategoryID = ko.validatedObservable(settings.StudentCategoryID);
        this.DeliveryMethodID = ko.validatedObservable(settings.DeliveryMethodID);
        this.LevelOfStudyID = ko.validatedObservable(settings.LevelOfStudyID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AdmissionsStage = ko.observable();
        this.Person = ko.observable();
        this.AdmissionsAcademicLevel = ko.observable();
        this.AdmissionsType = ko.observable();
        this.Recruiter = ko.observable();
        this.AdmissionsCounselor = ko.observable();
        this.AdmissionsAttemptPrograms = ko.observableArray([]);
        this.Milestones = ko.observableArray([]);
        this.Steps = ko.observableArray([]);
        this.Campus = ko.observable();
        this.PeriodTypes = ko.observableArray([]);
        this.DeliveryMethod = ko.observable();
        this.DocumentRepository = ko.observableArray([]);
        this.PreferredCommunicationType = ko.observable();
        this.StudentCategory = ko.observable();
        this.LevelOfStudy = ko.observable();
        this.ExpectedEntrancePeriod = ko.observable();
		this.ExpectedStartPeriod = ko.observable();

        if(euFeatureEnabled){
            this.AdmissionsAttemptEUAdditionalInfo = ko.observableArray([]);
        }
        if(ukFeatureEnabled)
        {
            this.AdmissionsAttemptUKAdditionalInfo = ko.observableArray([]);
            this.AdmissionsAttemptUKPersonalStatement = ko.observableArray([]);
            this.AdmissionsSpecialisms = ko.observableArray([]);
            this.UKQualifications = ko.observableArray([]);
        }
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.AdmissionsStageID != undefined) {
                loaded.AdmissionsStageID(responseData.AdmissionsStageID);
            }
            if (responseData.AdmissionsAcademicLevelID != undefined) {
                loaded.AdmissionsAcademicLevelID(responseData.AdmissionsAcademicLevelID);
            }
            if (responseData.AdmissionsTypeID != undefined) {
                loaded.AdmissionsTypeID(responseData.AdmissionsTypeID);
            }
            if (responseData.ExpectedEntrancePeriodID != undefined) {
                loaded.ExpectedEntrancePeriodID(responseData.ExpectedEntrancePeriodID);
			}
			if (responseData.ExpectedStartPeriodID != undefined) {
				loaded.ExpectedStartPeriodID(responseData.ExpectedStartPeriodID);
			}
            if (responseData.EarliestStartDate != undefined) {
                loaded.EarliestStartDate(responseData.EarliestStartDate);
            }
            if (responseData.HierarchyNodeID != undefined) {
                loaded.HierarchyNodeID(responseData.HierarchyNodeID);
            }
            if (responseData.ReviewingHierarchyNodeID != undefined) {
                loaded.ReviewingHierarchyNodeID(responseData.ReviewingHierarchyNodeID);
            }
            if (responseData.AdmissionsSourceID != undefined) {
                loaded.AdmissionsSourceID(responseData.AdmissionsSourceID);
            }
            if (responseData.ExpectedLoadID != undefined) {
                loaded.ExpectedLoadID(responseData.ExpectedLoadID);
            }
            if (responseData.EnrollmentStatusID != undefined) {
                loaded.EnrollmentStatusID(responseData.EnrollmentStatusID);
            }
            if (responseData.RecruiterID != undefined) {
                loaded.RecruiterID(responseData.RecruiterID);
            }
            if (responseData.AdmissionsCounselorID != undefined) {
                loaded.AdmissionsCounselorID(responseData.AdmissionsCounselorID);
            }
            if (responseData.AttendanceTypeID != undefined) {
                loaded.AttendanceTypeID(responseData.AttendanceTypeID);
            }
            if (responseData.AttendanceReasonID != undefined) {
                loaded.AttendanceReasonID(responseData.AttendanceReasonID);
            }
            if (responseData.EverAttended != undefined) {
                loaded.EverAttended(responseData.EverAttended);
            }
            if (responseData.Transfer != undefined) {
                loaded.Transfer(responseData.Transfer);
            }
            if (responseData.IsMatriculated != undefined) {
                loaded.IsMatriculated(responseData.IsMatriculated);
            }
            if (responseData.TransferWithinCountry != undefined) {
                loaded.TransferWithinCountry(responseData.TransferWithinCountry);
            }
            if (responseData.EverSuspendedDismissed != undefined) {
                loaded.EverSuspendedDismissed(responseData.EverSuspendedDismissed);
            }
            if (responseData.CampusID != undefined) {
                loaded.CampusID(responseData.CampusID);
            }
            if (responseData.CarPool != undefined) {
                loaded.CarPool(responseData.CarPool);
            }
            if (responseData.BypassCommunicationPlan != undefined) {
                loaded.BypassCommunicationPlan(responseData.BypassCommunicationPlan);
            }
            if (responseData.SurveyQuestion != undefined) {
                loaded.SurveyQuestion(responseData.SurveyQuestion);
            }
            if (responseData.Referrer != undefined) {
                loaded.Referrer(responseData.Referrer);
            }
            if (responseData.BrowserInfo != undefined) {
                loaded.BrowserInfo(responseData.BrowserInfo);
            }
            if (responseData.AllowCounselorRule != undefined) {
                loaded.AllowCounselorRule(responseData.AllowCounselorRule);
            }
            if (responseData.AllowRecruiterRule != undefined) {
                loaded.AllowRecruiterRule(responseData.AllowRecruiterRule);
            }
            if (responseData.Surname != undefined) {
                loaded.Surname(responseData.Surname);
            }
            if (responseData.GivenName != undefined) {
                loaded.GivenName(responseData.GivenName);
            }
            if (responseData.MiddleName != undefined) {
                loaded.MiddleName(responseData.MiddleName);
            }
            if (responseData.NumericalRank != undefined) {
                loaded.NumericalRank(responseData.NumericalRank);
            }
            if (responseData.PreferredCommunicationTypeID != undefined) {
                loaded.PreferredCommunicationTypeID(responseData.PreferredCommunicationTypeID);
            }
            if (responseData.CompletionDate != undefined) {
                loaded.CompletionDate(responseData.CompletionDate);
            }
            if (responseData.StudentCategoryID != undefined) {
                loaded.StudentCategoryID(responseData.StudentCategoryID);
            }
            if (responseData.DeliveryMethodID != undefined) {
                loaded.DeliveryMethodID(responseData.DeliveryMethodID);
            }
            if (responseData.LevelOfStudyID != undefined) {
                loaded.LevelOfStudyID(responseData.LevelOfStudyID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AdmissionsStage != null) {
                loaded.AdmissionsStage(new smapi.admissions.AdmissionsStageModel().LoadFromResponse(responseData.AdmissionsStage));
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.AdmissionsAcademicLevel != null) {
                loaded.AdmissionsAcademicLevel(new smapi.admissions.AdmissionsAcademicLevelModel().LoadFromResponse(responseData.AdmissionsAcademicLevel));
            }
            if (responseData.AdmissionsType != null) {
                loaded.AdmissionsType(new smapi.admissions.AdmissionsTypeModel().LoadFromResponse(responseData.AdmissionsType));
            }
            if (responseData.Recruiter != null) {
                loaded.Recruiter(new smapi.faculty.StaffModel().LoadFromResponse(responseData.Recruiter));
            }
            if (responseData.AdmissionsCounselor != null) {
                loaded.AdmissionsCounselor(new smapi.faculty.StaffModel().LoadFromResponse(responseData.AdmissionsCounselor));
            }
            if (responseData.AdmissionsAttemptPrograms != null && responseData.AdmissionsAttemptPrograms.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.AdmissionsAttemptPrograms.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptProgramModel().LoadFromResponse(responseData.AdmissionsAttemptPrograms[i]));
                }
                loaded.AdmissionsAttemptPrograms(items);
            }
            if (responseData.Milestones != null && responseData.Milestones.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Milestones.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptMilestoneModel().LoadFromResponse(responseData.Milestones[i]));
                }
                loaded.Milestones(items);
            }
            if (responseData.Steps != null && responseData.Steps.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Steps.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.Steps[i]));
                }
                loaded.Steps(items);
            }
            if (responseData.Campus != null) {
                loaded.Campus(new smapi.facility.CampusModel().LoadFromResponse(responseData.Campus));
            }
            if (responseData.PeriodTypes != null && responseData.PeriodTypes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.PeriodTypes.length; i++) {
                    items.push(new smapi.academic.AcademicPeriodTypeModel().LoadFromResponse(responseData.PeriodTypes[i]));
                }
                loaded.PeriodTypes(items);
            }
            if (responseData.DeliveryMethod != null) {
                loaded.DeliveryMethod(new smapi.academic.AcademicDeliveryMethodModel().LoadFromResponse(responseData.DeliveryMethod));
            }
            if (responseData.DocumentRepository != null && responseData.DocumentRepository.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.DocumentRepository.length; i++) {
                    items.push(new smapi.community.DocumentRepositoryModel().LoadFromResponse(responseData.DocumentRepository[i]));
                }
                loaded.DocumentRepository(items);
            }
            if (responseData.PreferredCommunicationType != null) {
                loaded.PreferredCommunicationType(new smapi.communication.CommunicationTypeModel().LoadFromResponse(responseData.PreferredCommunicationType));
            }
            if (responseData.StudentCategory != null) {
                loaded.StudentCategory(new smapi.admissions.StudentCategoryModel().LoadFromResponse(responseData.StudentCategory));
            }
            if (responseData.LevelOfStudy != null) {
                loaded.LevelOfStudy(new smapi.academic.LevelOfStudyModel().LoadFromResponse(responseData.LevelOfStudy));
            }
            if (responseData.ExpectedEntrancePeriod != null) {
                loaded.ExpectedEntrancePeriod(new smapi.admissions.AdmissionsPeriodModel().LoadFromResponse(responseData.ExpectedEntrancePeriod));
			}
			if (responseData.ExpectedStartPeriod != null) {
				loaded.ExpectedStartPeriod(new smapi.academic.AcademicPeriodModel().LoadFromResponse(responseData.ExpectedStartPeriod));
			}
            if(euFeatureEnabled && responseData.AdmissionsAttemptEUAdditionalInfo != null && responseData.AdmissionsAttemptEUAdditionalInfo.length > 0) {
                var items = new Array();
                for (var i = 0; i < responseData.AdmissionsAttemptEUAdditionalInfo.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptEUAdditionalInfoModel().LoadFromResponse(responseData.AdmissionsAttemptEUAdditionalInfo[i]));
                }
                loaded.AdmissionsAttemptEUAdditionalInfo(items);
            }
            if (ukFeatureEnabled && responseData.AdmissionsAttemptUKAdditionalInfo != null && responseData.AdmissionsAttemptUKAdditionalInfo.length > 0) {
                var items = new Array();
                for (var i = 0; i < responseData.AdmissionsAttemptUKAdditionalInfo.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptUKAdditionalInfoModel().LoadFromResponse(responseData.AdmissionsAttemptUKAdditionalInfo[i]));
                }
                loaded.AdmissionsAttemptUKAdditionalInfo(items);
            }
            if (ukFeatureEnabled && responseData.AdmissionsAttemptUKPersonalStatement != null && responseData.AdmissionsAttemptUKPersonalStatement.length > 0) {
                var items = new Array();
                for (var i = 0; i < responseData.AdmissionsAttemptUKPersonalStatement.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptUKPersonalStatementModel().LoadFromResponse(responseData.AdmissionsAttemptUKPersonalStatement[i]));
                }
                loaded.AdmissionsAttemptUKPersonalStatement(items);
            }
            if (ukFeatureEnabled && responseData.AdmissionsSpecialisms != null && responseData.AdmissionsSpecialisms.length > 0) {
                var items = new Array();
                for (var i = 0; i < responseData.AdmissionsSpecialisms.length; i++) {
                    items.push(new smapi.admissions.AdmissionsSpecialismsModel().LoadFromResponse(responseData.AdmissionsSpecialisms[i]));
                }
                loaded.AdmissionsSpecialisms(items);
            }

            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsAttempt', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionsStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionsAcademicLevelID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionsTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ExpectedEntrancePeriodID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
		});
		this.ExpectedStartPeriodID.extend({
			min: {
				params: -9223372036854775808,
				message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
			},
			max: {
				params: 9223372036854775807,
				message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
			},
			number: {
				message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
			}
		});
        this.EarliestStartDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.HierarchyNodeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ReviewingHierarchyNodeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionsSourceID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ExpectedLoadID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EnrollmentStatusID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RecruiterID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionsCounselorID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AttendanceTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AttendanceReasonID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EverAttended.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.Transfer.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.TransferWithinCountry.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.EverSuspendedDismissed.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.CampusID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CarPool.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.BypassCommunicationPlan.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.Referrer.extend({
            maxLength: {
                params: 2048,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '2048')
            }
        });
        this.BrowserInfo.extend({
            maxLength: {
                params: 2048,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '2048')
            }
        });
        this.AllowCounselorRule.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.AllowRecruiterRule.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.Surname.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.GivenName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.MiddleName.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.NumericalRank.extend({
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PreferredCommunicationTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CompletionDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.StudentCategoryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DeliveryMethodID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.LevelOfStudyID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsAttemptInteractionModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            Priority: 0,
            AdmissionsStageID: null,
            AdmissionsTypeID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.Priority = ko.validatedObservable(settings.Priority);
        this.AdmissionsStageID = ko.validatedObservable(settings.AdmissionsStageID);
        this.AdmissionsTypeID = ko.validatedObservable(settings.AdmissionsTypeID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AdmissionsStage = ko.observable();
        this.AdmissionsType = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.Priority != undefined) {
                loaded.Priority(responseData.Priority);
            }
            if (responseData.AdmissionsStageID != undefined) {
                loaded.AdmissionsStageID(responseData.AdmissionsStageID);
            }
            if (responseData.AdmissionsTypeID != undefined) {
                loaded.AdmissionsTypeID(responseData.AdmissionsTypeID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AdmissionsStage != null) {
                loaded.AdmissionsStage(new smapi.admissions.AdmissionsStageModel().LoadFromResponse(responseData.AdmissionsStage));
            }
            if (responseData.AdmissionsType != null) {
                loaded.AdmissionsType(new smapi.admissions.AdmissionsTypeModel().LoadFromResponse(responseData.AdmissionsType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsAttemptInteraction', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 250,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '250')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 250,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '250')
            }
        });
        this.Priority.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionsStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionsTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsAttemptMilestoneModel(options) {
        var defaults = {
            AdmissionsAttemptID: 0,
            AdmissionsStageID: null,
            DateOfMilestone: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.AdmissionsStageID = ko.validatedObservable(settings.AdmissionsStageID);
        this.DateOfMilestone = ko.validatedObservable(settings.DateOfMilestone);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AdmissionsAttempt = ko.observable();
        this.AdmissionsStage = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.AdmissionsStageID != undefined) {
                loaded.AdmissionsStageID(responseData.AdmissionsStageID);
            }
            if (responseData.DateOfMilestone != undefined) {
                loaded.DateOfMilestone(responseData.DateOfMilestone);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }
            if (responseData.AdmissionsStage != null) {
                loaded.AdmissionsStage(new smapi.admissions.AdmissionsStageModel().LoadFromResponse(responseData.AdmissionsStage));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsAttemptMilestone', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionsStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DateOfMilestone.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsAttemptProgramModel(options) {
        var defaults = {
            Preference: 0,
            AdmissionsAttemptID: 0,
            AdmissionsAcademicLevelID: null,
            ApplicationGoalID: null,
            AdmissionProgramID: null,
            AdmissionsProgramOfferingItemID: null,
            ProgramCategoryID: null,
            AdmissionsCohortID: null,
            AdmissionsConcentrationID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
            FlexiFieldValues: null
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Preference = ko.validatedObservable(settings.Preference);
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.AdmissionsAcademicLevelID = ko.validatedObservable(settings.AdmissionsAcademicLevelID);
        this.ApplicationGoalID = ko.validatedObservable(settings.ApplicationGoalID);
        this.AdmissionProgramID = ko.validatedObservable(settings.AdmissionProgramID);
        this.AdmissionsProgramOfferingItemID = ko.validatedObservable(settings.AdmissionsProgramOfferingItemID);
        this.ProgramCategoryID = ko.validatedObservable(settings.ProgramCategoryID);
        this.AdmissionsCohortID = ko.validatedObservable(settings.AdmissionsCohortID);
        this.AdmissionsConcentrationID = ko.validatedObservable(settings.AdmissionsConcentrationID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        this.FlexiFieldValues = ko.validatedObservable(settings.FlexiFieldValues);
        
        // Relationships as Observables and ObservableArrays
        this.AdmissionsAttempt = ko.observable();
        this.AdmissionsProgramOfferingItem = ko.observable();
        this.AcademicLevel = ko.observable();
        this.AdmissionProgram = ko.observable();
        this.ApplicationGoal = ko.observable();
        this.AdmissionsCohort = ko.observable();
        this.AdmissionsConcentration = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Preference != undefined) {
                loaded.Preference(responseData.Preference);
            }
            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.AdmissionsAcademicLevelID != undefined) {
                loaded.AdmissionsAcademicLevelID(responseData.AdmissionsAcademicLevelID);
            }
            if (responseData.ApplicationGoalID != undefined) {
                loaded.ApplicationGoalID(responseData.ApplicationGoalID);
            }
            if (responseData.AdmissionProgramID != undefined) {
                loaded.AdmissionProgramID(responseData.AdmissionProgramID);
            }
            if (responseData.AdmissionsProgramOfferingItemID != undefined) {
                loaded.AdmissionsProgramOfferingItemID(responseData.AdmissionsProgramOfferingItemID);
            }
            if (responseData.ProgramCategoryID != undefined) {
                loaded.ProgramCategoryID(responseData.ProgramCategoryID);
            }
            if (responseData.AdmissionsCohortID != undefined) {
                loaded.AdmissionsCohortID(responseData.AdmissionsCohortID);
            }
            if (responseData.AdmissionsConcentrationID != undefined) {
                loaded.AdmissionsConcentrationID(responseData.AdmissionsConcentrationID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }
            if (responseData.AdmissionsProgramOfferingItem != null) {
                loaded.AdmissionsProgramOfferingItem(new smapi.admissions.AdmissionsProgramOfferingItemModel().LoadFromResponse(responseData.AdmissionsProgramOfferingItem));
            }
            if (responseData.AcademicLevel != null) {
                loaded.AcademicLevel(new smapi.admissions.AdmissionsAcademicLevelModel().LoadFromResponse(responseData.AcademicLevel));
            }
            if (responseData.AdmissionProgram != null) {
                loaded.AdmissionProgram(new smapi.admissions.AdmissionsProgramModel().LoadFromResponse(responseData.AdmissionProgram));
            }
            if (responseData.ApplicationGoal != null) {
                loaded.ApplicationGoal(new smapi.admissions.AdmissionsEducationalGoalModel().LoadFromResponse(responseData.ApplicationGoal));
            }
            if (responseData.AdmissionsCohort != null) {
                loaded.AdmissionsCohort(new smapi.admissions.AdmissionsCohortModel().LoadFromResponse(responseData.AdmissionsCohort));
            }
            if (responseData.AdmissionsConcentration != null) {
                loaded.AdmissionsConcentration(new smapi.admissions.AdmissionsConcentrationModel().LoadFromResponse(responseData.AdmissionsConcentration));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsAttemptProgram', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Preference.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionsAcademicLevelID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ApplicationGoalID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionProgramID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionsProgramOfferingItemID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProgramCategoryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionsCohortID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionsConcentrationID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsAttemptStepModel(options) {
        var defaults = {
            ClassType: 0,
            Comments: '',
            AdmissionsAttemptID: 0,
            ProcessStageID: null,
            ParentStepID: null,
            StatusID: 0,
            RequiredOptionID: null,
            StepStartDate: null,
            StepEndDate: null,
            NavigatorScreenPath: '',
            ExpectedStepEndDate: null,
            AdHoc: false,
            ProgressOveridden: false,
            ExternalStage: false,
            MinExternalData: 0,
            MaxExternalData: 0,
            DueDate: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.Comments = ko.validatedObservable(settings.Comments);
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.ProcessStageID = ko.validatedObservable(settings.ProcessStageID);
        this.ParentStepID = ko.validatedObservable(settings.ParentStepID);
        this.StatusID = ko.validatedObservable(settings.StatusID);
        this.RequiredOptionID = ko.validatedObservable(settings.RequiredOptionID);
        this.StepStartDate = ko.validatedObservable(settings.StepStartDate);
        this.StepEndDate = ko.validatedObservable(settings.StepEndDate);
        this.NavigatorScreenPath = ko.validatedObservable(settings.NavigatorScreenPath);
        this.ExpectedStepEndDate = ko.validatedObservable(settings.ExpectedStepEndDate);
        this.AdHoc = ko.validatedObservable(settings.AdHoc);
        this.ProgressOveridden = ko.validatedObservable(settings.ProgressOveridden);
        this.ExternalStage = ko.validatedObservable(settings.ExternalStage);
        this.MinExternalData = ko.validatedObservable(settings.MinExternalData);
        this.MaxExternalData = ko.validatedObservable(settings.MaxExternalData);
        this.DueDate = ko.validatedObservable(settings.DueDate);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AdmissionsAttempt = ko.observable();
        this.ProcessStage = ko.observable();
        this.ReviewerComments = ko.observableArray([]);
        this.ExternalData = ko.observableArray([]);
        this.Parent = ko.observable();
        this.ChildSteps = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.Comments != undefined) {
                loaded.Comments(responseData.Comments);
            }
            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.ProcessStageID != undefined) {
                loaded.ProcessStageID(responseData.ProcessStageID);
            }
            if (responseData.ParentStepID != undefined) {
                loaded.ParentStepID(responseData.ParentStepID);
            }
            if (responseData.StatusID != undefined) {
                loaded.StatusID(responseData.StatusID);
            }
            if (responseData.RequiredOptionID != undefined) {
                loaded.RequiredOptionID(responseData.RequiredOptionID);
            }
            if (responseData.StepStartDate != undefined) {
                loaded.StepStartDate(responseData.StepStartDate);
            }
            if (responseData.StepEndDate != undefined) {
                loaded.StepEndDate(responseData.StepEndDate);
            }
            if (responseData.NavigatorScreenPath != undefined) {
                loaded.NavigatorScreenPath(responseData.NavigatorScreenPath);
            }
            if (responseData.ExpectedStepEndDate != undefined) {
                loaded.ExpectedStepEndDate(responseData.ExpectedStepEndDate);
            }
            if (responseData.AdHoc != undefined) {
                loaded.AdHoc(responseData.AdHoc);
            }
            if (responseData.ProgressOveridden != undefined) {
                loaded.ProgressOveridden(responseData.ProgressOveridden);
            }
            if (responseData.ExternalStage != undefined) {
                loaded.ExternalStage(responseData.ExternalStage);
            }
            if (responseData.MinExternalData != undefined) {
                loaded.MinExternalData(responseData.MinExternalData);
            }
            if (responseData.MaxExternalData != undefined) {
                loaded.MaxExternalData(responseData.MaxExternalData);
            }
            if (responseData.DueDate != undefined) {
                loaded.DueDate(responseData.DueDate);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }
            if (responseData.ProcessStage != null) {
                loaded.ProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.ProcessStage));
            }
            if (responseData.ReviewerComments != null && responseData.ReviewerComments.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ReviewerComments.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationCommentModel().LoadFromResponse(responseData.ReviewerComments[i]));
                }
                loaded.ReviewerComments(items);
            }
            if (responseData.ExternalData != null && responseData.ExternalData.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ExternalData.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepDataModel().LoadFromResponse(responseData.ExternalData[i]));
                }
                loaded.ExternalData(items);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.ChildSteps != null && responseData.ChildSteps.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ChildSteps.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.ChildSteps[i]));
                }
                loaded.ChildSteps(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsAttemptStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Comments.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProcessStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RequiredOptionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StepStartDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.StepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.NavigatorScreenPath.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ExpectedStepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AdHoc.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ExternalStage.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.MinExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MaxExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DueDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsAttemptStepDataModel(options) {
        var defaults = {
            AdmissionsAttemptStepID: 0,
            ExternalDataGID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.AdmissionsAttemptStepID = ko.validatedObservable(settings.AdmissionsAttemptStepID);
        this.ExternalDataGID = ko.validatedObservable(settings.ExternalDataGID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AdmissionsAttemptStep = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.AdmissionsAttemptStepID != undefined) {
                loaded.AdmissionsAttemptStepID(responseData.AdmissionsAttemptStepID);
            }
            if (responseData.ExternalDataGID != undefined) {
                loaded.ExternalDataGID(responseData.ExternalDataGID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AdmissionsAttemptStep != null) {
                loaded.AdmissionsAttemptStep(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.AdmissionsAttemptStep));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsAttemptStepData', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.AdmissionsAttemptStepID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ExternalDataGID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsCohortModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            AcademicLevelID: null,
            AcademicGoalID: null,
            ProgramID: null,
            ConcentrationID: null,
            ProgramCategoryID: null,
            CampusID: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.AcademicLevelID = ko.validatedObservable(settings.AcademicLevelID);
        this.AcademicGoalID = ko.validatedObservable(settings.AcademicGoalID);
        this.ProgramID = ko.validatedObservable(settings.ProgramID);
        this.ConcentrationID = ko.validatedObservable(settings.ConcentrationID);
        this.ProgramCategoryID = ko.validatedObservable(settings.ProgramCategoryID);
        this.CampusID = ko.validatedObservable(settings.CampusID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Levels = ko.observable();
        this.Goals = ko.observable();
        this.Programs = ko.observable();
        this.Concentrations = ko.observable();
        this.Campus = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.AcademicLevelID != undefined) {
                loaded.AcademicLevelID(responseData.AcademicLevelID);
            }
            if (responseData.AcademicGoalID != undefined) {
                loaded.AcademicGoalID(responseData.AcademicGoalID);
            }
            if (responseData.ProgramID != undefined) {
                loaded.ProgramID(responseData.ProgramID);
            }
            if (responseData.ConcentrationID != undefined) {
                loaded.ConcentrationID(responseData.ConcentrationID);
            }
            if (responseData.ProgramCategoryID != undefined) {
                loaded.ProgramCategoryID(responseData.ProgramCategoryID);
            }
            if (responseData.CampusID != undefined) {
                loaded.CampusID(responseData.CampusID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Levels != null) {
                loaded.Levels(new smapi.admissions.AdmissionsAcademicLevelModel().LoadFromResponse(responseData.Levels));
            }
            if (responseData.Goals != null) {
                loaded.Goals(new smapi.admissions.AdmissionsEducationalGoalModel().LoadFromResponse(responseData.Goals));
            }
            if (responseData.Programs != null) {
                loaded.Programs(new smapi.admissions.AdmissionsProgramModel().LoadFromResponse(responseData.Programs));
            }
            if (responseData.Concentrations != null) {
                loaded.Concentrations(new smapi.admissions.AdmissionsConcentrationModel().LoadFromResponse(responseData.Concentrations));
            }
            if (responseData.Campus != null) {
                loaded.Campus(new smapi.facility.CampusModel().LoadFromResponse(responseData.Campus));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsCohort', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.AcademicLevelID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AcademicGoalID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProgramID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ConcentrationID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProgramCategoryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CampusID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsConcentrationModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            ProgramID: null,
            AcademicGoalID: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.ProgramID = ko.validatedObservable(settings.ProgramID);
        this.AcademicGoalID = ko.validatedObservable(settings.AcademicGoalID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Programs = ko.observable();
        this.Goals = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.ProgramID != undefined) {
                loaded.ProgramID(responseData.ProgramID);
            }
            if (responseData.AcademicGoalID != undefined) {
                loaded.AcademicGoalID(responseData.AcademicGoalID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Programs != null) {
                loaded.Programs(new smapi.admissions.AdmissionsProgramModel().LoadFromResponse(responseData.Programs));
            }
            if (responseData.Goals != null) {
                loaded.Goals(new smapi.admissions.AdmissionsEducationalGoalModel().LoadFromResponse(responseData.Goals));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsConcentration', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ProgramID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AcademicGoalID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsDocumentModel(options) {
        var defaults = {
            ClassType: 0,
            PersonID: 0,
            DocumentID: null,
            DocumentStatusID: null,
            CompletionDate: null,
            Comment: '',
            Reference: '',
            SourceID: null,
            DataStepID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.DocumentID = ko.validatedObservable(settings.DocumentID);
        this.DocumentStatusID = ko.validatedObservable(settings.DocumentStatusID);
        this.CompletionDate = ko.validatedObservable(settings.CompletionDate);
        this.Comment = ko.validatedObservable(settings.Comment);
        this.Reference = ko.validatedObservable(settings.Reference);
        this.SourceID = ko.validatedObservable(settings.SourceID);
        this.DataStepID = ko.validatedObservable(settings.DataStepID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.Document = ko.observable();
        this.DataStep = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.DocumentID != undefined) {
                loaded.DocumentID(responseData.DocumentID);
            }
            if (responseData.DocumentStatusID != undefined) {
                loaded.DocumentStatusID(responseData.DocumentStatusID);
            }
            if (responseData.CompletionDate != undefined) {
                loaded.CompletionDate(responseData.CompletionDate);
            }
            if (responseData.Comment != undefined) {
                loaded.Comment(responseData.Comment);
            }
            if (responseData.Reference != undefined) {
                loaded.Reference(responseData.Reference);
            }
            if (responseData.SourceID != undefined) {
                loaded.SourceID(responseData.SourceID);
            }
            if (responseData.DataStepID != undefined) {
                loaded.DataStepID(responseData.DataStepID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.Document != null) {
                loaded.Document(new smapi.community.DocumentModel().LoadFromResponse(responseData.Document));
            }
            if (responseData.DataStep != null) {
                loaded.DataStep(new smapi.admissions.AdmissionsDocumentStepModel().LoadFromResponse(responseData.DataStep));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsDocument', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DocumentID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DocumentStatusID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CompletionDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.Comment.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.Reference.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.SourceID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DataStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsDocumentStepModel(options) {
        var defaults = {
            ClassType: 0,
            Comments: '',
            AdmissionsAttemptID: 0,
            ProcessStageID: null,
            ParentStepID: null,
            StatusID: 0,
            RequiredOptionID: null,
            StepStartDate: null,
            StepEndDate: null,
            NavigatorScreenPath: '',
            ExpectedStepEndDate: null,
            AdHoc: false,
            ProgressOveridden: false,
            ExternalStage: false,
            MinExternalData: 0,
            MaxExternalData: 0,
            DueDate: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.Comments = ko.validatedObservable(settings.Comments);
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.ProcessStageID = ko.validatedObservable(settings.ProcessStageID);
        this.ParentStepID = ko.validatedObservable(settings.ParentStepID);
        this.StatusID = ko.validatedObservable(settings.StatusID);
        this.RequiredOptionID = ko.validatedObservable(settings.RequiredOptionID);
        this.StepStartDate = ko.validatedObservable(settings.StepStartDate);
        this.StepEndDate = ko.validatedObservable(settings.StepEndDate);
        this.NavigatorScreenPath = ko.validatedObservable(settings.NavigatorScreenPath);
        this.ExpectedStepEndDate = ko.validatedObservable(settings.ExpectedStepEndDate);
        this.AdHoc = ko.validatedObservable(settings.AdHoc);
        this.ProgressOveridden = ko.validatedObservable(settings.ProgressOveridden);
        this.ExternalStage = ko.validatedObservable(settings.ExternalStage);
        this.MinExternalData = ko.validatedObservable(settings.MinExternalData);
        this.MaxExternalData = ko.validatedObservable(settings.MaxExternalData);
        this.DueDate = ko.validatedObservable(settings.DueDate);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AdmissionsDocuments = ko.observableArray([]);
        this.AdmissionsAttempt = ko.observable();
        this.ProcessStage = ko.observable();
        this.ReviewerComments = ko.observableArray([]);
        this.ExternalData = ko.observableArray([]);
        this.Parent = ko.observable();
        this.ChildSteps = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.Comments != undefined) {
                loaded.Comments(responseData.Comments);
            }
            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.ProcessStageID != undefined) {
                loaded.ProcessStageID(responseData.ProcessStageID);
            }
            if (responseData.ParentStepID != undefined) {
                loaded.ParentStepID(responseData.ParentStepID);
            }
            if (responseData.StatusID != undefined) {
                loaded.StatusID(responseData.StatusID);
            }
            if (responseData.RequiredOptionID != undefined) {
                loaded.RequiredOptionID(responseData.RequiredOptionID);
            }
            if (responseData.StepStartDate != undefined) {
                loaded.StepStartDate(responseData.StepStartDate);
            }
            if (responseData.StepEndDate != undefined) {
                loaded.StepEndDate(responseData.StepEndDate);
            }
            if (responseData.NavigatorScreenPath != undefined) {
                loaded.NavigatorScreenPath(responseData.NavigatorScreenPath);
            }
            if (responseData.ExpectedStepEndDate != undefined) {
                loaded.ExpectedStepEndDate(responseData.ExpectedStepEndDate);
            }
            if (responseData.AdHoc != undefined) {
                loaded.AdHoc(responseData.AdHoc);
            }
            if (responseData.ProgressOveridden != undefined) {
                loaded.ProgressOveridden(responseData.ProgressOveridden);
            }
            if (responseData.ExternalStage != undefined) {
                loaded.ExternalStage(responseData.ExternalStage);
            }
            if (responseData.MinExternalData != undefined) {
                loaded.MinExternalData(responseData.MinExternalData);
            }
            if (responseData.MaxExternalData != undefined) {
                loaded.MaxExternalData(responseData.MaxExternalData);
            }
            if (responseData.DueDate != undefined) {
                loaded.DueDate(responseData.DueDate);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AdmissionsDocuments != null && responseData.AdmissionsDocuments.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.AdmissionsDocuments.length; i++) {
                    items.push(new smapi.admissions.AdmissionsDocumentModel().LoadFromResponse(responseData.AdmissionsDocuments[i]));
                }
                loaded.AdmissionsDocuments(items);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }
            if (responseData.ProcessStage != null) {
                loaded.ProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.ProcessStage));
            }
            if (responseData.ReviewerComments != null && responseData.ReviewerComments.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ReviewerComments.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationCommentModel().LoadFromResponse(responseData.ReviewerComments[i]));
                }
                loaded.ReviewerComments(items);
            }
            if (responseData.ExternalData != null && responseData.ExternalData.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ExternalData.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepDataModel().LoadFromResponse(responseData.ExternalData[i]));
                }
                loaded.ExternalData(items);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.ChildSteps != null && responseData.ChildSteps.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ChildSteps.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.ChildSteps[i]));
                }
                loaded.ChildSteps(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsDocumentStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Comments.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProcessStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RequiredOptionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StepStartDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.StepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.NavigatorScreenPath.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ExpectedStepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AdHoc.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ExternalStage.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.MinExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MaxExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DueDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsEducationalGoalModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            Degreed: false,
            AdmissionsAcademicLevelID: null,
            Abbreviation: '',
            SortOrder: 0,
            EducationalGoalID: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.Degreed = ko.validatedObservable(settings.Degreed);
        this.AdmissionsAcademicLevelID = ko.validatedObservable(settings.AdmissionsAcademicLevelID);
        this.Abbreviation = ko.validatedObservable(settings.Abbreviation);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.EducationalGoalID = ko.validatedObservable(settings.EducationalGoalID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.EducationalGoal = ko.observable();
        this.AdmissionsAcademicLevel = ko.observable();
        this.AdmissionsPrograms = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.Degreed != undefined) {
                loaded.Degreed(responseData.Degreed);
            }
            if (responseData.AdmissionsAcademicLevelID != undefined) {
                loaded.AdmissionsAcademicLevelID(responseData.AdmissionsAcademicLevelID);
            }
            if (responseData.Abbreviation != undefined) {
                loaded.Abbreviation(responseData.Abbreviation);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.EducationalGoalID != undefined) {
                loaded.EducationalGoalID(responseData.EducationalGoalID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.EducationalGoal != null) {
                loaded.EducationalGoal(new smapi.academic.EducationalGoalModel().LoadFromResponse(responseData.EducationalGoal));
            }
            if (responseData.AdmissionsAcademicLevel != null) {
                loaded.AdmissionsAcademicLevel(new smapi.admissions.AdmissionsAcademicLevelModel().LoadFromResponse(responseData.AdmissionsAcademicLevel));
            }
            if (responseData.AdmissionsPrograms != null && responseData.AdmissionsPrograms.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.AdmissionsPrograms.length; i++) {
                    items.push(new smapi.admissions.AdmissionsProgramModel().LoadFromResponse(responseData.AdmissionsPrograms[i]));
                }
                loaded.AdmissionsPrograms(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsEducationalGoal', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.Degreed.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.AdmissionsAcademicLevelID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Abbreviation.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EducationalGoalID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsEventTypeModel(options) {
        var defaults = {
            DataStepID: null,
            ClassType: 0,
            EventManagementID: 0,
            EventTypeDate: null,
            Note: '',
            PersonID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.DataStepID = ko.validatedObservable(settings.DataStepID);
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.EventManagementID = ko.validatedObservable(settings.EventManagementID);
        this.EventTypeDate = ko.validatedObservable(settings.EventTypeDate);
        this.Note = ko.validatedObservable(settings.Note);
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.DataStep = ko.observable();
        this.Person = ko.observable();
        this.EventManagement = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.DataStepID != undefined) {
                loaded.DataStepID(responseData.DataStepID);
            }
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.EventManagementID != undefined) {
                loaded.EventManagementID(responseData.EventManagementID);
            }
            if (responseData.EventTypeDate != undefined) {
                loaded.EventTypeDate(responseData.EventTypeDate);
            }
            if (responseData.Note != undefined) {
                loaded.Note(responseData.Note);
            }
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.DataStep != null) {
                loaded.DataStep(new smapi.admissions.AdmissionsEventTypeStepModel().LoadFromResponse(responseData.DataStep));
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.EventManagement != null) {
                loaded.EventManagement(new smapi.community.EventManagementModel().LoadFromResponse(responseData.EventManagement));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsEventType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.DataStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EventManagementID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EventTypeDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.Note.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsEventTypeStepModel(options) {
        var defaults = {
            ClassType: 0,
            Comments: '',
            AdmissionsAttemptID: 0,
            ProcessStageID: null,
            ParentStepID: null,
            StatusID: 0,
            RequiredOptionID: null,
            StepStartDate: null,
            StepEndDate: null,
            NavigatorScreenPath: '',
            ExpectedStepEndDate: null,
            AdHoc: false,
            ProgressOveridden: false,
            ExternalStage: false,
            MinExternalData: 0,
            MaxExternalData: 0,
            DueDate: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.Comments = ko.validatedObservable(settings.Comments);
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.ProcessStageID = ko.validatedObservable(settings.ProcessStageID);
        this.ParentStepID = ko.validatedObservable(settings.ParentStepID);
        this.StatusID = ko.validatedObservable(settings.StatusID);
        this.RequiredOptionID = ko.validatedObservable(settings.RequiredOptionID);
        this.StepStartDate = ko.validatedObservable(settings.StepStartDate);
        this.StepEndDate = ko.validatedObservable(settings.StepEndDate);
        this.NavigatorScreenPath = ko.validatedObservable(settings.NavigatorScreenPath);
        this.ExpectedStepEndDate = ko.validatedObservable(settings.ExpectedStepEndDate);
        this.AdHoc = ko.validatedObservable(settings.AdHoc);
        this.ProgressOveridden = ko.validatedObservable(settings.ProgressOveridden);
        this.ExternalStage = ko.validatedObservable(settings.ExternalStage);
        this.MinExternalData = ko.validatedObservable(settings.MinExternalData);
        this.MaxExternalData = ko.validatedObservable(settings.MaxExternalData);
        this.DueDate = ko.validatedObservable(settings.DueDate);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AdmissionsEventTypes = ko.observableArray([]);
        this.AdmissionsAttempt = ko.observable();
        this.ProcessStage = ko.observable();
        this.ReviewerComments = ko.observableArray([]);
        this.ExternalData = ko.observableArray([]);
        this.Parent = ko.observable();
        this.ChildSteps = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.Comments != undefined) {
                loaded.Comments(responseData.Comments);
            }
            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.ProcessStageID != undefined) {
                loaded.ProcessStageID(responseData.ProcessStageID);
            }
            if (responseData.ParentStepID != undefined) {
                loaded.ParentStepID(responseData.ParentStepID);
            }
            if (responseData.StatusID != undefined) {
                loaded.StatusID(responseData.StatusID);
            }
            if (responseData.RequiredOptionID != undefined) {
                loaded.RequiredOptionID(responseData.RequiredOptionID);
            }
            if (responseData.StepStartDate != undefined) {
                loaded.StepStartDate(responseData.StepStartDate);
            }
            if (responseData.StepEndDate != undefined) {
                loaded.StepEndDate(responseData.StepEndDate);
            }
            if (responseData.NavigatorScreenPath != undefined) {
                loaded.NavigatorScreenPath(responseData.NavigatorScreenPath);
            }
            if (responseData.ExpectedStepEndDate != undefined) {
                loaded.ExpectedStepEndDate(responseData.ExpectedStepEndDate);
            }
            if (responseData.AdHoc != undefined) {
                loaded.AdHoc(responseData.AdHoc);
            }
            if (responseData.ProgressOveridden != undefined) {
                loaded.ProgressOveridden(responseData.ProgressOveridden);
            }
            if (responseData.ExternalStage != undefined) {
                loaded.ExternalStage(responseData.ExternalStage);
            }
            if (responseData.MinExternalData != undefined) {
                loaded.MinExternalData(responseData.MinExternalData);
            }
            if (responseData.MaxExternalData != undefined) {
                loaded.MaxExternalData(responseData.MaxExternalData);
            }
            if (responseData.DueDate != undefined) {
                loaded.DueDate(responseData.DueDate);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AdmissionsEventTypes != null && responseData.AdmissionsEventTypes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.AdmissionsEventTypes.length; i++) {
                    items.push(new smapi.admissions.AdmissionsEventTypeModel().LoadFromResponse(responseData.AdmissionsEventTypes[i]));
                }
                loaded.AdmissionsEventTypes(items);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }
            if (responseData.ProcessStage != null) {
                loaded.ProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.ProcessStage));
            }
            if (responseData.ReviewerComments != null && responseData.ReviewerComments.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ReviewerComments.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationCommentModel().LoadFromResponse(responseData.ReviewerComments[i]));
                }
                loaded.ReviewerComments(items);
            }
            if (responseData.ExternalData != null && responseData.ExternalData.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ExternalData.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepDataModel().LoadFromResponse(responseData.ExternalData[i]));
                }
                loaded.ExternalData(items);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.ChildSteps != null && responseData.ChildSteps.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ChildSteps.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.ChildSteps[i]));
                }
                loaded.ChildSteps(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsEventTypeStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Comments.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProcessStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RequiredOptionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StepStartDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.StepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.NavigatorScreenPath.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ExpectedStepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AdHoc.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ExternalStage.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.MinExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MaxExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DueDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsModuleSettingsModel(options) {
        var defaults = {
            ApplicationName: '',
            SiteName: '',
            UndergradInqRuleSetBeforeWF: '',
            UndergradInqRuleSetAfterWF: '',
            UndergradInqWF: '',
            GradInqRuleSetBeforeWF: '',
            GradInqRuleSetAfterWF: '',
            GradInqWF: '',
            AdmissionsGroupName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ApplicationName = ko.validatedObservable(settings.ApplicationName);
        this.SiteName = ko.validatedObservable(settings.SiteName);
        this.UndergradInqRuleSetBeforeWF = ko.validatedObservable(settings.UndergradInqRuleSetBeforeWF);
        this.UndergradInqRuleSetAfterWF = ko.validatedObservable(settings.UndergradInqRuleSetAfterWF);
        this.UndergradInqWF = ko.validatedObservable(settings.UndergradInqWF);
        this.GradInqRuleSetBeforeWF = ko.validatedObservable(settings.GradInqRuleSetBeforeWF);
        this.GradInqRuleSetAfterWF = ko.validatedObservable(settings.GradInqRuleSetAfterWF);
        this.GradInqWF = ko.validatedObservable(settings.GradInqWF);
        this.AdmissionsGroupName = ko.validatedObservable(settings.AdmissionsGroupName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ApplicationName != undefined) {
                loaded.ApplicationName(responseData.ApplicationName);
            }
            if (responseData.SiteName != undefined) {
                loaded.SiteName(responseData.SiteName);
            }
            if (responseData.UndergradInqRuleSetBeforeWF != undefined) {
                loaded.UndergradInqRuleSetBeforeWF(responseData.UndergradInqRuleSetBeforeWF);
            }
            if (responseData.UndergradInqRuleSetAfterWF != undefined) {
                loaded.UndergradInqRuleSetAfterWF(responseData.UndergradInqRuleSetAfterWF);
            }
            if (responseData.UndergradInqWF != undefined) {
                loaded.UndergradInqWF(responseData.UndergradInqWF);
            }
            if (responseData.GradInqRuleSetBeforeWF != undefined) {
                loaded.GradInqRuleSetBeforeWF(responseData.GradInqRuleSetBeforeWF);
            }
            if (responseData.GradInqRuleSetAfterWF != undefined) {
                loaded.GradInqRuleSetAfterWF(responseData.GradInqRuleSetAfterWF);
            }
            if (responseData.GradInqWF != undefined) {
                loaded.GradInqWF(responseData.GradInqWF);
            }
            if (responseData.AdmissionsGroupName != undefined) {
                loaded.AdmissionsGroupName(responseData.AdmissionsGroupName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsModuleSettings', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ApplicationName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.SiteName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.UndergradInqRuleSetBeforeWF.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.UndergradInqRuleSetAfterWF.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.UndergradInqWF.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.GradInqRuleSetBeforeWF.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.GradInqRuleSetAfterWF.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.GradInqWF.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.AdmissionsGroupName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsPaymentInformationModel(options) {
        var defaults = {
            PersonID: 0,
            PaymentMethodID: null,
            Paid: false,
            PaymentDate: null,
            DataStepID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.PaymentMethodID = ko.validatedObservable(settings.PaymentMethodID);
        this.Paid = ko.validatedObservable(settings.Paid);
        this.PaymentDate = ko.validatedObservable(settings.PaymentDate);
        this.DataStepID = ko.validatedObservable(settings.DataStepID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.DataStep = ko.observable();
        this.AccountTransactions = ko.observableArray([]);
        this.PaymentMethod = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.PaymentMethodID != undefined) {
                loaded.PaymentMethodID(responseData.PaymentMethodID);
            }
            if (responseData.Paid != undefined) {
                loaded.Paid(responseData.Paid);
            }
            if (responseData.PaymentDate != undefined) {
                loaded.PaymentDate(responseData.PaymentDate);
            }
            if (responseData.DataStepID != undefined) {
                loaded.DataStepID(responseData.DataStepID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.DataStep != null) {
                loaded.DataStep(new smapi.admissions.AdmissionsPaymentInformationStepModel().LoadFromResponse(responseData.DataStep));
            }
            if (responseData.AccountTransactions != null && responseData.AccountTransactions.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.AccountTransactions.length; i++) {
                    items.push(new smapi.financials.TransactionLedgerModel().LoadFromResponse(responseData.AccountTransactions[i]));
                }
                loaded.AccountTransactions(items);
            }
            if (responseData.PaymentMethod != null) {
                loaded.PaymentMethod(new smapi.financials.PaymentMethodModel().LoadFromResponse(responseData.PaymentMethod));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsPaymentInformation', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PaymentMethodID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Paid.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.PaymentDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.DataStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsPaymentInformationStepModel(options) {
        var defaults = {
            ClassType: 0,
            Comments: '',
            AdmissionsAttemptID: 0,
            ProcessStageID: null,
            ParentStepID: null,
            StatusID: 0,
            RequiredOptionID: null,
            StepStartDate: null,
            StepEndDate: null,
            NavigatorScreenPath: '',
            ExpectedStepEndDate: null,
            AdHoc: false,
            ProgressOveridden: false,
            ExternalStage: false,
            MinExternalData: 0,
            MaxExternalData: 0,
            DueDate: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.Comments = ko.validatedObservable(settings.Comments);
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.ProcessStageID = ko.validatedObservable(settings.ProcessStageID);
        this.ParentStepID = ko.validatedObservable(settings.ParentStepID);
        this.StatusID = ko.validatedObservable(settings.StatusID);
        this.RequiredOptionID = ko.validatedObservable(settings.RequiredOptionID);
        this.StepStartDate = ko.validatedObservable(settings.StepStartDate);
        this.StepEndDate = ko.validatedObservable(settings.StepEndDate);
        this.NavigatorScreenPath = ko.validatedObservable(settings.NavigatorScreenPath);
        this.ExpectedStepEndDate = ko.validatedObservable(settings.ExpectedStepEndDate);
        this.AdHoc = ko.validatedObservable(settings.AdHoc);
        this.ProgressOveridden = ko.validatedObservable(settings.ProgressOveridden);
        this.ExternalStage = ko.validatedObservable(settings.ExternalStage);
        this.MinExternalData = ko.validatedObservable(settings.MinExternalData);
        this.MaxExternalData = ko.validatedObservable(settings.MaxExternalData);
        this.DueDate = ko.validatedObservable(settings.DueDate);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AdmissionsPaymentInformationDetails = ko.observableArray([]);
        this.AdmissionsAttempt = ko.observable();
        this.ProcessStage = ko.observable();
        this.ReviewerComments = ko.observableArray([]);
        this.ExternalData = ko.observableArray([]);
        this.Parent = ko.observable();
        this.ChildSteps = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.Comments != undefined) {
                loaded.Comments(responseData.Comments);
            }
            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.ProcessStageID != undefined) {
                loaded.ProcessStageID(responseData.ProcessStageID);
            }
            if (responseData.ParentStepID != undefined) {
                loaded.ParentStepID(responseData.ParentStepID);
            }
            if (responseData.StatusID != undefined) {
                loaded.StatusID(responseData.StatusID);
            }
            if (responseData.RequiredOptionID != undefined) {
                loaded.RequiredOptionID(responseData.RequiredOptionID);
            }
            if (responseData.StepStartDate != undefined) {
                loaded.StepStartDate(responseData.StepStartDate);
            }
            if (responseData.StepEndDate != undefined) {
                loaded.StepEndDate(responseData.StepEndDate);
            }
            if (responseData.NavigatorScreenPath != undefined) {
                loaded.NavigatorScreenPath(responseData.NavigatorScreenPath);
            }
            if (responseData.ExpectedStepEndDate != undefined) {
                loaded.ExpectedStepEndDate(responseData.ExpectedStepEndDate);
            }
            if (responseData.AdHoc != undefined) {
                loaded.AdHoc(responseData.AdHoc);
            }
            if (responseData.ProgressOveridden != undefined) {
                loaded.ProgressOveridden(responseData.ProgressOveridden);
            }
            if (responseData.ExternalStage != undefined) {
                loaded.ExternalStage(responseData.ExternalStage);
            }
            if (responseData.MinExternalData != undefined) {
                loaded.MinExternalData(responseData.MinExternalData);
            }
            if (responseData.MaxExternalData != undefined) {
                loaded.MaxExternalData(responseData.MaxExternalData);
            }
            if (responseData.DueDate != undefined) {
                loaded.DueDate(responseData.DueDate);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AdmissionsPaymentInformationDetails != null && responseData.AdmissionsPaymentInformationDetails.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.AdmissionsPaymentInformationDetails.length; i++) {
                    items.push(new smapi.admissions.AdmissionsPaymentInformationModel().LoadFromResponse(responseData.AdmissionsPaymentInformationDetails[i]));
                }
                loaded.AdmissionsPaymentInformationDetails(items);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }
            if (responseData.ProcessStage != null) {
                loaded.ProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.ProcessStage));
            }
            if (responseData.ReviewerComments != null && responseData.ReviewerComments.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ReviewerComments.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationCommentModel().LoadFromResponse(responseData.ReviewerComments[i]));
                }
                loaded.ReviewerComments(items);
            }
            if (responseData.ExternalData != null && responseData.ExternalData.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ExternalData.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepDataModel().LoadFromResponse(responseData.ExternalData[i]));
                }
                loaded.ExternalData(items);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.ChildSteps != null && responseData.ChildSteps.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ChildSteps.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.ChildSteps[i]));
                }
                loaded.ChildSteps(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsPaymentInformationStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Comments.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProcessStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RequiredOptionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StepStartDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.StepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.NavigatorScreenPath.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ExpectedStepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AdHoc.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ExternalStage.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.MinExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MaxExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DueDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsPeriodModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            PeriodID: null,
            StartDate: null,
            EndDate: null,
            ActivePortal: false,
            SortOrder: '',
            EnrollmentYieldLower: 0,
            EnrollmentYieldUpper: 0,
            AcademicYear: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.PeriodID = ko.validatedObservable(settings.PeriodID);
        this.StartDate = ko.validatedObservable(settings.StartDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.ActivePortal = ko.validatedObservable(settings.ActivePortal);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.EnrollmentYieldLower = ko.validatedObservable(settings.EnrollmentYieldLower);
        this.EnrollmentYieldUpper = ko.validatedObservable(settings.EnrollmentYieldUpper);
        this.AcademicYear = ko.validatedObservable(settings.AcademicYear);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Period = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.PeriodID != undefined) {
                loaded.PeriodID(responseData.PeriodID);
            }
            if (responseData.StartDate != undefined) {
                loaded.StartDate(responseData.StartDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.ActivePortal != undefined) {
                loaded.ActivePortal(responseData.ActivePortal);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.EnrollmentYieldLower != undefined) {
                loaded.EnrollmentYieldLower(responseData.EnrollmentYieldLower);
            }
            if (responseData.EnrollmentYieldUpper != undefined) {
                loaded.EnrollmentYieldUpper(responseData.EnrollmentYieldUpper);
            }
            if (responseData.AcademicYear != undefined) {
                loaded.AcademicYear(responseData.AcademicYear);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Period != null) {
                loaded.Period(new smapi.community.PeriodModel().LoadFromResponse(responseData.Period));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsPeriod', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.PeriodID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StartDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ActivePortal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 12,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '12')
            }
        });
        this.EnrollmentYieldLower.extend({
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EnrollmentYieldUpper.extend({
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AcademicYear.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsProcessStageModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            MinExternalData: 0,
            MaxExternalData: 0,
            Required: false,
            CopyStatusBetweenSteps: false,
            CopyExtDataBetweenSteps: false,
            ApplicantShouldHaveAccess: false,
            AdHoc: false,
            AllowProgressOverride: false,
            ExternalStage: false,
            PortalStepID: null,
            InclusionRuleSetID: null,
            ProgressRuleSetID: null,
            NavigatorScreenPath: '',
            EntityID: 0,
            StepDataEntityID: null,
            DocumentTypeID: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.MinExternalData = ko.validatedObservable(settings.MinExternalData);
        this.MaxExternalData = ko.validatedObservable(settings.MaxExternalData);
        this.Required = ko.validatedObservable(settings.Required);
        this.CopyStatusBetweenSteps = ko.validatedObservable(settings.CopyStatusBetweenSteps);
        this.CopyExtDataBetweenSteps = ko.validatedObservable(settings.CopyExtDataBetweenSteps);
        this.ApplicantShouldHaveAccess = ko.validatedObservable(settings.ApplicantShouldHaveAccess);
        this.AdHoc = ko.validatedObservable(settings.AdHoc);
        this.AllowProgressOverride = ko.validatedObservable(settings.AllowProgressOverride);
        this.ExternalStage = ko.validatedObservable(settings.ExternalStage);
        this.PortalStepID = ko.validatedObservable(settings.PortalStepID);
        this.InclusionRuleSetID = ko.validatedObservable(settings.InclusionRuleSetID);
        this.ProgressRuleSetID = ko.validatedObservable(settings.ProgressRuleSetID);
        this.NavigatorScreenPath = ko.validatedObservable(settings.NavigatorScreenPath);
        this.EntityID = ko.validatedObservable(settings.EntityID);
        this.StepDataEntityID = ko.validatedObservable(settings.StepDataEntityID);
        this.DocumentTypeID = ko.validatedObservable(settings.DocumentTypeID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AdmissionsPrograms = ko.observableArray([]);
        this.Prerequisites = ko.observableArray([]);
        this.AdmissionsProcessStageAttributes = ko.observableArray([]);
        this.DocumentType = ko.observable();
        this.PortalStep = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.MinExternalData != undefined) {
                loaded.MinExternalData(responseData.MinExternalData);
            }
            if (responseData.MaxExternalData != undefined) {
                loaded.MaxExternalData(responseData.MaxExternalData);
            }
            if (responseData.Required != undefined) {
                loaded.Required(responseData.Required);
            }
            if (responseData.CopyStatusBetweenSteps != undefined) {
                loaded.CopyStatusBetweenSteps(responseData.CopyStatusBetweenSteps);
            }
            if (responseData.CopyExtDataBetweenSteps != undefined) {
                loaded.CopyExtDataBetweenSteps(responseData.CopyExtDataBetweenSteps);
            }
            if (responseData.ApplicantShouldHaveAccess != undefined) {
                loaded.ApplicantShouldHaveAccess(responseData.ApplicantShouldHaveAccess);
            }
            if (responseData.AdHoc != undefined) {
                loaded.AdHoc(responseData.AdHoc);
            }
            if (responseData.AllowProgressOverride != undefined) {
                loaded.AllowProgressOverride(responseData.AllowProgressOverride);
            }
            if (responseData.ExternalStage != undefined) {
                loaded.ExternalStage(responseData.ExternalStage);
            }
            if (responseData.PortalStepID != undefined) {
                loaded.PortalStepID(responseData.PortalStepID);
            }
            if (responseData.InclusionRuleSetID != undefined) {
                loaded.InclusionRuleSetID(responseData.InclusionRuleSetID);
            }
            if (responseData.ProgressRuleSetID != undefined) {
                loaded.ProgressRuleSetID(responseData.ProgressRuleSetID);
            }
            if (responseData.NavigatorScreenPath != undefined) {
                loaded.NavigatorScreenPath(responseData.NavigatorScreenPath);
            }
            if (responseData.EntityID != undefined) {
                loaded.EntityID(responseData.EntityID);
            }
            if (responseData.StepDataEntityID != undefined) {
                loaded.StepDataEntityID(responseData.StepDataEntityID);
            }
            if (responseData.DocumentTypeID != undefined) {
                loaded.DocumentTypeID(responseData.DocumentTypeID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AdmissionsPrograms != null && responseData.AdmissionsPrograms.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.AdmissionsPrograms.length; i++) {
                    items.push(new smapi.admissions.AdmissionsProgramModel().LoadFromResponse(responseData.AdmissionsPrograms[i]));
                }
                loaded.AdmissionsPrograms(items);
            }
            if (responseData.Prerequisites != null && responseData.Prerequisites.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Prerequisites.length; i++) {
                    items.push(new smapi.admissions.AdmissionsProcessStagePrerequisiteModel().LoadFromResponse(responseData.Prerequisites[i]));
                }
                loaded.Prerequisites(items);
            }
            if (responseData.AdmissionsProcessStageAttributes != null && responseData.AdmissionsProcessStageAttributes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.AdmissionsProcessStageAttributes.length; i++) {
                    items.push(new smapi.admissions.AdmissionsProcessStageAttributesModel().LoadFromResponse(responseData.AdmissionsProcessStageAttributes[i]));
                }
                loaded.AdmissionsProcessStageAttributes(items);
            }
            if (responseData.DocumentType != null) {
                loaded.DocumentType(new smapi.community.DocumentTypeModel().LoadFromResponse(responseData.DocumentType));
            }
            if (responseData.PortalStep != null) {
                loaded.PortalStep(new smapi.admissions.PortalStepModel().LoadFromResponse(responseData.PortalStep));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsProcessStage', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.MinExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MaxExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Required.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.CopyStatusBetweenSteps.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.CopyExtDataBetweenSteps.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ApplicantShouldHaveAccess.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.AdHoc.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.AllowProgressOverride.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ExternalStage.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.PortalStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.InclusionRuleSetID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProgressRuleSetID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.NavigatorScreenPath.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.EntityID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StepDataEntityID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DocumentTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsProcessStageAttributesModel(options) {
        var defaults = {
            AdmissionsProcessStageID: 0,
            EntityFieldID: 0,
            Visibility: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.AdmissionsProcessStageID = ko.validatedObservable(settings.AdmissionsProcessStageID);
        this.EntityFieldID = ko.validatedObservable(settings.EntityFieldID);
        this.Visibility = ko.validatedObservable(settings.Visibility);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AdmissionsProcessStage = ko.observable();
        this.ApplicationEvaluationWeight = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.AdmissionsProcessStageID != undefined) {
                loaded.AdmissionsProcessStageID(responseData.AdmissionsProcessStageID);
            }
            if (responseData.EntityFieldID != undefined) {
                loaded.EntityFieldID(responseData.EntityFieldID);
            }
            if (responseData.Visibility != undefined) {
                loaded.Visibility(responseData.Visibility);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AdmissionsProcessStage != null) {
                loaded.AdmissionsProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.AdmissionsProcessStage));
            }
            if (responseData.ApplicationEvaluationWeight != null && responseData.ApplicationEvaluationWeight.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ApplicationEvaluationWeight.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationWeightModel().LoadFromResponse(responseData.ApplicationEvaluationWeight[i]));
                }
                loaded.ApplicationEvaluationWeight(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsProcessStageAttributes', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.AdmissionsProcessStageID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EntityFieldID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Visibility.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsProcessStageBehaviorModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            NavigatorScreenPath: '',
            AdmissionsProcessStageID: 0,
            AdmissionsTypeID: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.NavigatorScreenPath = ko.validatedObservable(settings.NavigatorScreenPath);
        this.AdmissionsProcessStageID = ko.validatedObservable(settings.AdmissionsProcessStageID);
        this.AdmissionsTypeID = ko.validatedObservable(settings.AdmissionsTypeID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AdmissionsProcessStage = ko.observable();
        this.AdmissionsType = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.NavigatorScreenPath != undefined) {
                loaded.NavigatorScreenPath(responseData.NavigatorScreenPath);
            }
            if (responseData.AdmissionsProcessStageID != undefined) {
                loaded.AdmissionsProcessStageID(responseData.AdmissionsProcessStageID);
            }
            if (responseData.AdmissionsTypeID != undefined) {
                loaded.AdmissionsTypeID(responseData.AdmissionsTypeID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AdmissionsProcessStage != null) {
                loaded.AdmissionsProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.AdmissionsProcessStage));
            }
            if (responseData.AdmissionsType != null) {
                loaded.AdmissionsType(new smapi.admissions.AdmissionsTypeModel().LoadFromResponse(responseData.AdmissionsType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsProcessStageBehavior', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.NavigatorScreenPath.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.AdmissionsProcessStageID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionsTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsProcessStagePrerequisiteModel(options) {
        var defaults = {
            ProgressRuleSet: null,
            RequiredAdmissionsProcessStageID: null,
            DependentAdmissionsProcessStageID: null,
            ParentAdmissionsProcessStageID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ProgressRuleSet = ko.validatedObservable(settings.ProgressRuleSet);
        this.RequiredAdmissionsProcessStageID = ko.validatedObservable(settings.RequiredAdmissionsProcessStageID);
        this.DependentAdmissionsProcessStageID = ko.validatedObservable(settings.DependentAdmissionsProcessStageID);
        this.ParentAdmissionsProcessStageID = ko.validatedObservable(settings.ParentAdmissionsProcessStageID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.ParentAdmissionsProcessStage = ko.observable();
        this.RequiredAdmissionsProcessStage = ko.observable();
        this.DependentAdmissionsProcessStage = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ProgressRuleSet != undefined) {
                loaded.ProgressRuleSet(responseData.ProgressRuleSet);
            }
            if (responseData.RequiredAdmissionsProcessStageID != undefined) {
                loaded.RequiredAdmissionsProcessStageID(responseData.RequiredAdmissionsProcessStageID);
            }
            if (responseData.DependentAdmissionsProcessStageID != undefined) {
                loaded.DependentAdmissionsProcessStageID(responseData.DependentAdmissionsProcessStageID);
            }
            if (responseData.ParentAdmissionsProcessStageID != undefined) {
                loaded.ParentAdmissionsProcessStageID(responseData.ParentAdmissionsProcessStageID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.ParentAdmissionsProcessStage != null) {
                loaded.ParentAdmissionsProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.ParentAdmissionsProcessStage));
            }
            if (responseData.RequiredAdmissionsProcessStage != null) {
                loaded.RequiredAdmissionsProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.RequiredAdmissionsProcessStage));
            }
            if (responseData.DependentAdmissionsProcessStage != null) {
                loaded.DependentAdmissionsProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.DependentAdmissionsProcessStage));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsProcessStagePrerequisite', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ProgressRuleSet.extend({
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.RequiredAdmissionsProcessStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DependentAdmissionsProcessStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentAdmissionsProcessStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsProgramModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            ProgramID: '',
            ProgramStatusID: null,
            ApprovedDate: null,
            EffectiveDateFrom: null,
            EffectiveDateTo: null,
            DivisionID: null,
            DeliveryMethodID: null,
            ProgramLength: 0,
            UnitLength: null,
            WeightFactor: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.ProgramID = ko.validatedObservable(settings.ProgramID);
        this.ProgramStatusID = ko.validatedObservable(settings.ProgramStatusID);
        this.ApprovedDate = ko.validatedObservable(settings.ApprovedDate);
        this.EffectiveDateFrom = ko.validatedObservable(settings.EffectiveDateFrom);
        this.EffectiveDateTo = ko.validatedObservable(settings.EffectiveDateTo);
        this.DivisionID = ko.validatedObservable(settings.DivisionID);
        this.DeliveryMethodID = ko.validatedObservable(settings.DeliveryMethodID);
        this.ProgramLength = ko.validatedObservable(settings.ProgramLength);
        this.UnitLength = ko.validatedObservable(settings.UnitLength);
        this.WeightFactor = ko.validatedObservable(settings.WeightFactor);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.DeliveryMethod = ko.observable();
        this.Division = ko.observable();
        this.AdmissionsProcessStages = ko.observableArray([]);
        this.Campuses = ko.observableArray([]);
        this.Goals = ko.observableArray([]);
        this.AdmissionsOfferStages = ko.observableArray([]);
        this.ProgramStatus = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.ProgramID != undefined) {
                loaded.ProgramID(responseData.ProgramID);
            }
            if (responseData.ProgramStatusID != undefined) {
                loaded.ProgramStatusID(responseData.ProgramStatusID);
            }
            if (responseData.ApprovedDate != undefined) {
                loaded.ApprovedDate(responseData.ApprovedDate);
            }
            if (responseData.EffectiveDateFrom != undefined) {
                loaded.EffectiveDateFrom(responseData.EffectiveDateFrom);
            }
            if (responseData.EffectiveDateTo != undefined) {
                loaded.EffectiveDateTo(responseData.EffectiveDateTo);
            }
            if (responseData.DivisionID != undefined) {
                loaded.DivisionID(responseData.DivisionID);
            }
            if (responseData.DeliveryMethodID != undefined) {
                loaded.DeliveryMethodID(responseData.DeliveryMethodID);
            }
            if (responseData.ProgramLength != undefined) {
                loaded.ProgramLength(responseData.ProgramLength);
            }
            if (responseData.UnitLength != undefined) {
                loaded.UnitLength(responseData.UnitLength);
            }
            if (responseData.WeightFactor != undefined) {
                loaded.WeightFactor(responseData.WeightFactor);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.DeliveryMethod != null) {
                loaded.DeliveryMethod(new smapi.academic.AcademicDeliveryMethodModel().LoadFromResponse(responseData.DeliveryMethod));
            }
            if (responseData.Division != null) {
                loaded.Division(new smapi.academic.DivisionModel().LoadFromResponse(responseData.Division));
            }
            if (responseData.AdmissionsProcessStages != null && responseData.AdmissionsProcessStages.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.AdmissionsProcessStages.length; i++) {
                    items.push(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.AdmissionsProcessStages[i]));
                }
                loaded.AdmissionsProcessStages(items);
            }
            if (responseData.Campuses != null && responseData.Campuses.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Campuses.length; i++) {
                    items.push(new smapi.facility.CampusModel().LoadFromResponse(responseData.Campuses[i]));
                }
                loaded.Campuses(items);
            }
            if (responseData.Goals != null && responseData.Goals.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Goals.length; i++) {
                    items.push(new smapi.admissions.AdmissionsEducationalGoalModel().LoadFromResponse(responseData.Goals[i]));
                }
                loaded.Goals(items);
            }
            if (responseData.AdmissionsProgramOfferingFlowDefinitions != null && responseData.AdmissionsProgramOfferingFlowDefinitions.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.AdmissionsProgramOfferingFlowDefinitions.length; i++) {
                    items.push(new smapi.admissions.AdmissionsStageModel().LoadFromResponse(responseData.AdmissionsProgramOfferingFlowDefinitions[i].AdmissionsOfferStage));
                }
                loaded.AdmissionsOfferStages(items);
            }
            if (responseData.ProgramStatus != null) {
                loaded.ProgramStatus(new smapi.academic.ProgramStatusModel().LoadFromResponse(responseData.ProgramStatus));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsProgram', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ProgramID.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ProgramStatusID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ApprovedDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EffectiveDateFrom.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EffectiveDateTo.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.DivisionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DeliveryMethodID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProgramLength.extend({
            min: {
                params: -32768,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 32767,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.WeightFactor.extend({
            min: {
                params: 0,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GreaterThan0_Key), '0')
            }, 
            max: {
                params: 0,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_LessThan0_Key), '0')
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsProgramOfferingModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            AdmissionsAcademicLevelID: null,
            GroupAcademicLevelID: null,
            AdmissionCohortID: null,
            PeriodBased: false,
            AvailableStart: null,
            AvailableEnd: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.AdmissionsAcademicLevelID = ko.validatedObservable(settings.AdmissionsAcademicLevelID);
        this.GroupAcademicLevelID = ko.validatedObservable(settings.GroupAcademicLevelID);
        this.AdmissionCohortID = ko.validatedObservable(settings.AdmissionCohortID);
        this.PeriodBased = ko.validatedObservable(settings.PeriodBased);
        this.AvailableStart = ko.validatedObservable(settings.AvailableStart);
        this.AvailableEnd = ko.validatedObservable(settings.AvailableEnd);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.GroupAcademicLevel = ko.observable();
        this.ExternalIDs = ko.observableArray([]);
        this.AssignPeriodTypes = ko.observableArray([]);
        this.DeliveryMethods = ko.observableArray([]);
        this.Items = ko.observableArray([]);
        this.AcademicLevel = ko.observable();
        this.Campuses = ko.observableArray([]);
        this.AdmissionsCohort = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.AdmissionsAcademicLevelID != undefined) {
                loaded.AdmissionsAcademicLevelID(responseData.AdmissionsAcademicLevelID);
            }
            if (responseData.GroupAcademicLevelID != undefined) {
                loaded.GroupAcademicLevelID(responseData.GroupAcademicLevelID);
            }
            if (responseData.AdmissionCohortID != undefined) {
                loaded.AdmissionCohortID(responseData.AdmissionCohortID);
            }
            if (responseData.PeriodBased != undefined) {
                loaded.PeriodBased(responseData.PeriodBased);
            }
            if (responseData.AvailableStart != undefined) {
                loaded.AvailableStart(responseData.AvailableStart);
            }
            if (responseData.AvailableEnd != undefined) {
                loaded.AvailableEnd(responseData.AvailableEnd);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.GroupAcademicLevel != null) {
                loaded.GroupAcademicLevel(new smapi.admissions.AdmissionsAcademicLevelModel().LoadFromResponse(responseData.GroupAcademicLevel));
            }
            if (responseData.ExternalIDs != null && responseData.ExternalIDs.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ExternalIDs.length; i++) {
                    items.push(new smapi.admissions.ExternalAdmissionsProgramOfferingIDModel().LoadFromResponse(responseData.ExternalIDs[i]));
                }
                loaded.ExternalIDs(items);
            }
            if (responseData.AssignPeriodTypes != null && responseData.AssignPeriodTypes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.AssignPeriodTypes.length; i++) {
                    items.push(new smapi.academic.AcademicPeriodTypeModel().LoadFromResponse(responseData.AssignPeriodTypes[i]));
                }
                loaded.AssignPeriodTypes(items);
            }
            if (responseData.DeliveryMethods != null && responseData.DeliveryMethods.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.DeliveryMethods.length; i++) {
                    items.push(new smapi.academic.AcademicDeliveryMethodModel().LoadFromResponse(responseData.DeliveryMethods[i]));
                }
                loaded.DeliveryMethods(items);
            }
            if (responseData.Items != null && responseData.Items.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Items.length; i++) {
                    items.push(new smapi.admissions.AdmissionsProgramOfferingItemModel().LoadFromResponse(responseData.Items[i]));
                }
                loaded.Items(items);
            }
            if (responseData.AcademicLevel != null) {
                loaded.AcademicLevel(new smapi.admissions.AdmissionsAcademicLevelModel().LoadFromResponse(responseData.AcademicLevel));
            }
            if (responseData.Campuses != null && responseData.Campuses.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Campuses.length; i++) {
                    items.push(new smapi.facility.CampusModel().LoadFromResponse(responseData.Campuses[i]));
                }
                loaded.Campuses(items);
            }
            if (responseData.AdmissionsCohort != null) {
                loaded.AdmissionsCohort(new smapi.admissions.AdmissionsCohortModel().LoadFromResponse(responseData.AdmissionsCohort));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsProgramOffering', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.AdmissionsAcademicLevelID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GroupAcademicLevelID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionCohortID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AvailableStart.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AvailableEnd.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsProgramOfferingItemModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            AdmissionsAcademicLevelID: null,
            ApplicationGoalID: null,
            AdmissionProgramID: null,
            DivisionID: null,
            TypeID: null,
            AcademicProgramID: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.AdmissionsAcademicLevelID = ko.validatedObservable(settings.AdmissionsAcademicLevelID);
        this.ApplicationGoalID = ko.validatedObservable(settings.ApplicationGoalID);
        this.AdmissionProgramID = ko.validatedObservable(settings.AdmissionProgramID);
        this.DivisionID = ko.validatedObservable(settings.DivisionID);
        this.TypeID = ko.validatedObservable(settings.TypeID);
        this.AcademicProgramID = ko.validatedObservable(settings.AcademicProgramID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AcademicProgram = ko.observable();
        this.Division = ko.observable();
        this.ExternalIDs = ko.observableArray([]);
        this.AcademicLevel = ko.observable();
        this.AdmissionProgram = ko.observable();
        this.ApplicationGoal = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.AdmissionsAcademicLevelID != undefined) {
                loaded.AdmissionsAcademicLevelID(responseData.AdmissionsAcademicLevelID);
            }
            if (responseData.ApplicationGoalID != undefined) {
                loaded.ApplicationGoalID(responseData.ApplicationGoalID);
            }
            if (responseData.AdmissionProgramID != undefined) {
                loaded.AdmissionProgramID(responseData.AdmissionProgramID);
            }
            if (responseData.DivisionID != undefined) {
                loaded.DivisionID(responseData.DivisionID);
            }
            if (responseData.TypeID != undefined) {
                loaded.TypeID(responseData.TypeID);
            }
            if (responseData.AcademicProgramID != undefined) {
                loaded.AcademicProgramID(responseData.AcademicProgramID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AcademicProgram != null) {
                loaded.AcademicProgram(new smapi.academic.AcademicProgramModel().LoadFromResponse(responseData.AcademicProgram));
            }
            if (responseData.Division != null) {
                loaded.Division(new smapi.academic.DivisionModel().LoadFromResponse(responseData.Division));
            }
            if (responseData.ExternalIDs != null && responseData.ExternalIDs.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ExternalIDs.length; i++) {
                    items.push(new smapi.admissions.ExternalAdmissionsProgramOfferingItemIDModel().LoadFromResponse(responseData.ExternalIDs[i]));
                }
                loaded.ExternalIDs(items);
            }
            if (responseData.AcademicLevel != null) {
                loaded.AcademicLevel(new smapi.admissions.AdmissionsAcademicLevelModel().LoadFromResponse(responseData.AcademicLevel));
            }
            if (responseData.AdmissionProgram != null) {
                loaded.AdmissionProgram(new smapi.admissions.AdmissionsProgramModel().LoadFromResponse(responseData.AdmissionProgram));
            }
            if (responseData.ApplicationGoal != null) {
                loaded.ApplicationGoal(new smapi.admissions.AdmissionsEducationalGoalModel().LoadFromResponse(responseData.ApplicationGoal));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsProgramOfferingItem', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.AdmissionsAcademicLevelID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ApplicationGoalID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionProgramID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DivisionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AcademicProgramID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsRankingListModel(options) {
        var defaults = {
            GenerationDate: null,
            ApplicationEvaluationSetupID: 0,
            AdmissionsPeriodID: 0,
            AdmissionsProgramID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.GenerationDate = ko.validatedObservable(settings.GenerationDate);
        this.ApplicationEvaluationSetupID = ko.validatedObservable(settings.ApplicationEvaluationSetupID);
        this.AdmissionsPeriodID = ko.validatedObservable(settings.AdmissionsPeriodID);
        this.AdmissionsProgramID = ko.validatedObservable(settings.AdmissionsProgramID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.ApplicationEvaluationSetup = ko.observable();
        this.AdmissionsPeriod = ko.observable();
        this.AdmissionsProgram = ko.observable();
        this.AdmissionsApplicationRanks = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.GenerationDate != undefined) {
                loaded.GenerationDate(responseData.GenerationDate);
            }
            if (responseData.ApplicationEvaluationSetupID != undefined) {
                loaded.ApplicationEvaluationSetupID(responseData.ApplicationEvaluationSetupID);
            }
            if (responseData.AdmissionsPeriodID != undefined) {
                loaded.AdmissionsPeriodID(responseData.AdmissionsPeriodID);
            }
            if (responseData.AdmissionsProgramID != undefined) {
                loaded.AdmissionsProgramID(responseData.AdmissionsProgramID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.ApplicationEvaluationSetup != null) {
                loaded.ApplicationEvaluationSetup(new smapi.admissions.ApplicationEvaluationSetupModel().LoadFromResponse(responseData.ApplicationEvaluationSetup));
            }
            if (responseData.AdmissionsPeriod != null) {
                loaded.AdmissionsPeriod(new smapi.admissions.AdmissionsPeriodModel().LoadFromResponse(responseData.AdmissionsPeriod));
            }
            if (responseData.AdmissionsProgram != null) {
                loaded.AdmissionsProgram(new smapi.admissions.AdmissionsProgramModel().LoadFromResponse(responseData.AdmissionsProgram));
            }
            if (responseData.AdmissionsApplicationRanks != null && responseData.AdmissionsApplicationRanks.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.AdmissionsApplicationRanks.length; i++) {
                    items.push(new smapi.admissions.AdmissionsApplicationRankModel().LoadFromResponse(responseData.AdmissionsApplicationRanks[i]));
                }
                loaded.AdmissionsApplicationRanks(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsRankingList', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.GenerationDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ApplicationEvaluationSetupID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionsPeriodID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionsProgramID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsStageModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            AllowForImport: false,
            FinancialAid: false,
            Milestone: false,
            CreateStudent: false,
            AdmissionsStageStatusID: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.AllowForImport = ko.validatedObservable(settings.AllowForImport);
        this.FinancialAid = ko.validatedObservable(settings.FinancialAid);
        this.Milestone = ko.validatedObservable(settings.Milestone);
        this.CreateStudent = ko.validatedObservable(settings.CreateStudent);
        this.AdmissionsStageStatusID = ko.validatedObservable(settings.AdmissionsStageStatusID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AdmissionsTypes = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.AllowForImport != undefined) {
                loaded.AllowForImport(responseData.AllowForImport);
            }
            if (responseData.FinancialAid != undefined) {
                loaded.FinancialAid(responseData.FinancialAid);
            }
            if (responseData.Milestone != undefined) {
                loaded.Milestone(responseData.Milestone);
            }
            if (responseData.CreateStudent != undefined) {
                loaded.CreateStudent(responseData.CreateStudent);
            }
            if (responseData.AdmissionsStageStatusID != undefined) {
                loaded.AdmissionsStageStatusID(responseData.AdmissionsStageStatusID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AdmissionsTypes != null && responseData.AdmissionsTypes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.AdmissionsTypes.length; i++) {
                    items.push(new smapi.admissions.AdmissionsTypeModel().LoadFromResponse(responseData.AdmissionsTypes[i]));
                }
                loaded.AdmissionsTypes(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsStage', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 250,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '250')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 250,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '250')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AllowForImport.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.FinancialAid.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.AdmissionsStageStatusID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsTestNameModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsTestName', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsTestStatusModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsTestStatus', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsTestSubjectModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsTestSubject', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AdmissionsTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            AdmissionsStageStatusID: null,
            AdmissionsAcademicLevelID: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.AdmissionsStageStatusID = ko.validatedObservable(settings.AdmissionsStageStatusID);
        this.AdmissionsAcademicLevelID = ko.validatedObservable(settings.AdmissionsAcademicLevelID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.OverriddenBehaviors = ko.observableArray([]);
        this.AdmissionsAcademicLevel = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.AdmissionsStageStatusID != undefined) {
                loaded.AdmissionsStageStatusID(responseData.AdmissionsStageStatusID);
            }
            if (responseData.AdmissionsAcademicLevelID != undefined) {
                loaded.AdmissionsAcademicLevelID(responseData.AdmissionsAcademicLevelID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.OverriddenBehaviors != null && responseData.OverriddenBehaviors.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.OverriddenBehaviors.length; i++) {
                    items.push(new smapi.admissions.AdmissionsProcessStageBehaviorModel().LoadFromResponse(responseData.OverriddenBehaviors[i]));
                }
                loaded.OverriddenBehaviors(items);
            }
            if (responseData.AdmissionsAcademicLevel != null) {
                loaded.AdmissionsAcademicLevel(new smapi.admissions.AdmissionsAcademicLevelModel().LoadFromResponse(responseData.AdmissionsAcademicLevel));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.AdmissionsStageStatusID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionsAcademicLevelID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ApplicationAthleticProgramsModel(options) {
        var defaults = {
            PersonID: 0,
            PlanOnParticipating: false,
            IsAthlete: false,
            HasBeenEvaluated: false,
            AthleteSetDate: null,
            AthleteSetByPersonID: null,
            Requirement48C: false,
            ProspectiveAthlete: false,
            DataStepID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.PlanOnParticipating = ko.validatedObservable(settings.PlanOnParticipating);
        this.IsAthlete = ko.validatedObservable(settings.IsAthlete);
        this.HasBeenEvaluated = ko.validatedObservable(settings.HasBeenEvaluated);
        this.AthleteSetDate = ko.validatedObservable(settings.AthleteSetDate);
        this.AthleteSetByPersonID = ko.validatedObservable(settings.AthleteSetByPersonID);
        this.Requirement48C = ko.validatedObservable(settings.Requirement48C);
        this.ProspectiveAthlete = ko.validatedObservable(settings.ProspectiveAthlete);
        this.DataStepID = ko.validatedObservable(settings.DataStepID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.DataStep = ko.observable();
        this.AthleteSetByPerson = ko.observable();
        this.AthleticProgram = ko.observableArray([]);
        this.EligibilityCenter = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.PlanOnParticipating != undefined) {
                loaded.PlanOnParticipating(responseData.PlanOnParticipating);
            }
            if (responseData.IsAthlete != undefined) {
                loaded.IsAthlete(responseData.IsAthlete);
            }
            if (responseData.HasBeenEvaluated != undefined) {
                loaded.HasBeenEvaluated(responseData.HasBeenEvaluated);
            }
            if (responseData.AthleteSetDate != undefined) {
                loaded.AthleteSetDate(responseData.AthleteSetDate);
            }
            if (responseData.AthleteSetByPersonID != undefined) {
                loaded.AthleteSetByPersonID(responseData.AthleteSetByPersonID);
            }
            if (responseData.Requirement48C != undefined) {
                loaded.Requirement48C(responseData.Requirement48C);
            }
            if (responseData.ProspectiveAthlete != undefined) {
                loaded.ProspectiveAthlete(responseData.ProspectiveAthlete);
            }
            if (responseData.DataStepID != undefined) {
                loaded.DataStepID(responseData.DataStepID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.DataStep != null) {
                loaded.DataStep(new smapi.admissions.ApplicationAthleticProgramsStepModel().LoadFromResponse(responseData.DataStep));
            }
            if (responseData.AthleteSetByPerson != null) {
                loaded.AthleteSetByPerson(new smapi.community.PersonModel().LoadFromResponse(responseData.AthleteSetByPerson));
            }
            if (responseData.AthleticProgram != null && responseData.AthleticProgram.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.AthleticProgram.length; i++) {
                    items.push(new smapi.admissions.AthleticProgramModel().LoadFromResponse(responseData.AthleticProgram[i]));
                }
                loaded.AthleticProgram(items);
            }
            if (responseData.EligibilityCenter != null && responseData.EligibilityCenter.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.EligibilityCenter.length; i++) {
                    items.push(new smapi.academic.AthleticEligibilityCenterModel().LoadFromResponse(responseData.EligibilityCenter[i]));
                }
                loaded.EligibilityCenter(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.ApplicationAthleticPrograms', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PlanOnParticipating.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.IsAthlete.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.HasBeenEvaluated.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.AthleteSetDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AthleteSetByPersonID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProspectiveAthlete.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.DataStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ApplicationAthleticProgramsStepModel(options) {
        var defaults = {
            ClassType: 0,
            Comments: '',
            AdmissionsAttemptID: 0,
            ProcessStageID: null,
            ParentStepID: null,
            StatusID: 0,
            RequiredOptionID: null,
            StepStartDate: null,
            StepEndDate: null,
            NavigatorScreenPath: '',
            ExpectedStepEndDate: null,
            AdHoc: false,
            ProgressOveridden: false,
            ExternalStage: false,
            MinExternalData: 0,
            MaxExternalData: 0,
            DueDate: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.Comments = ko.validatedObservable(settings.Comments);
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.ProcessStageID = ko.validatedObservable(settings.ProcessStageID);
        this.ParentStepID = ko.validatedObservable(settings.ParentStepID);
        this.StatusID = ko.validatedObservable(settings.StatusID);
        this.RequiredOptionID = ko.validatedObservable(settings.RequiredOptionID);
        this.StepStartDate = ko.validatedObservable(settings.StepStartDate);
        this.StepEndDate = ko.validatedObservable(settings.StepEndDate);
        this.NavigatorScreenPath = ko.validatedObservable(settings.NavigatorScreenPath);
        this.ExpectedStepEndDate = ko.validatedObservable(settings.ExpectedStepEndDate);
        this.AdHoc = ko.validatedObservable(settings.AdHoc);
        this.ProgressOveridden = ko.validatedObservable(settings.ProgressOveridden);
        this.ExternalStage = ko.validatedObservable(settings.ExternalStage);
        this.MinExternalData = ko.validatedObservable(settings.MinExternalData);
        this.MaxExternalData = ko.validatedObservable(settings.MaxExternalData);
        this.DueDate = ko.validatedObservable(settings.DueDate);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.ApplicationAthleticPrograms = ko.observableArray([]);
        this.AdmissionsAttempt = ko.observable();
        this.ProcessStage = ko.observable();
        this.ReviewerComments = ko.observableArray([]);
        this.ExternalData = ko.observableArray([]);
        this.Parent = ko.observable();
        this.ChildSteps = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.Comments != undefined) {
                loaded.Comments(responseData.Comments);
            }
            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.ProcessStageID != undefined) {
                loaded.ProcessStageID(responseData.ProcessStageID);
            }
            if (responseData.ParentStepID != undefined) {
                loaded.ParentStepID(responseData.ParentStepID);
            }
            if (responseData.StatusID != undefined) {
                loaded.StatusID(responseData.StatusID);
            }
            if (responseData.RequiredOptionID != undefined) {
                loaded.RequiredOptionID(responseData.RequiredOptionID);
            }
            if (responseData.StepStartDate != undefined) {
                loaded.StepStartDate(responseData.StepStartDate);
            }
            if (responseData.StepEndDate != undefined) {
                loaded.StepEndDate(responseData.StepEndDate);
            }
            if (responseData.NavigatorScreenPath != undefined) {
                loaded.NavigatorScreenPath(responseData.NavigatorScreenPath);
            }
            if (responseData.ExpectedStepEndDate != undefined) {
                loaded.ExpectedStepEndDate(responseData.ExpectedStepEndDate);
            }
            if (responseData.AdHoc != undefined) {
                loaded.AdHoc(responseData.AdHoc);
            }
            if (responseData.ProgressOveridden != undefined) {
                loaded.ProgressOveridden(responseData.ProgressOveridden);
            }
            if (responseData.ExternalStage != undefined) {
                loaded.ExternalStage(responseData.ExternalStage);
            }
            if (responseData.MinExternalData != undefined) {
                loaded.MinExternalData(responseData.MinExternalData);
            }
            if (responseData.MaxExternalData != undefined) {
                loaded.MaxExternalData(responseData.MaxExternalData);
            }
            if (responseData.DueDate != undefined) {
                loaded.DueDate(responseData.DueDate);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.ApplicationAthleticPrograms != null && responseData.ApplicationAthleticPrograms.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ApplicationAthleticPrograms.length; i++) {
                    items.push(new smapi.admissions.ApplicationAthleticProgramsModel().LoadFromResponse(responseData.ApplicationAthleticPrograms[i]));
                }
                loaded.ApplicationAthleticPrograms(items);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }
            if (responseData.ProcessStage != null) {
                loaded.ProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.ProcessStage));
            }
            if (responseData.ReviewerComments != null && responseData.ReviewerComments.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ReviewerComments.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationCommentModel().LoadFromResponse(responseData.ReviewerComments[i]));
                }
                loaded.ReviewerComments(items);
            }
            if (responseData.ExternalData != null && responseData.ExternalData.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ExternalData.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepDataModel().LoadFromResponse(responseData.ExternalData[i]));
                }
                loaded.ExternalData(items);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.ChildSteps != null && responseData.ChildSteps.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ChildSteps.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.ChildSteps[i]));
                }
                loaded.ChildSteps(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.ApplicationAthleticProgramsStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Comments.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProcessStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RequiredOptionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StepStartDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.StepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.NavigatorScreenPath.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ExpectedStepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AdHoc.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ExternalStage.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.MinExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MaxExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DueDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ApplicationEvaluationModel(options) {
        var defaults = {
            AdmissionsAttemptID: 0,
            AdmissionsProgramID: 0,
            StatusID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.AdmissionsProgramID = ko.validatedObservable(settings.AdmissionsProgramID);
        this.StatusID = ko.validatedObservable(settings.StatusID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AdmissionsAttempt = ko.observable();
        this.AdmissionProgram = ko.observable();
        this.ApplicationEvaluationComments = ko.observableArray([]);
        this.ApplicationEvaluationReviewerStatus = ko.observableArray([]);
        this.ApplicationEvaluationStatus = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.AdmissionsProgramID != undefined) {
                loaded.AdmissionsProgramID(responseData.AdmissionsProgramID);
            }
            if (responseData.StatusID != undefined) {
                loaded.StatusID(responseData.StatusID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }
            if (responseData.AdmissionProgram != null) {
                loaded.AdmissionProgram(new smapi.admissions.AdmissionsProgramModel().LoadFromResponse(responseData.AdmissionProgram));
            }
            if (responseData.ApplicationEvaluationComments != null && responseData.ApplicationEvaluationComments.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ApplicationEvaluationComments.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationCommentModel().LoadFromResponse(responseData.ApplicationEvaluationComments[i]));
                }
                loaded.ApplicationEvaluationComments(items);
            }
            if (responseData.ApplicationEvaluationReviewerStatus != null && responseData.ApplicationEvaluationReviewerStatus.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ApplicationEvaluationReviewerStatus.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationReviewerStatusModel().LoadFromResponse(responseData.ApplicationEvaluationReviewerStatus[i]));
                }
                loaded.ApplicationEvaluationReviewerStatus(items);
            }
            if (responseData.ApplicationEvaluationStatus != null) {
                loaded.ApplicationEvaluationStatus(new smapi.admissions.ApplicationEvaluationStatusModel().LoadFromResponse(responseData.ApplicationEvaluationStatus));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.ApplicationEvaluation', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionsProgramID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ApplicationEvaluationCommentModel(options) {
        var defaults = {
            ApplicationEvaluationID: 0,
            AdmissionsAttemptStepID: null,
            PersonID: 0,
            Comment: '',
            CommentDate: null,
            Score: 0,
            ScoreDate: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ApplicationEvaluationID = ko.validatedObservable(settings.ApplicationEvaluationID);
        this.AdmissionsAttemptStepID = ko.validatedObservable(settings.AdmissionsAttemptStepID);
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.Comment = ko.validatedObservable(settings.Comment);
        this.CommentDate = ko.validatedObservable(settings.CommentDate);
        this.Score = ko.validatedObservable(settings.Score);
        this.ScoreDate = ko.validatedObservable(settings.ScoreDate);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.ApplicationEvaluation = ko.observable();
        this.AdmissionsAttemptStep = ko.observable();
        this.Person = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ApplicationEvaluationID != undefined) {
                loaded.ApplicationEvaluationID(responseData.ApplicationEvaluationID);
            }
            if (responseData.AdmissionsAttemptStepID != undefined) {
                loaded.AdmissionsAttemptStepID(responseData.AdmissionsAttemptStepID);
            }
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.Comment != undefined) {
                loaded.Comment(responseData.Comment);
            }
            if (responseData.CommentDate != undefined) {
                loaded.CommentDate(responseData.CommentDate);
            }
            if (responseData.Score != undefined) {
                loaded.Score(responseData.Score);
            }
            if (responseData.ScoreDate != undefined) {
                loaded.ScoreDate(responseData.ScoreDate);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.ApplicationEvaluation != null) {
                loaded.ApplicationEvaluation(new smapi.admissions.ApplicationEvaluationModel().LoadFromResponse(responseData.ApplicationEvaluation));
            }
            if (responseData.AdmissionsAttemptStep != null) {
                loaded.AdmissionsAttemptStep(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.AdmissionsAttemptStep));
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.ApplicationEvaluationComment', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ApplicationEvaluationID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionsAttemptStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Comment.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.CommentDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.Score.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ScoreDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ApplicationEvaluationCriteriaModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.ProcessStage = ko.observableArray([]);
        this.ApplicationEvaluationWeight = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.ProcessStage != null && responseData.ProcessStage.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ProcessStage.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationRuleModel().LoadFromResponse(responseData.ProcessStage[i]));
                }
                loaded.ProcessStage(items);
            }
            if (responseData.ApplicationEvaluationWeight != null && responseData.ApplicationEvaluationWeight.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ApplicationEvaluationWeight.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationWeightModel().LoadFromResponse(responseData.ApplicationEvaluationWeight[i]));
                }
                loaded.ApplicationEvaluationWeight(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.ApplicationEvaluationCriteria', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ApplicationEvaluationReviewerStatusModel(options) {
        var defaults = {
            ApplicationEvaluationID: 0,
            PersonID: 0,
            StatusID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ApplicationEvaluationID = ko.validatedObservable(settings.ApplicationEvaluationID);
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.StatusID = ko.validatedObservable(settings.StatusID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.ApplicationEvaluation = ko.observable();
        this.Person = ko.observable();
        this.Status = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ApplicationEvaluationID != undefined) {
                loaded.ApplicationEvaluationID(responseData.ApplicationEvaluationID);
            }
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.StatusID != undefined) {
                loaded.StatusID(responseData.StatusID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.ApplicationEvaluation != null) {
                loaded.ApplicationEvaluation(new smapi.admissions.ApplicationEvaluationModel().LoadFromResponse(responseData.ApplicationEvaluation));
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.Status != null) {
                loaded.Status(new smapi.admissions.ApplicationEvaluationStatusModel().LoadFromResponse(responseData.Status));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.ApplicationEvaluationReviewerStatus', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ApplicationEvaluationID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ApplicationEvaluationRuleModel(options) {
        var defaults = {
            SortOrder: 0,
            AdmissionsProcessStageID: 0,
            ApplicationEvaluationCriteriaID: 0,
            RankingAlgorithmID: 0,
            RankingAlgorithmDateEntityFieldID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.AdmissionsProcessStageID = ko.validatedObservable(settings.AdmissionsProcessStageID);
        this.ApplicationEvaluationCriteriaID = ko.validatedObservable(settings.ApplicationEvaluationCriteriaID);
        this.RankingAlgorithmID = ko.validatedObservable(settings.RankingAlgorithmID);
        this.RankingAlgorithmDateEntityFieldID = ko.validatedObservable(settings.RankingAlgorithmDateEntityFieldID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AdmissionsProcessStage = ko.observable();
        this.ApplicationEvaluationCriteria = ko.observable();
        this.RankingAlgorithm = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.AdmissionsProcessStageID != undefined) {
                loaded.AdmissionsProcessStageID(responseData.AdmissionsProcessStageID);
            }
            if (responseData.ApplicationEvaluationCriteriaID != undefined) {
                loaded.ApplicationEvaluationCriteriaID(responseData.ApplicationEvaluationCriteriaID);
            }
            if (responseData.RankingAlgorithmID != undefined) {
                loaded.RankingAlgorithmID(responseData.RankingAlgorithmID);
            }
            if (responseData.RankingAlgorithmDateEntityFieldID != undefined) {
                loaded.RankingAlgorithmDateEntityFieldID(responseData.RankingAlgorithmDateEntityFieldID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AdmissionsProcessStage != null) {
                loaded.AdmissionsProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.AdmissionsProcessStage));
            }
            if (responseData.ApplicationEvaluationCriteria != null) {
                loaded.ApplicationEvaluationCriteria(new smapi.admissions.ApplicationEvaluationCriteriaModel().LoadFromResponse(responseData.ApplicationEvaluationCriteria));
            }
            if (responseData.RankingAlgorithm != null) {
                loaded.RankingAlgorithm(new smapi.admissions.RankingAlgorithmModel().LoadFromResponse(responseData.RankingAlgorithm));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.ApplicationEvaluationRule', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionsProcessStageID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ApplicationEvaluationCriteriaID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RankingAlgorithmID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RankingAlgorithmDateEntityFieldID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ApplicationEvaluationSetupModel(options) {
        var defaults = {
            CriteriaID: null,
            ReviewersAmount: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.CriteriaID = ko.validatedObservable(settings.CriteriaID);
        this.ReviewersAmount = ko.validatedObservable(settings.ReviewersAmount);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.ApplicationEvaluationSetupPrograms = ko.observableArray([]);
        this.ApplicationEvaluationSetupPeriods = ko.observableArray([]);
        this.ApplicationEvaluationCriteria = ko.observable();
        this.ApplicationEvaluationSetupCommitteeSettings = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.CriteriaID != undefined) {
                loaded.CriteriaID(responseData.CriteriaID);
            }
            if (responseData.ReviewersAmount != undefined) {
                loaded.ReviewersAmount(responseData.ReviewersAmount);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.ApplicationEvaluationSetupPrograms != null && responseData.ApplicationEvaluationSetupPrograms.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ApplicationEvaluationSetupPrograms.length; i++) {
                    items.push(new smapi.admissions.AdmissionsProgramModel().LoadFromResponse(responseData.ApplicationEvaluationSetupPrograms[i]));
                }
                loaded.ApplicationEvaluationSetupPrograms(items);
            }
            if (responseData.ApplicationEvaluationSetupPeriods != null && responseData.ApplicationEvaluationSetupPeriods.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ApplicationEvaluationSetupPeriods.length; i++) {
                    items.push(new smapi.admissions.AdmissionsPeriodModel().LoadFromResponse(responseData.ApplicationEvaluationSetupPeriods[i]));
                }
                loaded.ApplicationEvaluationSetupPeriods(items);
            }
            if (responseData.ApplicationEvaluationCriteria != null) {
                loaded.ApplicationEvaluationCriteria(new smapi.admissions.ApplicationEvaluationCriteriaModel().LoadFromResponse(responseData.ApplicationEvaluationCriteria));
            }
            if (responseData.ApplicationEvaluationSetupCommitteeSettings != null && responseData.ApplicationEvaluationSetupCommitteeSettings.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ApplicationEvaluationSetupCommitteeSettings.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationSetupCommitteeSettingsModel().LoadFromResponse(responseData.ApplicationEvaluationSetupCommitteeSettings[i]));
                }
                loaded.ApplicationEvaluationSetupCommitteeSettings(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.ApplicationEvaluationSetup', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.CriteriaID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ReviewersAmount.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: 0,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GreaterThan0_Key), '0')
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ApplicationEvaluationSetupCommitteeSettingsModel(options) {
        var defaults = {
            ApplicationEvaluationSetupID: 0,
            CommitteeSettingID: 0,
            IsMarked: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ApplicationEvaluationSetupID = ko.validatedObservable(settings.ApplicationEvaluationSetupID);
        this.CommitteeSettingID = ko.validatedObservable(settings.CommitteeSettingID);
        this.IsMarked = ko.validatedObservable(settings.IsMarked);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.ApplicationEvaluationSetup = ko.observable();
        this.CommitteeSettings = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ApplicationEvaluationSetupID != undefined) {
                loaded.ApplicationEvaluationSetupID(responseData.ApplicationEvaluationSetupID);
            }
            if (responseData.CommitteeSettingID != undefined) {
                loaded.CommitteeSettingID(responseData.CommitteeSettingID);
            }
            if (responseData.IsMarked != undefined) {
                loaded.IsMarked(responseData.IsMarked);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.ApplicationEvaluationSetup != null) {
                loaded.ApplicationEvaluationSetup(new smapi.admissions.ApplicationEvaluationSetupModel().LoadFromResponse(responseData.ApplicationEvaluationSetup));
            }
            if (responseData.CommitteeSettings != null) {
                loaded.CommitteeSettings(new smapi.admissions.CommitteeSettingsModel().LoadFromResponse(responseData.CommitteeSettings));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.ApplicationEvaluationSetupCommitteeSettings', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ApplicationEvaluationSetupID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CommitteeSettingID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.IsMarked.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ApplicationEvaluationStatusModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            IsReviewer: false,
            IsAdmissionOfficer: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.IsReviewer = ko.validatedObservable(settings.IsReviewer);
        this.IsAdmissionOfficer = ko.validatedObservable(settings.IsAdmissionOfficer);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.IsReviewer != undefined) {
                loaded.IsReviewer(responseData.IsReviewer);
            }
            if (responseData.IsAdmissionOfficer != undefined) {
                loaded.IsAdmissionOfficer(responseData.IsAdmissionOfficer);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.ApplicationEvaluationStatus', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.IsReviewer.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.IsAdmissionOfficer.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ApplicationEvaluationWeightModel(options) {
        var defaults = {
            Weight: 0,
            AdmissionsProcessStageAttributesID: 0,
            ApplicationEvaluationCriteriaID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Weight = ko.validatedObservable(settings.Weight);
        this.AdmissionsProcessStageAttributesID = ko.validatedObservable(settings.AdmissionsProcessStageAttributesID);
        this.ApplicationEvaluationCriteriaID = ko.validatedObservable(settings.ApplicationEvaluationCriteriaID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AdmissionsProcessStageAttributes = ko.observable();
        this.ApplicationEvaluationCriteria = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Weight != undefined) {
                loaded.Weight(responseData.Weight);
            }
            if (responseData.AdmissionsProcessStageAttributesID != undefined) {
                loaded.AdmissionsProcessStageAttributesID(responseData.AdmissionsProcessStageAttributesID);
            }
            if (responseData.ApplicationEvaluationCriteriaID != undefined) {
                loaded.ApplicationEvaluationCriteriaID(responseData.ApplicationEvaluationCriteriaID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AdmissionsProcessStageAttributes != null) {
                loaded.AdmissionsProcessStageAttributes(new smapi.admissions.AdmissionsProcessStageAttributesModel().LoadFromResponse(responseData.AdmissionsProcessStageAttributes));
            }
            if (responseData.ApplicationEvaluationCriteria != null) {
                loaded.ApplicationEvaluationCriteria(new smapi.admissions.ApplicationEvaluationCriteriaModel().LoadFromResponse(responseData.ApplicationEvaluationCriteria));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.ApplicationEvaluationWeight', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Weight.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionsProcessStageAttributesID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ApplicationEvaluationCriteriaID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ApplicationStudentSurveyModel(options) {
        var defaults = {
            PersonID: 0,
            Parent4YearCollegeAttended: false,
            WorkHourPlansID: null,
            ChoiceRankID: null,
            PriorAttendanceID: null,
            DataStepID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.Parent4YearCollegeAttended = ko.validatedObservable(settings.Parent4YearCollegeAttended);
        this.WorkHourPlansID = ko.validatedObservable(settings.WorkHourPlansID);
        this.ChoiceRankID = ko.validatedObservable(settings.ChoiceRankID);
        this.PriorAttendanceID = ko.validatedObservable(settings.PriorAttendanceID);
        this.DataStepID = ko.validatedObservable(settings.DataStepID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.DataStep = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.Parent4YearCollegeAttended != undefined) {
                loaded.Parent4YearCollegeAttended(responseData.Parent4YearCollegeAttended);
            }
            if (responseData.WorkHourPlansID != undefined) {
                loaded.WorkHourPlansID(responseData.WorkHourPlansID);
            }
            if (responseData.ChoiceRankID != undefined) {
                loaded.ChoiceRankID(responseData.ChoiceRankID);
            }
            if (responseData.PriorAttendanceID != undefined) {
                loaded.PriorAttendanceID(responseData.PriorAttendanceID);
            }
            if (responseData.DataStepID != undefined) {
                loaded.DataStepID(responseData.DataStepID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.DataStep != null) {
                loaded.DataStep(new smapi.admissions.ApplicationStudentSurveyStepModel().LoadFromResponse(responseData.DataStep));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.ApplicationStudentSurvey', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Parent4YearCollegeAttended.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.WorkHourPlansID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ChoiceRankID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PriorAttendanceID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DataStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ApplicationStudentSurveyStepModel(options) {
        var defaults = {
            ClassType: 0,
            Comments: '',
            AdmissionsAttemptID: 0,
            ProcessStageID: null,
            ParentStepID: null,
            StatusID: 0,
            RequiredOptionID: null,
            StepStartDate: null,
            StepEndDate: null,
            NavigatorScreenPath: '',
            ExpectedStepEndDate: null,
            AdHoc: false,
            ProgressOveridden: false,
            ExternalStage: false,
            MinExternalData: 0,
            MaxExternalData: 0,
            DueDate: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.Comments = ko.validatedObservable(settings.Comments);
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.ProcessStageID = ko.validatedObservable(settings.ProcessStageID);
        this.ParentStepID = ko.validatedObservable(settings.ParentStepID);
        this.StatusID = ko.validatedObservable(settings.StatusID);
        this.RequiredOptionID = ko.validatedObservable(settings.RequiredOptionID);
        this.StepStartDate = ko.validatedObservable(settings.StepStartDate);
        this.StepEndDate = ko.validatedObservable(settings.StepEndDate);
        this.NavigatorScreenPath = ko.validatedObservable(settings.NavigatorScreenPath);
        this.ExpectedStepEndDate = ko.validatedObservable(settings.ExpectedStepEndDate);
        this.AdHoc = ko.validatedObservable(settings.AdHoc);
        this.ProgressOveridden = ko.validatedObservable(settings.ProgressOveridden);
        this.ExternalStage = ko.validatedObservable(settings.ExternalStage);
        this.MinExternalData = ko.validatedObservable(settings.MinExternalData);
        this.MaxExternalData = ko.validatedObservable(settings.MaxExternalData);
        this.DueDate = ko.validatedObservable(settings.DueDate);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.ApplicationStudentSurveys = ko.observableArray([]);
        this.AdmissionsAttempt = ko.observable();
        this.ProcessStage = ko.observable();
        this.ReviewerComments = ko.observableArray([]);
        this.ExternalData = ko.observableArray([]);
        this.Parent = ko.observable();
        this.ChildSteps = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.Comments != undefined) {
                loaded.Comments(responseData.Comments);
            }
            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.ProcessStageID != undefined) {
                loaded.ProcessStageID(responseData.ProcessStageID);
            }
            if (responseData.ParentStepID != undefined) {
                loaded.ParentStepID(responseData.ParentStepID);
            }
            if (responseData.StatusID != undefined) {
                loaded.StatusID(responseData.StatusID);
            }
            if (responseData.RequiredOptionID != undefined) {
                loaded.RequiredOptionID(responseData.RequiredOptionID);
            }
            if (responseData.StepStartDate != undefined) {
                loaded.StepStartDate(responseData.StepStartDate);
            }
            if (responseData.StepEndDate != undefined) {
                loaded.StepEndDate(responseData.StepEndDate);
            }
            if (responseData.NavigatorScreenPath != undefined) {
                loaded.NavigatorScreenPath(responseData.NavigatorScreenPath);
            }
            if (responseData.ExpectedStepEndDate != undefined) {
                loaded.ExpectedStepEndDate(responseData.ExpectedStepEndDate);
            }
            if (responseData.AdHoc != undefined) {
                loaded.AdHoc(responseData.AdHoc);
            }
            if (responseData.ProgressOveridden != undefined) {
                loaded.ProgressOveridden(responseData.ProgressOveridden);
            }
            if (responseData.ExternalStage != undefined) {
                loaded.ExternalStage(responseData.ExternalStage);
            }
            if (responseData.MinExternalData != undefined) {
                loaded.MinExternalData(responseData.MinExternalData);
            }
            if (responseData.MaxExternalData != undefined) {
                loaded.MaxExternalData(responseData.MaxExternalData);
            }
            if (responseData.DueDate != undefined) {
                loaded.DueDate(responseData.DueDate);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.ApplicationStudentSurveys != null && responseData.ApplicationStudentSurveys.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ApplicationStudentSurveys.length; i++) {
                    items.push(new smapi.admissions.ApplicationStudentSurveyModel().LoadFromResponse(responseData.ApplicationStudentSurveys[i]));
                }
                loaded.ApplicationStudentSurveys(items);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }
            if (responseData.ProcessStage != null) {
                loaded.ProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.ProcessStage));
            }
            if (responseData.ReviewerComments != null && responseData.ReviewerComments.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ReviewerComments.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationCommentModel().LoadFromResponse(responseData.ReviewerComments[i]));
                }
                loaded.ReviewerComments(items);
            }
            if (responseData.ExternalData != null && responseData.ExternalData.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ExternalData.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepDataModel().LoadFromResponse(responseData.ExternalData[i]));
                }
                loaded.ExternalData(items);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.ChildSteps != null && responseData.ChildSteps.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ChildSteps.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.ChildSteps[i]));
                }
                loaded.ChildSteps(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.ApplicationStudentSurveyStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Comments.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProcessStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RequiredOptionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StepStartDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.StepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.NavigatorScreenPath.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ExpectedStepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AdHoc.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ExternalStage.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.MinExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MaxExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DueDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AthleticProgramModel(options) {
        var defaults = {
            Participates: false,
            MensProgramID: null,
            WomensProgramID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Participates = ko.validatedObservable(settings.Participates);
        this.MensProgramID = ko.validatedObservable(settings.MensProgramID);
        this.WomensProgramID = ko.validatedObservable(settings.WomensProgramID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Participates != undefined) {
                loaded.Participates(responseData.Participates);
            }
            if (responseData.MensProgramID != undefined) {
                loaded.MensProgramID(responseData.MensProgramID);
            }
            if (responseData.WomensProgramID != undefined) {
                loaded.WomensProgramID(responseData.WomensProgramID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AthleticProgram', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Participates.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.MensProgramID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.WomensProgramID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CollegeInformationModel(options) {
        var defaults = {
            PersonID: 0,
            CollegeName: '',
            CollegeID: null,
            TranscriptEvalStatusID: null,
            StudentID: '',
            CreditsEarned: 0,
            CreditsTransferred: 0,
            GradePoint: 0,
            GradePointOf: 0,
            StartDate: null,
            EndDate: null,
            ConferralDate: null,
            CollegeTypeID: null,
            Comments: '',
            SemesterTypeID: null,
            StatusID: null,
            TranscriptDocumentID: null,
            I20DocumentID: null,
            AdmissionsAcademicLevelID: null,
            PersonAcademicGoalID: null,
            EducationalGoal: '',
            DataStepID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
            ProgramName: null,
            CredentialID: null,
            City: null
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.CollegeName = ko.validatedObservable(settings.CollegeName);
        this.CollegeID = ko.validatedObservable(settings.CollegeID);
        this.TranscriptEvalStatusID = ko.validatedObservable(settings.TranscriptEvalStatusID);
        this.StudentID = ko.validatedObservable(settings.StudentID);
        this.CreditsEarned = ko.validatedObservable(settings.CreditsEarned);
        this.CreditsTransferred = ko.validatedObservable(settings.CreditsTransferred);
        this.GradePoint = ko.validatedObservable(settings.GradePoint);
        this.GradePointOf = ko.validatedObservable(settings.GradePointOf);
        this.StartDate = ko.validatedObservable(settings.StartDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.ConferralDate = ko.validatedObservable(settings.ConferralDate);
        this.CollegeTypeID = ko.validatedObservable(settings.CollegeTypeID);
        this.Comments = ko.validatedObservable(settings.Comments);
        this.SemesterTypeID = ko.validatedObservable(settings.SemesterTypeID);
        this.StatusID = ko.validatedObservable(settings.StatusID);
        this.TranscriptDocumentID = ko.validatedObservable(settings.TranscriptDocumentID);
        this.I20DocumentID = ko.validatedObservable(settings.I20DocumentID);
        this.AdmissionsAcademicLevelID = ko.validatedObservable(settings.AdmissionsAcademicLevelID);
        this.PersonAcademicGoalID = ko.validatedObservable(settings.PersonAcademicGoalID);
        this.EducationalGoal = ko.validatedObservable(settings.EducationalGoal);
        this.DataStepID = ko.validatedObservable(settings.DataStepID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        // New fields added only for APAS
        this.ProgramName = ko.validatedObservable(settings.ProgramName);
        this.CredentialID = ko.validatedObservable(settings.CredentialID);
        this.City = ko.validatedObservable(settings.City);
        
        // Relationships as Observables and ObservableArrays
        this.PersonAcademicGoal = ko.observable();
        this.Person = ko.observable();
        this.College = ko.observable();
        this.DataStep = ko.observable();
        this.SemesterType = ko.observable();
        this.TranscriptDocument = ko.observable();
        this.I20Document = ko.observable();
        this.AdmissionsAcademicLevel = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.CollegeName != undefined) {
                loaded.CollegeName(responseData.CollegeName);
            }
            if (responseData.CollegeID != undefined) {
                loaded.CollegeID(responseData.CollegeID);
            }
            if (responseData.TranscriptEvalStatusID != undefined) {
                loaded.TranscriptEvalStatusID(responseData.TranscriptEvalStatusID);
            }
            if (responseData.StudentID != undefined) {
                loaded.StudentID(responseData.StudentID);
            }
            if (responseData.CreditsEarned != undefined) {
                loaded.CreditsEarned(responseData.CreditsEarned);
            }
            if (responseData.CreditsTransferred != undefined) {
                loaded.CreditsTransferred(responseData.CreditsTransferred);
            }
            if (responseData.GradePoint != undefined) {
                loaded.GradePoint(responseData.GradePoint);
            }
            if (responseData.GradePointOf != undefined) {
                loaded.GradePointOf(responseData.GradePointOf);
            }
            if (responseData.StartDate != undefined) {
                loaded.StartDate(responseData.StartDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.ConferralDate != undefined) {
                loaded.ConferralDate(responseData.ConferralDate);
            }
            if (responseData.CollegeTypeID != undefined) {
                loaded.CollegeTypeID(responseData.CollegeTypeID);
            }
            if (responseData.Comments != undefined) {
                loaded.Comments(responseData.Comments);
            }
            if (responseData.SemesterTypeID != undefined) {
                loaded.SemesterTypeID(responseData.SemesterTypeID);
            }
            if (responseData.StatusID != undefined) {
                loaded.StatusID(responseData.StatusID);
            }
            if (responseData.TranscriptDocumentID != undefined) {
                loaded.TranscriptDocumentID(responseData.TranscriptDocumentID);
            }
            if (responseData.I20DocumentID != undefined) {
                loaded.I20DocumentID(responseData.I20DocumentID);
            }
            if (responseData.AdmissionsAcademicLevelID != undefined) {
                loaded.AdmissionsAcademicLevelID(responseData.AdmissionsAcademicLevelID);
            }
            if (responseData.PersonAcademicGoalID != undefined) {
                loaded.PersonAcademicGoalID(responseData.PersonAcademicGoalID);
            }
            if (responseData.EducationalGoal != undefined) {
                loaded.EducationalGoal(responseData.EducationalGoal);
            }
            if (responseData.DataStepID != undefined) {
                loaded.DataStepID(responseData.DataStepID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.PersonAcademicGoal != null) {
                loaded.PersonAcademicGoal(new smapi.academic.PersonAcademicGoalModel().LoadFromResponse(responseData.PersonAcademicGoal));
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.College != null) {
                loaded.College(new smapi.academic.CollegeModel().LoadFromResponse(responseData.College));
            }
            if (responseData.DataStep != null) {
                loaded.DataStep(new smapi.admissions.CollegeInformationStepModel().LoadFromResponse(responseData.DataStep));
            }
            if (responseData.SemesterType != null) {
                loaded.SemesterType(new smapi.admissions.CollegeSemesterTypeModel().LoadFromResponse(responseData.SemesterType));
            }
            if (responseData.TranscriptDocument != null && responseData.TranscriptDocument != undefined ) {
                loaded.TranscriptDocument(new smapi.admissions.TranscriptDocumentModel().LoadFromResponse(responseData.TranscriptDocument));
            }
            if (responseData.I20Document != null) {
                loaded.I20Document(new smapi.admissions.AdmissionsDocumentModel().LoadFromResponse(responseData.I20Document));
            }
            if (responseData.AdmissionsAcademicLevel != null) {
                loaded.AdmissionsAcademicLevel(new smapi.admissions.AdmissionsAcademicLevelModel().LoadFromResponse(responseData.AdmissionsAcademicLevel));
            }
            if (responseData.ProgramName != undefined) {
                loaded.ProgramName(responseData.ProgramName);
            }
            if (responseData.CredentialID != undefined) {
                loaded.CredentialID(responseData.CredentialID);
            }
            if (responseData.City != undefined) {
                loaded.City(responseData.City);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.CollegeInformation', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CollegeName.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.CollegeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TranscriptEvalStatusID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StudentID.extend({
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.CreditsEarned.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CreditsTransferred.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GradePoint.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GradePointOf.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StartDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ConferralDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.CollegeTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Comments.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SemesterTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StatusID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TranscriptDocumentID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.I20DocumentID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionsAcademicLevelID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PersonAcademicGoalID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EducationalGoal.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.DataStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CollegeInformationGoalModel(options) {
        var defaults = {
            AdmissionsEducationalGoalID: null,
            Program: '',
            CollegeInformationID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.AdmissionsEducationalGoalID = ko.validatedObservable(settings.AdmissionsEducationalGoalID);
        this.Program = ko.validatedObservable(settings.Program);
        this.CollegeInformationID = ko.validatedObservable(settings.CollegeInformationID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.CollegeInformation = ko.observable();
        this.AdmissionsEducationalGoal = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.AdmissionsEducationalGoalID != undefined) {
                loaded.AdmissionsEducationalGoalID(responseData.AdmissionsEducationalGoalID);
            }
            if (responseData.Program != undefined) {
                loaded.Program(responseData.Program);
            }
            if (responseData.CollegeInformationID != undefined) {
                loaded.CollegeInformationID(responseData.CollegeInformationID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.CollegeInformation != null) {
                loaded.CollegeInformation(new smapi.admissions.CollegeInformationModel().LoadFromResponse(responseData.CollegeInformation));
            }
            if (responseData.AdmissionsEducationalGoal != null) {
                loaded.AdmissionsEducationalGoal(new smapi.admissions.AdmissionsEducationalGoalModel().LoadFromResponse(responseData.AdmissionsEducationalGoal));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.CollegeInformationGoal', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.AdmissionsEducationalGoalID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Program.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.CollegeInformationID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CollegeInformationStepModel(options) {
        var defaults = {
            ClassType: 0,
            Comments: '',
            AdmissionsAttemptID: 0,
            ProcessStageID: null,
            ParentStepID: null,
            StatusID: 0,
            RequiredOptionID: null,
            StepStartDate: null,
            StepEndDate: null,
            NavigatorScreenPath: '',
            ExpectedStepEndDate: null,
            AdHoc: false,
            ProgressOveridden: false,
            ExternalStage: false,
            MinExternalData: 0,
            MaxExternalData: 0,
            DueDate: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.Comments = ko.validatedObservable(settings.Comments);
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.ProcessStageID = ko.validatedObservable(settings.ProcessStageID);
        this.ParentStepID = ko.validatedObservable(settings.ParentStepID);
        this.StatusID = ko.validatedObservable(settings.StatusID);
        this.RequiredOptionID = ko.validatedObservable(settings.RequiredOptionID);
        this.StepStartDate = ko.validatedObservable(settings.StepStartDate);
        this.StepEndDate = ko.validatedObservable(settings.StepEndDate);
        this.NavigatorScreenPath = ko.validatedObservable(settings.NavigatorScreenPath);
        this.ExpectedStepEndDate = ko.validatedObservable(settings.ExpectedStepEndDate);
        this.AdHoc = ko.validatedObservable(settings.AdHoc);
        this.ProgressOveridden = ko.validatedObservable(settings.ProgressOveridden);
        this.ExternalStage = ko.validatedObservable(settings.ExternalStage);
        this.MinExternalData = ko.validatedObservable(settings.MinExternalData);
        this.MaxExternalData = ko.validatedObservable(settings.MaxExternalData);
        this.DueDate = ko.validatedObservable(settings.DueDate);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.CollegeDetails = ko.observableArray([]);
        this.AdmissionsAttempt = ko.observable();
        this.ProcessStage = ko.observable();
        this.ReviewerComments = ko.observableArray([]);
        this.ExternalData = ko.observableArray([]);
        this.Parent = ko.observable();
        this.ChildSteps = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.Comments != undefined) {
                loaded.Comments(responseData.Comments);
            }
            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.ProcessStageID != undefined) {
                loaded.ProcessStageID(responseData.ProcessStageID);
            }
            if (responseData.ParentStepID != undefined) {
                loaded.ParentStepID(responseData.ParentStepID);
            }
            if (responseData.StatusID != undefined) {
                loaded.StatusID(responseData.StatusID);
            }
            if (responseData.RequiredOptionID != undefined) {
                loaded.RequiredOptionID(responseData.RequiredOptionID);
            }
            if (responseData.StepStartDate != undefined) {
                loaded.StepStartDate(responseData.StepStartDate);
            }
            if (responseData.StepEndDate != undefined) {
                loaded.StepEndDate(responseData.StepEndDate);
            }
            if (responseData.NavigatorScreenPath != undefined) {
                loaded.NavigatorScreenPath(responseData.NavigatorScreenPath);
            }
            if (responseData.ExpectedStepEndDate != undefined) {
                loaded.ExpectedStepEndDate(responseData.ExpectedStepEndDate);
            }
            if (responseData.AdHoc != undefined) {
                loaded.AdHoc(responseData.AdHoc);
            }
            if (responseData.ProgressOveridden != undefined) {
                loaded.ProgressOveridden(responseData.ProgressOveridden);
            }
            if (responseData.ExternalStage != undefined) {
                loaded.ExternalStage(responseData.ExternalStage);
            }
            if (responseData.MinExternalData != undefined) {
                loaded.MinExternalData(responseData.MinExternalData);
            }
            if (responseData.MaxExternalData != undefined) {
                loaded.MaxExternalData(responseData.MaxExternalData);
            }
            if (responseData.DueDate != undefined) {
                loaded.DueDate(responseData.DueDate);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.CollegeDetails != null && responseData.CollegeDetails.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.CollegeDetails.length; i++) {
                    items.push(new smapi.admissions.CollegeInformationModel().LoadFromResponse(responseData.CollegeDetails[i]));
                }
                loaded.CollegeDetails(items);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }
            if (responseData.ProcessStage != null) {
                loaded.ProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.ProcessStage));
            }
            if (responseData.ReviewerComments != null && responseData.ReviewerComments.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ReviewerComments.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationCommentModel().LoadFromResponse(responseData.ReviewerComments[i]));
                }
                loaded.ReviewerComments(items);
            }
            if (responseData.ExternalData != null && responseData.ExternalData.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ExternalData.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepDataModel().LoadFromResponse(responseData.ExternalData[i]));
                }
                loaded.ExternalData(items);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.ChildSteps != null && responseData.ChildSteps.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ChildSteps.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.ChildSteps[i]));
                }
                loaded.ChildSteps(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.CollegeInformationStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Comments.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProcessStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RequiredOptionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StepStartDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.StepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.NavigatorScreenPath.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ExpectedStepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AdHoc.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ExternalStage.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.MinExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MaxExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DueDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CollegeSemesterTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            CreditFactor: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.CreditFactor = ko.validatedObservable(settings.CreditFactor);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.CreditFactor != undefined) {
                loaded.CreditFactor(responseData.CreditFactor);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.CollegeSemesterType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.CreditFactor.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CommitteeSettingsModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            CommitteeSettingsType: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.CommitteeSettingsType = ko.validatedObservable(settings.CommitteeSettingsType);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.ApplicationEvaluationSetupCommitteeSettings = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.CommitteeSettingsType != undefined) {
                loaded.CommitteeSettingsType(responseData.CommitteeSettingsType);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.ApplicationEvaluationSetupCommitteeSettings != null && responseData.ApplicationEvaluationSetupCommitteeSettings.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ApplicationEvaluationSetupCommitteeSettings.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationSetupCommitteeSettingsModel().LoadFromResponse(responseData.ApplicationEvaluationSetupCommitteeSettings[i]));
                }
                loaded.ApplicationEvaluationSetupCommitteeSettings(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.CommitteeSettings', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.CommitteeSettingsType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CriterionModel(options) {
        var defaults = {
            PersonID: 0,
            TestDate: null,
            Score: 0,
            SourceID: null,
            StateID: null,
            DataStepID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.TestDate = ko.validatedObservable(settings.TestDate);
        this.Score = ko.validatedObservable(settings.Score);
        this.SourceID = ko.validatedObservable(settings.SourceID);
        this.StateID = ko.validatedObservable(settings.StateID);
        this.DataStepID = ko.validatedObservable(settings.DataStepID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.DataStep = ko.observable();
        this.GoverningDistrict = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.TestDate != undefined) {
                loaded.TestDate(responseData.TestDate);
            }
            if (responseData.Score != undefined) {
                loaded.Score(responseData.Score);
            }
            if (responseData.SourceID != undefined) {
                loaded.SourceID(responseData.SourceID);
            }
            if (responseData.StateID != undefined) {
                loaded.StateID(responseData.StateID);
            }
            if (responseData.DataStepID != undefined) {
                loaded.DataStepID(responseData.DataStepID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.DataStep != null) {
                loaded.DataStep(new smapi.admissions.CriterionStepModel().LoadFromResponse(responseData.DataStep));
            }
            if (responseData.GoverningDistrict != null) {
                loaded.GoverningDistrict(new smapi.community.GoverningDistrictModel().LoadFromResponse(responseData.GoverningDistrict));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.Criterion', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TestDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.Score.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SourceID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StateID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DataStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CriterionStepModel(options) {
        var defaults = {
            ClassType: 0,
            Comments: '',
            AdmissionsAttemptID: 0,
            ProcessStageID: null,
            ParentStepID: null,
            StatusID: 0,
            RequiredOptionID: null,
            StepStartDate: null,
            StepEndDate: null,
            NavigatorScreenPath: '',
            ExpectedStepEndDate: null,
            AdHoc: false,
            ProgressOveridden: false,
            ExternalStage: false,
            MinExternalData: 0,
            MaxExternalData: 0,
            DueDate: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.Comments = ko.validatedObservable(settings.Comments);
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.ProcessStageID = ko.validatedObservable(settings.ProcessStageID);
        this.ParentStepID = ko.validatedObservable(settings.ParentStepID);
        this.StatusID = ko.validatedObservable(settings.StatusID);
        this.RequiredOptionID = ko.validatedObservable(settings.RequiredOptionID);
        this.StepStartDate = ko.validatedObservable(settings.StepStartDate);
        this.StepEndDate = ko.validatedObservable(settings.StepEndDate);
        this.NavigatorScreenPath = ko.validatedObservable(settings.NavigatorScreenPath);
        this.ExpectedStepEndDate = ko.validatedObservable(settings.ExpectedStepEndDate);
        this.AdHoc = ko.validatedObservable(settings.AdHoc);
        this.ProgressOveridden = ko.validatedObservable(settings.ProgressOveridden);
        this.ExternalStage = ko.validatedObservable(settings.ExternalStage);
        this.MinExternalData = ko.validatedObservable(settings.MinExternalData);
        this.MaxExternalData = ko.validatedObservable(settings.MaxExternalData);
        this.DueDate = ko.validatedObservable(settings.DueDate);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.CriterionTestScores = ko.observableArray([]);
        this.AdmissionsAttempt = ko.observable();
        this.ProcessStage = ko.observable();
        this.ReviewerComments = ko.observableArray([]);
        this.ExternalData = ko.observableArray([]);
        this.Parent = ko.observable();
        this.ChildSteps = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.Comments != undefined) {
                loaded.Comments(responseData.Comments);
            }
            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.ProcessStageID != undefined) {
                loaded.ProcessStageID(responseData.ProcessStageID);
            }
            if (responseData.ParentStepID != undefined) {
                loaded.ParentStepID(responseData.ParentStepID);
            }
            if (responseData.StatusID != undefined) {
                loaded.StatusID(responseData.StatusID);
            }
            if (responseData.RequiredOptionID != undefined) {
                loaded.RequiredOptionID(responseData.RequiredOptionID);
            }
            if (responseData.StepStartDate != undefined) {
                loaded.StepStartDate(responseData.StepStartDate);
            }
            if (responseData.StepEndDate != undefined) {
                loaded.StepEndDate(responseData.StepEndDate);
            }
            if (responseData.NavigatorScreenPath != undefined) {
                loaded.NavigatorScreenPath(responseData.NavigatorScreenPath);
            }
            if (responseData.ExpectedStepEndDate != undefined) {
                loaded.ExpectedStepEndDate(responseData.ExpectedStepEndDate);
            }
            if (responseData.AdHoc != undefined) {
                loaded.AdHoc(responseData.AdHoc);
            }
            if (responseData.ProgressOveridden != undefined) {
                loaded.ProgressOveridden(responseData.ProgressOveridden);
            }
            if (responseData.ExternalStage != undefined) {
                loaded.ExternalStage(responseData.ExternalStage);
            }
            if (responseData.MinExternalData != undefined) {
                loaded.MinExternalData(responseData.MinExternalData);
            }
            if (responseData.MaxExternalData != undefined) {
                loaded.MaxExternalData(responseData.MaxExternalData);
            }
            if (responseData.DueDate != undefined) {
                loaded.DueDate(responseData.DueDate);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.CriterionTestScores != null && responseData.CriterionTestScores.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.CriterionTestScores.length; i++) {
                    items.push(new smapi.admissions.CriterionModel().LoadFromResponse(responseData.CriterionTestScores[i]));
                }
                loaded.CriterionTestScores(items);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }
            if (responseData.ProcessStage != null) {
                loaded.ProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.ProcessStage));
            }
            if (responseData.ReviewerComments != null && responseData.ReviewerComments.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ReviewerComments.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationCommentModel().LoadFromResponse(responseData.ReviewerComments[i]));
                }
                loaded.ReviewerComments(items);
            }
            if (responseData.ExternalData != null && responseData.ExternalData.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ExternalData.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepDataModel().LoadFromResponse(responseData.ExternalData[i]));
                }
                loaded.ExternalData(items);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.ChildSteps != null && responseData.ChildSteps.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ChildSteps.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.ChildSteps[i]));
                }
                loaded.ChildSteps(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.CriterionStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Comments.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProcessStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RequiredOptionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StepStartDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.StepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.NavigatorScreenPath.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ExpectedStepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AdHoc.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ExternalStage.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.MinExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MaxExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DueDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function EssayModel(options) {
        var defaults = {
            PersonID: 0,
            EssayText: '',
            DataStepID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.EssayText = ko.validatedObservable(settings.EssayText);
        this.DataStepID = ko.validatedObservable(settings.DataStepID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.DataStep = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.EssayText != undefined) {
                loaded.EssayText(responseData.EssayText);
            }
            if (responseData.DataStepID != undefined) {
                loaded.DataStepID(responseData.DataStepID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.DataStep != null) {
                loaded.DataStep(new smapi.admissions.EssayStepModel().LoadFromResponse(responseData.DataStep));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.Essay', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EssayText.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.DataStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function EssayStepModel(options) {
        var defaults = {
            ClassType: 0,
            Comments: '',
            AdmissionsAttemptID: 0,
            ProcessStageID: null,
            ParentStepID: null,
            StatusID: 0,
            RequiredOptionID: null,
            StepStartDate: null,
            StepEndDate: null,
            NavigatorScreenPath: '',
            ExpectedStepEndDate: null,
            AdHoc: false,
            ProgressOveridden: false,
            ExternalStage: false,
            MinExternalData: 0,
            MaxExternalData: 0,
            DueDate: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.Comments = ko.validatedObservable(settings.Comments);
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.ProcessStageID = ko.validatedObservable(settings.ProcessStageID);
        this.ParentStepID = ko.validatedObservable(settings.ParentStepID);
        this.StatusID = ko.validatedObservable(settings.StatusID);
        this.RequiredOptionID = ko.validatedObservable(settings.RequiredOptionID);
        this.StepStartDate = ko.validatedObservable(settings.StepStartDate);
        this.StepEndDate = ko.validatedObservable(settings.StepEndDate);
        this.NavigatorScreenPath = ko.validatedObservable(settings.NavigatorScreenPath);
        this.ExpectedStepEndDate = ko.validatedObservable(settings.ExpectedStepEndDate);
        this.AdHoc = ko.validatedObservable(settings.AdHoc);
        this.ProgressOveridden = ko.validatedObservable(settings.ProgressOveridden);
        this.ExternalStage = ko.validatedObservable(settings.ExternalStage);
        this.MinExternalData = ko.validatedObservable(settings.MinExternalData);
        this.MaxExternalData = ko.validatedObservable(settings.MaxExternalData);
        this.DueDate = ko.validatedObservable(settings.DueDate);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Essays = ko.observableArray([]);
        this.AdmissionsAttempt = ko.observable();
        this.ProcessStage = ko.observable();
        this.ReviewerComments = ko.observableArray([]);
        this.ExternalData = ko.observableArray([]);
        this.Parent = ko.observable();
        this.ChildSteps = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.Comments != undefined) {
                loaded.Comments(responseData.Comments);
            }
            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.ProcessStageID != undefined) {
                loaded.ProcessStageID(responseData.ProcessStageID);
            }
            if (responseData.ParentStepID != undefined) {
                loaded.ParentStepID(responseData.ParentStepID);
            }
            if (responseData.StatusID != undefined) {
                loaded.StatusID(responseData.StatusID);
            }
            if (responseData.RequiredOptionID != undefined) {
                loaded.RequiredOptionID(responseData.RequiredOptionID);
            }
            if (responseData.StepStartDate != undefined) {
                loaded.StepStartDate(responseData.StepStartDate);
            }
            if (responseData.StepEndDate != undefined) {
                loaded.StepEndDate(responseData.StepEndDate);
            }
            if (responseData.NavigatorScreenPath != undefined) {
                loaded.NavigatorScreenPath(responseData.NavigatorScreenPath);
            }
            if (responseData.ExpectedStepEndDate != undefined) {
                loaded.ExpectedStepEndDate(responseData.ExpectedStepEndDate);
            }
            if (responseData.AdHoc != undefined) {
                loaded.AdHoc(responseData.AdHoc);
            }
            if (responseData.ProgressOveridden != undefined) {
                loaded.ProgressOveridden(responseData.ProgressOveridden);
            }
            if (responseData.ExternalStage != undefined) {
                loaded.ExternalStage(responseData.ExternalStage);
            }
            if (responseData.MinExternalData != undefined) {
                loaded.MinExternalData(responseData.MinExternalData);
            }
            if (responseData.MaxExternalData != undefined) {
                loaded.MaxExternalData(responseData.MaxExternalData);
            }
            if (responseData.DueDate != undefined) {
                loaded.DueDate(responseData.DueDate);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Essays != null && responseData.Essays.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Essays.length; i++) {
                    items.push(new smapi.admissions.EssayModel().LoadFromResponse(responseData.Essays[i]));
                }
                loaded.Essays(items);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }
            if (responseData.ProcessStage != null) {
                loaded.ProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.ProcessStage));
            }
            if (responseData.ReviewerComments != null && responseData.ReviewerComments.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ReviewerComments.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationCommentModel().LoadFromResponse(responseData.ReviewerComments[i]));
                }
                loaded.ReviewerComments(items);
            }
            if (responseData.ExternalData != null && responseData.ExternalData.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ExternalData.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepDataModel().LoadFromResponse(responseData.ExternalData[i]));
                }
                loaded.ExternalData(items);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.ChildSteps != null && responseData.ChildSteps.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ChildSteps.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.ChildSteps[i]));
                }
                loaded.ChildSteps(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.EssayStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Comments.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProcessStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RequiredOptionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StepStartDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.StepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.NavigatorScreenPath.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ExpectedStepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AdHoc.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ExternalStage.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.MinExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MaxExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DueDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ExternalAdmissionsProgramOfferingIDModel(options) {
        var defaults = {
            ExternalSystem: '',
            ExternalEntity: '',
            ExternalID: 0,
            AdmissionsProgramOfferingID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ExternalSystem = ko.validatedObservable(settings.ExternalSystem);
        this.ExternalEntity = ko.validatedObservable(settings.ExternalEntity);
        this.ExternalID = ko.validatedObservable(settings.ExternalID);
        this.AdmissionsProgramOfferingID = ko.validatedObservable(settings.AdmissionsProgramOfferingID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Offering = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ExternalSystem != undefined) {
                loaded.ExternalSystem(responseData.ExternalSystem);
            }
            if (responseData.ExternalEntity != undefined) {
                loaded.ExternalEntity(responseData.ExternalEntity);
            }
            if (responseData.ExternalID != undefined) {
                loaded.ExternalID(responseData.ExternalID);
            }
            if (responseData.AdmissionsProgramOfferingID != undefined) {
                loaded.AdmissionsProgramOfferingID(responseData.AdmissionsProgramOfferingID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Offering != null) {
                loaded.Offering(new smapi.admissions.AdmissionsProgramOfferingModel().LoadFromResponse(responseData.Offering));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.ExternalAdmissionsProgramOfferingID', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ExternalSystem.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ExternalEntity.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ExternalID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionsProgramOfferingID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ExternalAdmissionsProgramOfferingItemIDModel(options) {
        var defaults = {
            ExternalSystem: '',
            ExternalEntity: '',
            ExternalID: 0,
            AdmissionsProgramOfferingItemID: 0,
            AcademicProgramID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ExternalSystem = ko.validatedObservable(settings.ExternalSystem);
        this.ExternalEntity = ko.validatedObservable(settings.ExternalEntity);
        this.ExternalID = ko.validatedObservable(settings.ExternalID);
        this.AdmissionsProgramOfferingItemID = ko.validatedObservable(settings.AdmissionsProgramOfferingItemID);
        this.AcademicProgramID = ko.validatedObservable(settings.AcademicProgramID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AcademicProgram = ko.observable();
        this.OfferingItem = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ExternalSystem != undefined) {
                loaded.ExternalSystem(responseData.ExternalSystem);
            }
            if (responseData.ExternalEntity != undefined) {
                loaded.ExternalEntity(responseData.ExternalEntity);
            }
            if (responseData.ExternalID != undefined) {
                loaded.ExternalID(responseData.ExternalID);
            }
            if (responseData.AdmissionsProgramOfferingItemID != undefined) {
                loaded.AdmissionsProgramOfferingItemID(responseData.AdmissionsProgramOfferingItemID);
            }
            if (responseData.AcademicProgramID != undefined) {
                loaded.AcademicProgramID(responseData.AcademicProgramID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AcademicProgram != null) {
                loaded.AcademicProgram(new smapi.academic.AcademicProgramModel().LoadFromResponse(responseData.AcademicProgram));
            }
            if (responseData.OfferingItem != null) {
                loaded.OfferingItem(new smapi.admissions.AdmissionsProgramOfferingItemModel().LoadFromResponse(responseData.OfferingItem));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.ExternalAdmissionsProgramOfferingItemID', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ExternalSystem.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ExternalEntity.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ExternalID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionsProgramOfferingItemID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AcademicProgramID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function GEDModel(options) {
        var defaults = {
            PersonID: 0,
            TestDate: null,
            Score: 0,
            SourceID: null,
            StateID: null,
            DataStepID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.TestDate = ko.validatedObservable(settings.TestDate);
        this.Score = ko.validatedObservable(settings.Score);
        this.SourceID = ko.validatedObservable(settings.SourceID);
        this.StateID = ko.validatedObservable(settings.StateID);
        this.DataStepID = ko.validatedObservable(settings.DataStepID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.DataStep = ko.observable();
        this.GoverningDistrict = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.TestDate != undefined) {
                loaded.TestDate(responseData.TestDate);
            }
            if (responseData.Score != undefined) {
                loaded.Score(responseData.Score);
            }
            if (responseData.SourceID != undefined) {
                loaded.SourceID(responseData.SourceID);
            }
            if (responseData.StateID != undefined) {
                loaded.StateID(responseData.StateID);
            }
            if (responseData.DataStepID != undefined) {
                loaded.DataStepID(responseData.DataStepID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.DataStep != null) {
                loaded.DataStep(new smapi.admissions.GEDStepModel().LoadFromResponse(responseData.DataStep));
            }
            if (responseData.GoverningDistrict != null) {
                loaded.GoverningDistrict(new smapi.community.GoverningDistrictModel().LoadFromResponse(responseData.GoverningDistrict));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.GED', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TestDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.Score.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SourceID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StateID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DataStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function GEDStepModel(options) {
        var defaults = {
            ClassType: 0,
            Comments: '',
            AdmissionsAttemptID: 0,
            ProcessStageID: null,
            ParentStepID: null,
            StatusID: 0,
            RequiredOptionID: null,
            StepStartDate: null,
            StepEndDate: null,
            NavigatorScreenPath: '',
            ExpectedStepEndDate: null,
            AdHoc: false,
            ProgressOveridden: false,
            ExternalStage: false,
            MinExternalData: 0,
            MaxExternalData: 0,
            DueDate: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.Comments = ko.validatedObservable(settings.Comments);
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.ProcessStageID = ko.validatedObservable(settings.ProcessStageID);
        this.ParentStepID = ko.validatedObservable(settings.ParentStepID);
        this.StatusID = ko.validatedObservable(settings.StatusID);
        this.RequiredOptionID = ko.validatedObservable(settings.RequiredOptionID);
        this.StepStartDate = ko.validatedObservable(settings.StepStartDate);
        this.StepEndDate = ko.validatedObservable(settings.StepEndDate);
        this.NavigatorScreenPath = ko.validatedObservable(settings.NavigatorScreenPath);
        this.ExpectedStepEndDate = ko.validatedObservable(settings.ExpectedStepEndDate);
        this.AdHoc = ko.validatedObservable(settings.AdHoc);
        this.ProgressOveridden = ko.validatedObservable(settings.ProgressOveridden);
        this.ExternalStage = ko.validatedObservable(settings.ExternalStage);
        this.MinExternalData = ko.validatedObservable(settings.MinExternalData);
        this.MaxExternalData = ko.validatedObservable(settings.MaxExternalData);
        this.DueDate = ko.validatedObservable(settings.DueDate);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.GEDScores = ko.observableArray([]);
        this.AdmissionsAttempt = ko.observable();
        this.ProcessStage = ko.observable();
        this.ReviewerComments = ko.observableArray([]);
        this.ExternalData = ko.observableArray([]);
        this.Parent = ko.observable();
        this.ChildSteps = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.Comments != undefined) {
                loaded.Comments(responseData.Comments);
            }
            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.ProcessStageID != undefined) {
                loaded.ProcessStageID(responseData.ProcessStageID);
            }
            if (responseData.ParentStepID != undefined) {
                loaded.ParentStepID(responseData.ParentStepID);
            }
            if (responseData.StatusID != undefined) {
                loaded.StatusID(responseData.StatusID);
            }
            if (responseData.RequiredOptionID != undefined) {
                loaded.RequiredOptionID(responseData.RequiredOptionID);
            }
            if (responseData.StepStartDate != undefined) {
                loaded.StepStartDate(responseData.StepStartDate);
            }
            if (responseData.StepEndDate != undefined) {
                loaded.StepEndDate(responseData.StepEndDate);
            }
            if (responseData.NavigatorScreenPath != undefined) {
                loaded.NavigatorScreenPath(responseData.NavigatorScreenPath);
            }
            if (responseData.ExpectedStepEndDate != undefined) {
                loaded.ExpectedStepEndDate(responseData.ExpectedStepEndDate);
            }
            if (responseData.AdHoc != undefined) {
                loaded.AdHoc(responseData.AdHoc);
            }
            if (responseData.ProgressOveridden != undefined) {
                loaded.ProgressOveridden(responseData.ProgressOveridden);
            }
            if (responseData.ExternalStage != undefined) {
                loaded.ExternalStage(responseData.ExternalStage);
            }
            if (responseData.MinExternalData != undefined) {
                loaded.MinExternalData(responseData.MinExternalData);
            }
            if (responseData.MaxExternalData != undefined) {
                loaded.MaxExternalData(responseData.MaxExternalData);
            }
            if (responseData.DueDate != undefined) {
                loaded.DueDate(responseData.DueDate);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.GEDScores != null && responseData.GEDScores.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.GEDScores.length; i++) {
                    items.push(new smapi.admissions.GEDModel().LoadFromResponse(responseData.GEDScores[i]));
                }
                loaded.GEDScores(items);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }
            if (responseData.ProcessStage != null) {
                loaded.ProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.ProcessStage));
            }
            if (responseData.ReviewerComments != null && responseData.ReviewerComments.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ReviewerComments.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationCommentModel().LoadFromResponse(responseData.ReviewerComments[i]));
                }
                loaded.ReviewerComments(items);
            }
            if (responseData.ExternalData != null && responseData.ExternalData.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ExternalData.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepDataModel().LoadFromResponse(responseData.ExternalData[i]));
                }
                loaded.ExternalData(items);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.ChildSteps != null && responseData.ChildSteps.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ChildSteps.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.ChildSteps[i]));
                }
                loaded.ChildSteps(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.GEDStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Comments.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProcessStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RequiredOptionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StepStartDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.StepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.NavigatorScreenPath.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ExpectedStepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AdHoc.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ExternalStage.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.MinExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MaxExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DueDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function GenericTestModel(options) {
        var defaults = {
            PersonID: 0,
            TestTypeID: null,
            TestDate: null,
            Score: 0,
            PassingScore: 0,
            UseForPlacement: false,
            SourceID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.TestTypeID = ko.validatedObservable(settings.TestTypeID);
        this.TestDate = ko.validatedObservable(settings.TestDate);
        this.Score = ko.validatedObservable(settings.Score);
        this.PassingScore = ko.validatedObservable(settings.PassingScore);
        this.UseForPlacement = ko.validatedObservable(settings.UseForPlacement);
        this.SourceID = ko.validatedObservable(settings.SourceID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.TestTypeID != undefined) {
                loaded.TestTypeID(responseData.TestTypeID);
            }
            if (responseData.TestDate != undefined) {
                loaded.TestDate(responseData.TestDate);
            }
            if (responseData.Score != undefined) {
                loaded.Score(responseData.Score);
            }
            if (responseData.PassingScore != undefined) {
                loaded.PassingScore(responseData.PassingScore);
            }
            if (responseData.UseForPlacement != undefined) {
                loaded.UseForPlacement(responseData.UseForPlacement);
            }
            if (responseData.SourceID != undefined) {
                loaded.SourceID(responseData.SourceID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.GenericTest', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TestTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TestDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.Score.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PassingScore.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.UseForPlacement.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.SourceID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function GMATModel(options) {
        var defaults = {
            PersonID: 0,
            TestDate: null,
            RegistrationNumber: '',
            IrregularityCode: '',
            Verbal: 0,
            Quantitative: 0,
            Total: 0,
            Writing: 0,
            UseForPlacement: false,
            SourceID: null,
            DataStepID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.TestDate = ko.validatedObservable(settings.TestDate);
        this.RegistrationNumber = ko.validatedObservable(settings.RegistrationNumber);
        this.IrregularityCode = ko.validatedObservable(settings.IrregularityCode);
        this.Verbal = ko.validatedObservable(settings.Verbal);
        this.Quantitative = ko.validatedObservable(settings.Quantitative);
        this.Total = ko.validatedObservable(settings.Total);
        this.Writing = ko.validatedObservable(settings.Writing);
        this.UseForPlacement = ko.validatedObservable(settings.UseForPlacement);
        this.SourceID = ko.validatedObservable(settings.SourceID);
        this.DataStepID = ko.validatedObservable(settings.DataStepID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.DataStep = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.TestDate != undefined) {
                loaded.TestDate(responseData.TestDate);
            }
            if (responseData.RegistrationNumber != undefined) {
                loaded.RegistrationNumber(responseData.RegistrationNumber);
            }
            if (responseData.IrregularityCode != undefined) {
                loaded.IrregularityCode(responseData.IrregularityCode);
            }
            if (responseData.Verbal != undefined) {
                loaded.Verbal(responseData.Verbal);
            }
            if (responseData.Quantitative != undefined) {
                loaded.Quantitative(responseData.Quantitative);
            }
            if (responseData.Total != undefined) {
                loaded.Total(responseData.Total);
            }
            if (responseData.Writing != undefined) {
                loaded.Writing(responseData.Writing);
            }
            if (responseData.UseForPlacement != undefined) {
                loaded.UseForPlacement(responseData.UseForPlacement);
            }
            if (responseData.SourceID != undefined) {
                loaded.SourceID(responseData.SourceID);
            }
            if (responseData.DataStepID != undefined) {
                loaded.DataStepID(responseData.DataStepID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.DataStep != null) {
                loaded.DataStep(new smapi.admissions.GMATStepModel().LoadFromResponse(responseData.DataStep));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.GMAT', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TestDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.RegistrationNumber.extend({
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            }
        });
        this.IrregularityCode.extend({
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            }
        });
        this.Verbal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Quantitative.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Total.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Writing.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.UseForPlacement.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.SourceID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DataStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function GMATStepModel(options) {
        var defaults = {
            ClassType: 0,
            Comments: '',
            AdmissionsAttemptID: 0,
            ProcessStageID: null,
            ParentStepID: null,
            StatusID: 0,
            RequiredOptionID: null,
            StepStartDate: null,
            StepEndDate: null,
            NavigatorScreenPath: '',
            ExpectedStepEndDate: null,
            AdHoc: false,
            ProgressOveridden: false,
            ExternalStage: false,
            MinExternalData: 0,
            MaxExternalData: 0,
            DueDate: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.Comments = ko.validatedObservable(settings.Comments);
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.ProcessStageID = ko.validatedObservable(settings.ProcessStageID);
        this.ParentStepID = ko.validatedObservable(settings.ParentStepID);
        this.StatusID = ko.validatedObservable(settings.StatusID);
        this.RequiredOptionID = ko.validatedObservable(settings.RequiredOptionID);
        this.StepStartDate = ko.validatedObservable(settings.StepStartDate);
        this.StepEndDate = ko.validatedObservable(settings.StepEndDate);
        this.NavigatorScreenPath = ko.validatedObservable(settings.NavigatorScreenPath);
        this.ExpectedStepEndDate = ko.validatedObservable(settings.ExpectedStepEndDate);
        this.AdHoc = ko.validatedObservable(settings.AdHoc);
        this.ProgressOveridden = ko.validatedObservable(settings.ProgressOveridden);
        this.ExternalStage = ko.validatedObservable(settings.ExternalStage);
        this.MinExternalData = ko.validatedObservable(settings.MinExternalData);
        this.MaxExternalData = ko.validatedObservable(settings.MaxExternalData);
        this.DueDate = ko.validatedObservable(settings.DueDate);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.GMATTestScores = ko.observableArray([]);
        this.AdmissionsAttempt = ko.observable();
        this.ProcessStage = ko.observable();
        this.ReviewerComments = ko.observableArray([]);
        this.ExternalData = ko.observableArray([]);
        this.Parent = ko.observable();
        this.ChildSteps = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.Comments != undefined) {
                loaded.Comments(responseData.Comments);
            }
            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.ProcessStageID != undefined) {
                loaded.ProcessStageID(responseData.ProcessStageID);
            }
            if (responseData.ParentStepID != undefined) {
                loaded.ParentStepID(responseData.ParentStepID);
            }
            if (responseData.StatusID != undefined) {
                loaded.StatusID(responseData.StatusID);
            }
            if (responseData.RequiredOptionID != undefined) {
                loaded.RequiredOptionID(responseData.RequiredOptionID);
            }
            if (responseData.StepStartDate != undefined) {
                loaded.StepStartDate(responseData.StepStartDate);
            }
            if (responseData.StepEndDate != undefined) {
                loaded.StepEndDate(responseData.StepEndDate);
            }
            if (responseData.NavigatorScreenPath != undefined) {
                loaded.NavigatorScreenPath(responseData.NavigatorScreenPath);
            }
            if (responseData.ExpectedStepEndDate != undefined) {
                loaded.ExpectedStepEndDate(responseData.ExpectedStepEndDate);
            }
            if (responseData.AdHoc != undefined) {
                loaded.AdHoc(responseData.AdHoc);
            }
            if (responseData.ProgressOveridden != undefined) {
                loaded.ProgressOveridden(responseData.ProgressOveridden);
            }
            if (responseData.ExternalStage != undefined) {
                loaded.ExternalStage(responseData.ExternalStage);
            }
            if (responseData.MinExternalData != undefined) {
                loaded.MinExternalData(responseData.MinExternalData);
            }
            if (responseData.MaxExternalData != undefined) {
                loaded.MaxExternalData(responseData.MaxExternalData);
            }
            if (responseData.DueDate != undefined) {
                loaded.DueDate(responseData.DueDate);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.GMATTestScores != null && responseData.GMATTestScores.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.GMATTestScores.length; i++) {
                    items.push(new smapi.admissions.GMATModel().LoadFromResponse(responseData.GMATTestScores[i]));
                }
                loaded.GMATTestScores(items);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }
            if (responseData.ProcessStage != null) {
                loaded.ProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.ProcessStage));
            }
            if (responseData.ReviewerComments != null && responseData.ReviewerComments.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ReviewerComments.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationCommentModel().LoadFromResponse(responseData.ReviewerComments[i]));
                }
                loaded.ReviewerComments(items);
            }
            if (responseData.ExternalData != null && responseData.ExternalData.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ExternalData.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepDataModel().LoadFromResponse(responseData.ExternalData[i]));
                }
                loaded.ExternalData(items);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.ChildSteps != null && responseData.ChildSteps.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ChildSteps.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.ChildSteps[i]));
                }
                loaded.ChildSteps(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.GMATStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Comments.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProcessStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RequiredOptionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StepStartDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.StepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.NavigatorScreenPath.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ExpectedStepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AdHoc.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ExternalStage.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.MinExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MaxExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DueDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function GREGeneralModel(options) {
        var defaults = {
            PersonID: 0,
            TestDate: null,
            RegistrationNumber: '',
            Verbal: 0,
            Quantitative: 0,
            Writing: 0,
            UseForPlacement: false,
            SourceID: null,
            DataStepID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.TestDate = ko.validatedObservable(settings.TestDate);
        this.RegistrationNumber = ko.validatedObservable(settings.RegistrationNumber);
        this.Verbal = ko.validatedObservable(settings.Verbal);
        this.Quantitative = ko.validatedObservable(settings.Quantitative);
        this.Writing = ko.validatedObservable(settings.Writing);
        this.UseForPlacement = ko.validatedObservable(settings.UseForPlacement);
        this.SourceID = ko.validatedObservable(settings.SourceID);
        this.DataStepID = ko.validatedObservable(settings.DataStepID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.DataStep = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.TestDate != undefined) {
                loaded.TestDate(responseData.TestDate);
            }
            if (responseData.RegistrationNumber != undefined) {
                loaded.RegistrationNumber(responseData.RegistrationNumber);
            }
            if (responseData.Verbal != undefined) {
                loaded.Verbal(responseData.Verbal);
            }
            if (responseData.Quantitative != undefined) {
                loaded.Quantitative(responseData.Quantitative);
            }
            if (responseData.Writing != undefined) {
                loaded.Writing(responseData.Writing);
            }
            if (responseData.UseForPlacement != undefined) {
                loaded.UseForPlacement(responseData.UseForPlacement);
            }
            if (responseData.SourceID != undefined) {
                loaded.SourceID(responseData.SourceID);
            }
            if (responseData.DataStepID != undefined) {
                loaded.DataStepID(responseData.DataStepID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.DataStep != null) {
                loaded.DataStep(new smapi.admissions.GREGeneralStepModel().LoadFromResponse(responseData.DataStep));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.GREGeneral', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TestDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.RegistrationNumber.extend({
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            }
        });
        this.Verbal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: 0,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GreaterThan0_Key), '0')
            }, 
            max: {
                params: 800,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_LessThan0_Key), '800')
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Quantitative.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: 0,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GreaterThan0_Key), '0')
            }, 
            max: {
                params: 800,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_LessThan0_Key), '800')
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Writing.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: 0,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GreaterThan0_Key), '0')
            }, 
            max: {
                params: 6,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_LessThan0_Key), '6')
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.UseForPlacement.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.SourceID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DataStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function GREGeneralStepModel(options) {
        var defaults = {
            ClassType: 0,
            Comments: '',
            AdmissionsAttemptID: 0,
            ProcessStageID: null,
            ParentStepID: null,
            StatusID: 0,
            RequiredOptionID: null,
            StepStartDate: null,
            StepEndDate: null,
            NavigatorScreenPath: '',
            ExpectedStepEndDate: null,
            AdHoc: false,
            ProgressOveridden: false,
            ExternalStage: false,
            MinExternalData: 0,
            MaxExternalData: 0,
            DueDate: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.Comments = ko.validatedObservable(settings.Comments);
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.ProcessStageID = ko.validatedObservable(settings.ProcessStageID);
        this.ParentStepID = ko.validatedObservable(settings.ParentStepID);
        this.StatusID = ko.validatedObservable(settings.StatusID);
        this.RequiredOptionID = ko.validatedObservable(settings.RequiredOptionID);
        this.StepStartDate = ko.validatedObservable(settings.StepStartDate);
        this.StepEndDate = ko.validatedObservable(settings.StepEndDate);
        this.NavigatorScreenPath = ko.validatedObservable(settings.NavigatorScreenPath);
        this.ExpectedStepEndDate = ko.validatedObservable(settings.ExpectedStepEndDate);
        this.AdHoc = ko.validatedObservable(settings.AdHoc);
        this.ProgressOveridden = ko.validatedObservable(settings.ProgressOveridden);
        this.ExternalStage = ko.validatedObservable(settings.ExternalStage);
        this.MinExternalData = ko.validatedObservable(settings.MinExternalData);
        this.MaxExternalData = ko.validatedObservable(settings.MaxExternalData);
        this.DueDate = ko.validatedObservable(settings.DueDate);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.GREGeneralTestScores = ko.observableArray([]);
        this.AdmissionsAttempt = ko.observable();
        this.ProcessStage = ko.observable();
        this.ReviewerComments = ko.observableArray([]);
        this.ExternalData = ko.observableArray([]);
        this.Parent = ko.observable();
        this.ChildSteps = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.Comments != undefined) {
                loaded.Comments(responseData.Comments);
            }
            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.ProcessStageID != undefined) {
                loaded.ProcessStageID(responseData.ProcessStageID);
            }
            if (responseData.ParentStepID != undefined) {
                loaded.ParentStepID(responseData.ParentStepID);
            }
            if (responseData.StatusID != undefined) {
                loaded.StatusID(responseData.StatusID);
            }
            if (responseData.RequiredOptionID != undefined) {
                loaded.RequiredOptionID(responseData.RequiredOptionID);
            }
            if (responseData.StepStartDate != undefined) {
                loaded.StepStartDate(responseData.StepStartDate);
            }
            if (responseData.StepEndDate != undefined) {
                loaded.StepEndDate(responseData.StepEndDate);
            }
            if (responseData.NavigatorScreenPath != undefined) {
                loaded.NavigatorScreenPath(responseData.NavigatorScreenPath);
            }
            if (responseData.ExpectedStepEndDate != undefined) {
                loaded.ExpectedStepEndDate(responseData.ExpectedStepEndDate);
            }
            if (responseData.AdHoc != undefined) {
                loaded.AdHoc(responseData.AdHoc);
            }
            if (responseData.ProgressOveridden != undefined) {
                loaded.ProgressOveridden(responseData.ProgressOveridden);
            }
            if (responseData.ExternalStage != undefined) {
                loaded.ExternalStage(responseData.ExternalStage);
            }
            if (responseData.MinExternalData != undefined) {
                loaded.MinExternalData(responseData.MinExternalData);
            }
            if (responseData.MaxExternalData != undefined) {
                loaded.MaxExternalData(responseData.MaxExternalData);
            }
            if (responseData.DueDate != undefined) {
                loaded.DueDate(responseData.DueDate);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.GREGeneralTestScores != null && responseData.GREGeneralTestScores.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.GREGeneralTestScores.length; i++) {
                    items.push(new smapi.admissions.GREGeneralModel().LoadFromResponse(responseData.GREGeneralTestScores[i]));
                }
                loaded.GREGeneralTestScores(items);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }
            if (responseData.ProcessStage != null) {
                loaded.ProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.ProcessStage));
            }
            if (responseData.ReviewerComments != null && responseData.ReviewerComments.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ReviewerComments.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationCommentModel().LoadFromResponse(responseData.ReviewerComments[i]));
                }
                loaded.ReviewerComments(items);
            }
            if (responseData.ExternalData != null && responseData.ExternalData.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ExternalData.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepDataModel().LoadFromResponse(responseData.ExternalData[i]));
                }
                loaded.ExternalData(items);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.ChildSteps != null && responseData.ChildSteps.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ChildSteps.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.ChildSteps[i]));
                }
                loaded.ChildSteps(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.GREGeneralStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Comments.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProcessStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RequiredOptionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StepStartDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.StepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.NavigatorScreenPath.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ExpectedStepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AdHoc.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ExternalStage.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.MinExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MaxExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DueDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function HighSchoolModel(options) {
        var defaults = {
            OrganizationID: 0,
            DisplayName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.OrganizationID = ko.validatedObservable(settings.OrganizationID);
        this.DisplayName = ko.validatedObservable(settings.DisplayName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Organization = ko.observable();
        this.HighSchoolCodes = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.OrganizationID != undefined) {
                loaded.OrganizationID(responseData.OrganizationID);
            }
            if (responseData.DisplayName != undefined) {
                loaded.DisplayName(responseData.DisplayName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Organization != null) {
                loaded.Organization(new smapi.community.OrganizationModel().LoadFromResponse(responseData.Organization));
            }
            if (responseData.HighSchoolCodes != null && responseData.HighSchoolCodes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.HighSchoolCodes.length; i++) {
                    items.push(new smapi.admissions.HighSchoolCodeModel().LoadFromResponse(responseData.HighSchoolCodes[i]));
                }
                loaded.HighSchoolCodes(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.HighSchool', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.OrganizationID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DisplayName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 60,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '60')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function HighSchoolCodeModel(options) {
        var defaults = {
            Code: '',
            HighSchoolCodeTypeID: null,
            HighSchoolID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Code = ko.validatedObservable(settings.Code);
        this.HighSchoolCodeTypeID = ko.validatedObservable(settings.HighSchoolCodeTypeID);
        this.HighSchoolID = ko.validatedObservable(settings.HighSchoolID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.HighSchool = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Code != undefined) {
                loaded.Code(responseData.Code);
            }
            if (responseData.HighSchoolCodeTypeID != undefined) {
                loaded.HighSchoolCodeTypeID(responseData.HighSchoolCodeTypeID);
            }
            if (responseData.HighSchoolID != undefined) {
                loaded.HighSchoolID(responseData.HighSchoolID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.HighSchool != null) {
                loaded.HighSchool(new smapi.admissions.HighSchoolModel().LoadFromResponse(responseData.HighSchool));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.HighSchoolCode', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Code.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            }
        });
        this.HighSchoolCodeTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.HighSchoolID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function HighSchoolInformationModel(options) {
        var defaults = {
            PersonID: 0,
            HighSchoolName: '',
            SourceID: null,
            HighSchoolID: null,
            StudentID: '',
            GraduationDate: null,
            StartDate: null,
            EndDate: null,
            EvaluationDate: null,
            CounselorName: '',
            CounselorPhone: '',
            CounselorTitle: '',
            GPA: 0,
            GPAScale: 0,
            ClassRank: 0,
            ClassSize: 0,
            Graduated: false,
            ProjectedGPAVerbal: 0,
            ProjectedGPAMath: 0,
            TranscriptDocumentID: null,
            DataStepID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
            HighestLevelAchieved: null,
            Credentials: [],
            City: '',
            Courses: null,
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.HighSchoolName = ko.validatedObservable(settings.HighSchoolName);
        this.SourceID = ko.validatedObservable(settings.SourceID);
        this.HighSchoolID = ko.validatedObservable(settings.HighSchoolID);
        this.StudentID = ko.validatedObservable(settings.StudentID);
        this.GraduationDate = ko.validatedObservable(settings.GraduationDate);
        this.StartDate = ko.validatedObservable(settings.StartDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.EvaluationDate = ko.validatedObservable(settings.EvaluationDate);
        this.CounselorName = ko.validatedObservable(settings.CounselorName);
        this.CounselorPhone = ko.validatedObservable(settings.CounselorPhone);
        this.CounselorTitle = ko.validatedObservable(settings.CounselorTitle);
        this.GPA = ko.validatedObservable(settings.GPA);
        this.GPAScale = ko.validatedObservable(settings.GPAScale);
        this.ClassRank = ko.validatedObservable(settings.ClassRank);
        this.City = ko.observable(settings.City);
        this.HighestLevelAchieved = ko.observable(settings.HighestLevelAchieved);
        this.Credentials = ko.observable(settings.Credentials);
        this.Courses = ko.observable(settings.Courses);
        this.ClassSize = ko.validatedObservable(settings.ClassSize);
        this.Graduated = ko.validatedObservable(settings.Graduated);
        this.ProjectedGPAVerbal = ko.validatedObservable(settings.ProjectedGPAVerbal);
        this.ProjectedGPAMath = ko.validatedObservable(settings.ProjectedGPAMath);
        this.TranscriptDocumentID = ko.validatedObservable(settings.TranscriptDocumentID);
        this.DataStepID = ko.validatedObservable(settings.DataStepID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.HighSchool = ko.observable();
        this.Person = ko.observable();
        this.TranscriptDocument = ko.observable();
        this.DataStep = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.HighSchoolName != undefined) {
                loaded.HighSchoolName(responseData.HighSchoolName);
            }
            if (responseData.SourceID != undefined) {
                loaded.SourceID(responseData.SourceID);
            }
            if (responseData.HighSchoolID != undefined) {
                loaded.HighSchoolID(responseData.HighSchoolID);
            }
            if (responseData.StudentID != undefined) {
                loaded.StudentID(responseData.StudentID);
            }
            if (responseData.GraduationDate != undefined) {
                loaded.GraduationDate(responseData.GraduationDate);
            }
            if (responseData.StartDate != undefined) {
                loaded.StartDate(responseData.StartDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.EvaluationDate != undefined) {
                loaded.EvaluationDate(responseData.EvaluationDate);
            }
            if (responseData.CounselorName != undefined) {
                loaded.CounselorName(responseData.CounselorName);
            }
            if (responseData.CounselorPhone != undefined) {
                loaded.CounselorPhone(responseData.CounselorPhone);
            }
            if (responseData.CounselorTitle != undefined) {
                loaded.CounselorTitle(responseData.CounselorTitle);
            }
            if (responseData.GPA != undefined) {
                loaded.GPA(responseData.GPA);
            }
            if (responseData.GPAScale != undefined) {
                loaded.GPAScale(responseData.GPAScale);
            }
            if (responseData.City != undefined) {
                loaded.City(responseData.City);
            }
            if (responseData.HighestLevelAchieved != undefined) {
                loaded.HighestLevelAchieved(responseData.HighestLevelAchieved);
            }
            if (responseData.Credentials != undefined) {
                loaded.Credentials(responseData.Credentials);
            }
            if (responseData.Courses != undefined) {
                loaded.Courses(responseData.Courses);
            }
            if (responseData.ClassRank != undefined) {
                loaded.ClassRank(responseData.ClassRank);
            }
            if (responseData.ClassSize != undefined) {
                loaded.ClassSize(responseData.ClassSize);
            }
            if (responseData.Graduated != undefined) {
                loaded.Graduated(responseData.Graduated);
            }
            if (responseData.ProjectedGPAVerbal != undefined) {
                loaded.ProjectedGPAVerbal(responseData.ProjectedGPAVerbal);
            }
            if (responseData.ProjectedGPAMath != undefined) {
                loaded.ProjectedGPAMath(responseData.ProjectedGPAMath);
            }
            if (responseData.TranscriptDocumentID != undefined) {
                loaded.TranscriptDocumentID(responseData.TranscriptDocumentID);
            }
            if (responseData.DataStepID != undefined) {
                loaded.DataStepID(responseData.DataStepID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.HighSchool != null) {
                loaded.HighSchool(new smapi.admissions.HighSchoolModel().LoadFromResponse(responseData.HighSchool));
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.TranscriptDocument != null && responseData.TranscriptDocument != undefined ) {
                loaded.TranscriptDocument(new smapi.admissions.AdmissionsDocumentModel().LoadFromResponse(responseData.TranscriptDocument));
            }
            if (responseData.DataStep != null) {
                loaded.DataStep(new smapi.admissions.HighSchoolInformationStepModel().LoadFromResponse(responseData.DataStep));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.HighSchoolInformation', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.HighSchoolName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SourceID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.HighSchoolID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StudentID.extend({
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.GraduationDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.StartDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EvaluationDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.CounselorName.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.CounselorPhone.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.CounselorTitle.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.GPA.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GPAScale.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ClassRank.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ClassSize.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Graduated.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ProjectedGPAVerbal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProjectedGPAMath.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TranscriptDocumentID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DataStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function HighSchoolInformationStepModel(options) {
        var defaults = {
            ClassType: 0,
            Comments: '',
            AdmissionsAttemptID: 0,
            ProcessStageID: null,
            ParentStepID: null,
            StatusID: 0,
            RequiredOptionID: null,
            StepStartDate: null,
            StepEndDate: null,
            NavigatorScreenPath: '',
            ExpectedStepEndDate: null,
            AdHoc: false,
            ProgressOveridden: false,
            ExternalStage: false,
            MinExternalData: 0,
            MaxExternalData: 0,
            DueDate: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.Comments = ko.validatedObservable(settings.Comments);
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.ProcessStageID = ko.validatedObservable(settings.ProcessStageID);
        this.ParentStepID = ko.validatedObservable(settings.ParentStepID);
        this.StatusID = ko.validatedObservable(settings.StatusID);
        this.RequiredOptionID = ko.validatedObservable(settings.RequiredOptionID);
        this.StepStartDate = ko.validatedObservable(settings.StepStartDate);
        this.StepEndDate = ko.validatedObservable(settings.StepEndDate);
        this.NavigatorScreenPath = ko.validatedObservable(settings.NavigatorScreenPath);
        this.ExpectedStepEndDate = ko.validatedObservable(settings.ExpectedStepEndDate);
        this.AdHoc = ko.validatedObservable(settings.AdHoc);
        this.ProgressOveridden = ko.validatedObservable(settings.ProgressOveridden);
        this.ExternalStage = ko.validatedObservable(settings.ExternalStage);
        this.MinExternalData = ko.validatedObservable(settings.MinExternalData);
        this.MaxExternalData = ko.validatedObservable(settings.MaxExternalData);
        this.DueDate = ko.validatedObservable(settings.DueDate);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.HighSchoolDetails = ko.observableArray([]);
        this.AdmissionsAttempt = ko.observable();
        this.ProcessStage = ko.observable();
        this.ReviewerComments = ko.observableArray([]);
        this.ExternalData = ko.observableArray([]);
        this.Parent = ko.observable();
        this.ChildSteps = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.Comments != undefined) {
                loaded.Comments(responseData.Comments);
            }
            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.ProcessStageID != undefined) {
                loaded.ProcessStageID(responseData.ProcessStageID);
            }
            if (responseData.ParentStepID != undefined) {
                loaded.ParentStepID(responseData.ParentStepID);
            }
            if (responseData.StatusID != undefined) {
                loaded.StatusID(responseData.StatusID);
            }
            if (responseData.RequiredOptionID != undefined) {
                loaded.RequiredOptionID(responseData.RequiredOptionID);
            }
            if (responseData.StepStartDate != undefined) {
                loaded.StepStartDate(responseData.StepStartDate);
            }
            if (responseData.StepEndDate != undefined) {
                loaded.StepEndDate(responseData.StepEndDate);
            }
            if (responseData.NavigatorScreenPath != undefined) {
                loaded.NavigatorScreenPath(responseData.NavigatorScreenPath);
            }
            if (responseData.ExpectedStepEndDate != undefined) {
                loaded.ExpectedStepEndDate(responseData.ExpectedStepEndDate);
            }
            if (responseData.AdHoc != undefined) {
                loaded.AdHoc(responseData.AdHoc);
            }
            if (responseData.ProgressOveridden != undefined) {
                loaded.ProgressOveridden(responseData.ProgressOveridden);
            }
            if (responseData.ExternalStage != undefined) {
                loaded.ExternalStage(responseData.ExternalStage);
            }
            if (responseData.MinExternalData != undefined) {
                loaded.MinExternalData(responseData.MinExternalData);
            }
            if (responseData.MaxExternalData != undefined) {
                loaded.MaxExternalData(responseData.MaxExternalData);
            }
            if (responseData.DueDate != undefined) {
                loaded.DueDate(responseData.DueDate);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.HighSchoolDetails != null && responseData.HighSchoolDetails.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.HighSchoolDetails.length; i++) {
                    items.push(new smapi.admissions.HighSchoolInformationModel().LoadFromResponse(responseData.HighSchoolDetails[i]));
                }
                loaded.HighSchoolDetails(items);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }
            if (responseData.ProcessStage != null) {
                loaded.ProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.ProcessStage));
            }
            if (responseData.ReviewerComments != null && responseData.ReviewerComments.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ReviewerComments.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationCommentModel().LoadFromResponse(responseData.ReviewerComments[i]));
                }
                loaded.ReviewerComments(items);
            }
            if (responseData.ExternalData != null && responseData.ExternalData.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ExternalData.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepDataModel().LoadFromResponse(responseData.ExternalData[i]));
                }
                loaded.ExternalData(items);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.ChildSteps != null && responseData.ChildSteps.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ChildSteps.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.ChildSteps[i]));
                }
                loaded.ChildSteps(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.HighSchoolInformationStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Comments.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProcessStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RequiredOptionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StepStartDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.StepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.NavigatorScreenPath.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ExpectedStepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AdHoc.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ExternalStage.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.MinExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MaxExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DueDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PlacementTestModel(options) {
        var defaults = {
            PersonID: 0,
            TestDate: null,
            Score1: 0,
            Score2: 0,
            Score3: 0,
            Score4: 0,
            Score5: 0,
            TestNameID: null,
            TestSubjectID: null,
            TestStatusID: null,
            UseForPlacement: false,
            SourceID: null,
            DataStepID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.TestDate = ko.validatedObservable(settings.TestDate);
        this.Score1 = ko.validatedObservable(settings.Score1);
        this.Score2 = ko.validatedObservable(settings.Score2);
        this.Score3 = ko.validatedObservable(settings.Score3);
        this.Score4 = ko.validatedObservable(settings.Score4);
        this.Score5 = ko.validatedObservable(settings.Score5);
        this.TestNameID = ko.validatedObservable(settings.TestNameID);
        this.TestSubjectID = ko.validatedObservable(settings.TestSubjectID);
        this.TestStatusID = ko.validatedObservable(settings.TestStatusID);
        this.UseForPlacement = ko.validatedObservable(settings.UseForPlacement);
        this.SourceID = ko.validatedObservable(settings.SourceID);
        this.DataStepID = ko.validatedObservable(settings.DataStepID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.DataStep = ko.observable();
        this.AdmissionsTestName = ko.observable();
        this.AdmissionsTestSubject = ko.observable();
        this.AdmissionsTestStatus = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.TestDate != undefined) {
                loaded.TestDate(responseData.TestDate);
            }
            if (responseData.Score1 != undefined) {
                loaded.Score1(responseData.Score1);
            }
            if (responseData.Score2 != undefined) {
                loaded.Score2(responseData.Score2);
            }
            if (responseData.Score3 != undefined) {
                loaded.Score3(responseData.Score3);
            }
            if (responseData.Score4 != undefined) {
                loaded.Score4(responseData.Score4);
            }
            if (responseData.Score5 != undefined) {
                loaded.Score5(responseData.Score5);
            }
            if (responseData.TestNameID != undefined) {
                loaded.TestNameID(responseData.TestNameID);
            }
            if (responseData.TestSubjectID != undefined) {
                loaded.TestSubjectID(responseData.TestSubjectID);
            }
            if (responseData.TestStatusID != undefined) {
                loaded.TestStatusID(responseData.TestStatusID);
            }
            if (responseData.UseForPlacement != undefined) {
                loaded.UseForPlacement(responseData.UseForPlacement);
            }
            if (responseData.SourceID != undefined) {
                loaded.SourceID(responseData.SourceID);
            }
            if (responseData.DataStepID != undefined) {
                loaded.DataStepID(responseData.DataStepID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.DataStep != null) {
                loaded.DataStep(new smapi.admissions.PlacementTestStepModel().LoadFromResponse(responseData.DataStep));
            }
            if (responseData.AdmissionsTestName != null) {
                loaded.AdmissionsTestName(new smapi.admissions.AdmissionsTestNameModel().LoadFromResponse(responseData.AdmissionsTestName));
            }
            if (responseData.AdmissionsTestSubject != null) {
                loaded.AdmissionsTestSubject(new smapi.admissions.AdmissionsTestSubjectModel().LoadFromResponse(responseData.AdmissionsTestSubject));
            }
            if (responseData.AdmissionsTestStatus != null) {
                loaded.AdmissionsTestStatus(new smapi.admissions.AdmissionsTestStatusModel().LoadFromResponse(responseData.AdmissionsTestStatus));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.PlacementTest', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TestDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.Score1.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Score2.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Score3.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Score4.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Score5.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TestNameID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TestSubjectID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TestStatusID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.UseForPlacement.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.SourceID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DataStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PlacementTestExemptionModel(options) {
        var defaults = {
            PersonID: 0,
            TestDate: null,
            Written: 0,
            Grammar: 0,
            Reading: 0,
            Total: 0,
            EnglishCourse: 0,
            UseForPlacement: false,
            SourceID: null,
            DataStepID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.TestDate = ko.validatedObservable(settings.TestDate);
        this.Written = ko.validatedObservable(settings.Written);
        this.Grammar = ko.validatedObservable(settings.Grammar);
        this.Reading = ko.validatedObservable(settings.Reading);
        this.Total = ko.validatedObservable(settings.Total);
        this.EnglishCourse = ko.validatedObservable(settings.EnglishCourse);
        this.UseForPlacement = ko.validatedObservable(settings.UseForPlacement);
        this.SourceID = ko.validatedObservable(settings.SourceID);
        this.DataStepID = ko.validatedObservable(settings.DataStepID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.DataStep = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.TestDate != undefined) {
                loaded.TestDate(responseData.TestDate);
            }
            if (responseData.Written != undefined) {
                loaded.Written(responseData.Written);
            }
            if (responseData.Grammar != undefined) {
                loaded.Grammar(responseData.Grammar);
            }
            if (responseData.Reading != undefined) {
                loaded.Reading(responseData.Reading);
            }
            if (responseData.Total != undefined) {
                loaded.Total(responseData.Total);
            }
            if (responseData.EnglishCourse != undefined) {
                loaded.EnglishCourse(responseData.EnglishCourse);
            }
            if (responseData.UseForPlacement != undefined) {
                loaded.UseForPlacement(responseData.UseForPlacement);
            }
            if (responseData.SourceID != undefined) {
                loaded.SourceID(responseData.SourceID);
            }
            if (responseData.DataStepID != undefined) {
                loaded.DataStepID(responseData.DataStepID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.DataStep != null) {
                loaded.DataStep(new smapi.admissions.PlacementTestExemptionStepModel().LoadFromResponse(responseData.DataStep));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.PlacementTestExemption', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TestDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.Written.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Grammar.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Reading.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Total.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EnglishCourse.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.UseForPlacement.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.SourceID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DataStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PlacementTestExemptionStepModel(options) {
        var defaults = {
            ClassType: 0,
            Comments: '',
            AdmissionsAttemptID: 0,
            ProcessStageID: null,
            ParentStepID: null,
            StatusID: 0,
            RequiredOptionID: null,
            StepStartDate: null,
            StepEndDate: null,
            NavigatorScreenPath: '',
            ExpectedStepEndDate: null,
            AdHoc: false,
            ProgressOveridden: false,
            ExternalStage: false,
            MinExternalData: 0,
            MaxExternalData: 0,
            DueDate: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.Comments = ko.validatedObservable(settings.Comments);
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.ProcessStageID = ko.validatedObservable(settings.ProcessStageID);
        this.ParentStepID = ko.validatedObservable(settings.ParentStepID);
        this.StatusID = ko.validatedObservable(settings.StatusID);
        this.RequiredOptionID = ko.validatedObservable(settings.RequiredOptionID);
        this.StepStartDate = ko.validatedObservable(settings.StepStartDate);
        this.StepEndDate = ko.validatedObservable(settings.StepEndDate);
        this.NavigatorScreenPath = ko.validatedObservable(settings.NavigatorScreenPath);
        this.ExpectedStepEndDate = ko.validatedObservable(settings.ExpectedStepEndDate);
        this.AdHoc = ko.validatedObservable(settings.AdHoc);
        this.ProgressOveridden = ko.validatedObservable(settings.ProgressOveridden);
        this.ExternalStage = ko.validatedObservable(settings.ExternalStage);
        this.MinExternalData = ko.validatedObservable(settings.MinExternalData);
        this.MaxExternalData = ko.validatedObservable(settings.MaxExternalData);
        this.DueDate = ko.validatedObservable(settings.DueDate);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.PlacementTestExemptions = ko.observableArray([]);
        this.AdmissionsAttempt = ko.observable();
        this.ProcessStage = ko.observable();
        this.ReviewerComments = ko.observableArray([]);
        this.ExternalData = ko.observableArray([]);
        this.Parent = ko.observable();
        this.ChildSteps = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.Comments != undefined) {
                loaded.Comments(responseData.Comments);
            }
            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.ProcessStageID != undefined) {
                loaded.ProcessStageID(responseData.ProcessStageID);
            }
            if (responseData.ParentStepID != undefined) {
                loaded.ParentStepID(responseData.ParentStepID);
            }
            if (responseData.StatusID != undefined) {
                loaded.StatusID(responseData.StatusID);
            }
            if (responseData.RequiredOptionID != undefined) {
                loaded.RequiredOptionID(responseData.RequiredOptionID);
            }
            if (responseData.StepStartDate != undefined) {
                loaded.StepStartDate(responseData.StepStartDate);
            }
            if (responseData.StepEndDate != undefined) {
                loaded.StepEndDate(responseData.StepEndDate);
            }
            if (responseData.NavigatorScreenPath != undefined) {
                loaded.NavigatorScreenPath(responseData.NavigatorScreenPath);
            }
            if (responseData.ExpectedStepEndDate != undefined) {
                loaded.ExpectedStepEndDate(responseData.ExpectedStepEndDate);
            }
            if (responseData.AdHoc != undefined) {
                loaded.AdHoc(responseData.AdHoc);
            }
            if (responseData.ProgressOveridden != undefined) {
                loaded.ProgressOveridden(responseData.ProgressOveridden);
            }
            if (responseData.ExternalStage != undefined) {
                loaded.ExternalStage(responseData.ExternalStage);
            }
            if (responseData.MinExternalData != undefined) {
                loaded.MinExternalData(responseData.MinExternalData);
            }
            if (responseData.MaxExternalData != undefined) {
                loaded.MaxExternalData(responseData.MaxExternalData);
            }
            if (responseData.DueDate != undefined) {
                loaded.DueDate(responseData.DueDate);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.PlacementTestExemptions != null && responseData.PlacementTestExemptions.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.PlacementTestExemptions.length; i++) {
                    items.push(new smapi.admissions.PlacementTestExemptionModel().LoadFromResponse(responseData.PlacementTestExemptions[i]));
                }
                loaded.PlacementTestExemptions(items);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }
            if (responseData.ProcessStage != null) {
                loaded.ProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.ProcessStage));
            }
            if (responseData.ReviewerComments != null && responseData.ReviewerComments.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ReviewerComments.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationCommentModel().LoadFromResponse(responseData.ReviewerComments[i]));
                }
                loaded.ReviewerComments(items);
            }
            if (responseData.ExternalData != null && responseData.ExternalData.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ExternalData.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepDataModel().LoadFromResponse(responseData.ExternalData[i]));
                }
                loaded.ExternalData(items);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.ChildSteps != null && responseData.ChildSteps.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ChildSteps.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.ChildSteps[i]));
                }
                loaded.ChildSteps(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.PlacementTestExemptionStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Comments.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProcessStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RequiredOptionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StepStartDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.StepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.NavigatorScreenPath.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ExpectedStepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AdHoc.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ExternalStage.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.MinExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MaxExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DueDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PlacementTestStepModel(options) {
        var defaults = {
            ClassType: 0,
            Comments: '',
            AdmissionsAttemptID: 0,
            ProcessStageID: null,
            ParentStepID: null,
            StatusID: 0,
            RequiredOptionID: null,
            StepStartDate: null,
            StepEndDate: null,
            NavigatorScreenPath: '',
            ExpectedStepEndDate: null,
            AdHoc: false,
            ProgressOveridden: false,
            ExternalStage: false,
            MinExternalData: 0,
            MaxExternalData: 0,
            DueDate: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.Comments = ko.validatedObservable(settings.Comments);
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.ProcessStageID = ko.validatedObservable(settings.ProcessStageID);
        this.ParentStepID = ko.validatedObservable(settings.ParentStepID);
        this.StatusID = ko.validatedObservable(settings.StatusID);
        this.RequiredOptionID = ko.validatedObservable(settings.RequiredOptionID);
        this.StepStartDate = ko.validatedObservable(settings.StepStartDate);
        this.StepEndDate = ko.validatedObservable(settings.StepEndDate);
        this.NavigatorScreenPath = ko.validatedObservable(settings.NavigatorScreenPath);
        this.ExpectedStepEndDate = ko.validatedObservable(settings.ExpectedStepEndDate);
        this.AdHoc = ko.validatedObservable(settings.AdHoc);
        this.ProgressOveridden = ko.validatedObservable(settings.ProgressOveridden);
        this.ExternalStage = ko.validatedObservable(settings.ExternalStage);
        this.MinExternalData = ko.validatedObservable(settings.MinExternalData);
        this.MaxExternalData = ko.validatedObservable(settings.MaxExternalData);
        this.DueDate = ko.validatedObservable(settings.DueDate);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.PlacementTests = ko.observableArray([]);
        this.AdmissionsAttempt = ko.observable();
        this.ProcessStage = ko.observable();
        this.ReviewerComments = ko.observableArray([]);
        this.ExternalData = ko.observableArray([]);
        this.Parent = ko.observable();
        this.ChildSteps = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.Comments != undefined) {
                loaded.Comments(responseData.Comments);
            }
            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.ProcessStageID != undefined) {
                loaded.ProcessStageID(responseData.ProcessStageID);
            }
            if (responseData.ParentStepID != undefined) {
                loaded.ParentStepID(responseData.ParentStepID);
            }
            if (responseData.StatusID != undefined) {
                loaded.StatusID(responseData.StatusID);
            }
            if (responseData.RequiredOptionID != undefined) {
                loaded.RequiredOptionID(responseData.RequiredOptionID);
            }
            if (responseData.StepStartDate != undefined) {
                loaded.StepStartDate(responseData.StepStartDate);
            }
            if (responseData.StepEndDate != undefined) {
                loaded.StepEndDate(responseData.StepEndDate);
            }
            if (responseData.NavigatorScreenPath != undefined) {
                loaded.NavigatorScreenPath(responseData.NavigatorScreenPath);
            }
            if (responseData.ExpectedStepEndDate != undefined) {
                loaded.ExpectedStepEndDate(responseData.ExpectedStepEndDate);
            }
            if (responseData.AdHoc != undefined) {
                loaded.AdHoc(responseData.AdHoc);
            }
            if (responseData.ProgressOveridden != undefined) {
                loaded.ProgressOveridden(responseData.ProgressOveridden);
            }
            if (responseData.ExternalStage != undefined) {
                loaded.ExternalStage(responseData.ExternalStage);
            }
            if (responseData.MinExternalData != undefined) {
                loaded.MinExternalData(responseData.MinExternalData);
            }
            if (responseData.MaxExternalData != undefined) {
                loaded.MaxExternalData(responseData.MaxExternalData);
            }
            if (responseData.DueDate != undefined) {
                loaded.DueDate(responseData.DueDate);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.PlacementTests != null && responseData.PlacementTests.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.PlacementTests.length; i++) {
                    items.push(new smapi.admissions.PlacementTestModel().LoadFromResponse(responseData.PlacementTests[i]));
                }
                loaded.PlacementTests(items);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }
            if (responseData.ProcessStage != null) {
                loaded.ProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.ProcessStage));
            }
            if (responseData.ReviewerComments != null && responseData.ReviewerComments.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ReviewerComments.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationCommentModel().LoadFromResponse(responseData.ReviewerComments[i]));
                }
                loaded.ReviewerComments(items);
            }
            if (responseData.ExternalData != null && responseData.ExternalData.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ExternalData.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepDataModel().LoadFromResponse(responseData.ExternalData[i]));
                }
                loaded.ExternalData(items);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.ChildSteps != null && responseData.ChildSteps.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ChildSteps.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.ChildSteps[i]));
                }
                loaded.ChildSteps(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.PlacementTestStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Comments.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProcessStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RequiredOptionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StepStartDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.StepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.NavigatorScreenPath.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ExpectedStepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AdHoc.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ExternalStage.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.MinExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MaxExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DueDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PortalStepModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.PortalStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PraxisModel(options) {
        var defaults = {
            PersonID: 0,
            TestDate: null,
            ETSID: '',
            Name: '',
            Score: 0,
            PassingScore: 0,
            UseForPlacement: false,
            SourceID: null,
            StateID: null,
            DataStepID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.TestDate = ko.validatedObservable(settings.TestDate);
        this.ETSID = ko.validatedObservable(settings.ETSID);
        this.Name = ko.validatedObservable(settings.Name);
        this.Score = ko.validatedObservable(settings.Score);
        this.PassingScore = ko.validatedObservable(settings.PassingScore);
        this.UseForPlacement = ko.validatedObservable(settings.UseForPlacement);
        this.SourceID = ko.validatedObservable(settings.SourceID);
        this.StateID = ko.validatedObservable(settings.StateID);
        this.DataStepID = ko.validatedObservable(settings.DataStepID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.DataStep = ko.observable();
        this.GoverningDistrict = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.TestDate != undefined) {
                loaded.TestDate(responseData.TestDate);
            }
            if (responseData.ETSID != undefined) {
                loaded.ETSID(responseData.ETSID);
            }
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Score != undefined) {
                loaded.Score(responseData.Score);
            }
            if (responseData.PassingScore != undefined) {
                loaded.PassingScore(responseData.PassingScore);
            }
            if (responseData.UseForPlacement != undefined) {
                loaded.UseForPlacement(responseData.UseForPlacement);
            }
            if (responseData.SourceID != undefined) {
                loaded.SourceID(responseData.SourceID);
            }
            if (responseData.StateID != undefined) {
                loaded.StateID(responseData.StateID);
            }
            if (responseData.DataStepID != undefined) {
                loaded.DataStepID(responseData.DataStepID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.DataStep != null) {
                loaded.DataStep(new smapi.admissions.PraxisStepModel().LoadFromResponse(responseData.DataStep));
            }
            if (responseData.GoverningDistrict != null) {
                loaded.GoverningDistrict(new smapi.community.GoverningDistrictModel().LoadFromResponse(responseData.GoverningDistrict));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.Praxis', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TestDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ETSID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            }
        });
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Score.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PassingScore.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.UseForPlacement.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.SourceID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StateID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DataStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PraxisIIModel(options) {
        var defaults = {
            PersonID: 0,
            TestDate: null,
            ETSID: '',
            Name: '',
            Score: 0,
            PassingScore: 0,
            UseForPlacement: false,
            SourceID: null,
            StateID: null,
            DataStepID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.TestDate = ko.validatedObservable(settings.TestDate);
        this.ETSID = ko.validatedObservable(settings.ETSID);
        this.Name = ko.validatedObservable(settings.Name);
        this.Score = ko.validatedObservable(settings.Score);
        this.PassingScore = ko.validatedObservable(settings.PassingScore);
        this.UseForPlacement = ko.validatedObservable(settings.UseForPlacement);
        this.SourceID = ko.validatedObservable(settings.SourceID);
        this.StateID = ko.validatedObservable(settings.StateID);
        this.DataStepID = ko.validatedObservable(settings.DataStepID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.DataStep = ko.observable();
        this.GoverningDistrict = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.TestDate != undefined) {
                loaded.TestDate(responseData.TestDate);
            }
            if (responseData.ETSID != undefined) {
                loaded.ETSID(responseData.ETSID);
            }
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Score != undefined) {
                loaded.Score(responseData.Score);
            }
            if (responseData.PassingScore != undefined) {
                loaded.PassingScore(responseData.PassingScore);
            }
            if (responseData.UseForPlacement != undefined) {
                loaded.UseForPlacement(responseData.UseForPlacement);
            }
            if (responseData.SourceID != undefined) {
                loaded.SourceID(responseData.SourceID);
            }
            if (responseData.StateID != undefined) {
                loaded.StateID(responseData.StateID);
            }
            if (responseData.DataStepID != undefined) {
                loaded.DataStepID(responseData.DataStepID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.DataStep != null) {
                loaded.DataStep(new smapi.admissions.PraxisIIStepModel().LoadFromResponse(responseData.DataStep));
            }
            if (responseData.GoverningDistrict != null) {
                loaded.GoverningDistrict(new smapi.community.GoverningDistrictModel().LoadFromResponse(responseData.GoverningDistrict));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.PraxisII', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TestDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ETSID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            }
        });
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Score.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PassingScore.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.UseForPlacement.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.SourceID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StateID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DataStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PraxisIIStepModel(options) {
        var defaults = {
            ClassType: 0,
            Comments: '',
            AdmissionsAttemptID: 0,
            ProcessStageID: null,
            ParentStepID: null,
            StatusID: 0,
            RequiredOptionID: null,
            StepStartDate: null,
            StepEndDate: null,
            NavigatorScreenPath: '',
            ExpectedStepEndDate: null,
            AdHoc: false,
            ProgressOveridden: false,
            ExternalStage: false,
            MinExternalData: 0,
            MaxExternalData: 0,
            DueDate: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.Comments = ko.validatedObservable(settings.Comments);
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.ProcessStageID = ko.validatedObservable(settings.ProcessStageID);
        this.ParentStepID = ko.validatedObservable(settings.ParentStepID);
        this.StatusID = ko.validatedObservable(settings.StatusID);
        this.RequiredOptionID = ko.validatedObservable(settings.RequiredOptionID);
        this.StepStartDate = ko.validatedObservable(settings.StepStartDate);
        this.StepEndDate = ko.validatedObservable(settings.StepEndDate);
        this.NavigatorScreenPath = ko.validatedObservable(settings.NavigatorScreenPath);
        this.ExpectedStepEndDate = ko.validatedObservable(settings.ExpectedStepEndDate);
        this.AdHoc = ko.validatedObservable(settings.AdHoc);
        this.ProgressOveridden = ko.validatedObservable(settings.ProgressOveridden);
        this.ExternalStage = ko.validatedObservable(settings.ExternalStage);
        this.MinExternalData = ko.validatedObservable(settings.MinExternalData);
        this.MaxExternalData = ko.validatedObservable(settings.MaxExternalData);
        this.DueDate = ko.validatedObservable(settings.DueDate);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.PraxisIITestScores = ko.observableArray([]);
        this.AdmissionsAttempt = ko.observable();
        this.ProcessStage = ko.observable();
        this.ReviewerComments = ko.observableArray([]);
        this.ExternalData = ko.observableArray([]);
        this.Parent = ko.observable();
        this.ChildSteps = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.Comments != undefined) {
                loaded.Comments(responseData.Comments);
            }
            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.ProcessStageID != undefined) {
                loaded.ProcessStageID(responseData.ProcessStageID);
            }
            if (responseData.ParentStepID != undefined) {
                loaded.ParentStepID(responseData.ParentStepID);
            }
            if (responseData.StatusID != undefined) {
                loaded.StatusID(responseData.StatusID);
            }
            if (responseData.RequiredOptionID != undefined) {
                loaded.RequiredOptionID(responseData.RequiredOptionID);
            }
            if (responseData.StepStartDate != undefined) {
                loaded.StepStartDate(responseData.StepStartDate);
            }
            if (responseData.StepEndDate != undefined) {
                loaded.StepEndDate(responseData.StepEndDate);
            }
            if (responseData.NavigatorScreenPath != undefined) {
                loaded.NavigatorScreenPath(responseData.NavigatorScreenPath);
            }
            if (responseData.ExpectedStepEndDate != undefined) {
                loaded.ExpectedStepEndDate(responseData.ExpectedStepEndDate);
            }
            if (responseData.AdHoc != undefined) {
                loaded.AdHoc(responseData.AdHoc);
            }
            if (responseData.ProgressOveridden != undefined) {
                loaded.ProgressOveridden(responseData.ProgressOveridden);
            }
            if (responseData.ExternalStage != undefined) {
                loaded.ExternalStage(responseData.ExternalStage);
            }
            if (responseData.MinExternalData != undefined) {
                loaded.MinExternalData(responseData.MinExternalData);
            }
            if (responseData.MaxExternalData != undefined) {
                loaded.MaxExternalData(responseData.MaxExternalData);
            }
            if (responseData.DueDate != undefined) {
                loaded.DueDate(responseData.DueDate);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.PraxisIITestScores != null && responseData.PraxisIITestScores.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.PraxisIITestScores.length; i++) {
                    items.push(new smapi.admissions.PraxisIIModel().LoadFromResponse(responseData.PraxisIITestScores[i]));
                }
                loaded.PraxisIITestScores(items);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }
            if (responseData.ProcessStage != null) {
                loaded.ProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.ProcessStage));
            }
            if (responseData.ReviewerComments != null && responseData.ReviewerComments.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ReviewerComments.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationCommentModel().LoadFromResponse(responseData.ReviewerComments[i]));
                }
                loaded.ReviewerComments(items);
            }
            if (responseData.ExternalData != null && responseData.ExternalData.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ExternalData.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepDataModel().LoadFromResponse(responseData.ExternalData[i]));
                }
                loaded.ExternalData(items);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.ChildSteps != null && responseData.ChildSteps.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ChildSteps.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.ChildSteps[i]));
                }
                loaded.ChildSteps(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.PraxisIIStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Comments.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProcessStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RequiredOptionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StepStartDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.StepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.NavigatorScreenPath.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ExpectedStepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AdHoc.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ExternalStage.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.MinExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MaxExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DueDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PraxisStepModel(options) {
        var defaults = {
            ClassType: 0,
            Comments: '',
            AdmissionsAttemptID: 0,
            ProcessStageID: null,
            ParentStepID: null,
            StatusID: 0,
            RequiredOptionID: null,
            StepStartDate: null,
            StepEndDate: null,
            NavigatorScreenPath: '',
            ExpectedStepEndDate: null,
            AdHoc: false,
            ProgressOveridden: false,
            ExternalStage: false,
            MinExternalData: 0,
            MaxExternalData: 0,
            DueDate: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.Comments = ko.validatedObservable(settings.Comments);
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.ProcessStageID = ko.validatedObservable(settings.ProcessStageID);
        this.ParentStepID = ko.validatedObservable(settings.ParentStepID);
        this.StatusID = ko.validatedObservable(settings.StatusID);
        this.RequiredOptionID = ko.validatedObservable(settings.RequiredOptionID);
        this.StepStartDate = ko.validatedObservable(settings.StepStartDate);
        this.StepEndDate = ko.validatedObservable(settings.StepEndDate);
        this.NavigatorScreenPath = ko.validatedObservable(settings.NavigatorScreenPath);
        this.ExpectedStepEndDate = ko.validatedObservable(settings.ExpectedStepEndDate);
        this.AdHoc = ko.validatedObservable(settings.AdHoc);
        this.ProgressOveridden = ko.validatedObservable(settings.ProgressOveridden);
        this.ExternalStage = ko.validatedObservable(settings.ExternalStage);
        this.MinExternalData = ko.validatedObservable(settings.MinExternalData);
        this.MaxExternalData = ko.validatedObservable(settings.MaxExternalData);
        this.DueDate = ko.validatedObservable(settings.DueDate);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.PraxisTestScores = ko.observableArray([]);
        this.AdmissionsAttempt = ko.observable();
        this.ProcessStage = ko.observable();
        this.ReviewerComments = ko.observableArray([]);
        this.ExternalData = ko.observableArray([]);
        this.Parent = ko.observable();
        this.ChildSteps = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.Comments != undefined) {
                loaded.Comments(responseData.Comments);
            }
            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.ProcessStageID != undefined) {
                loaded.ProcessStageID(responseData.ProcessStageID);
            }
            if (responseData.ParentStepID != undefined) {
                loaded.ParentStepID(responseData.ParentStepID);
            }
            if (responseData.StatusID != undefined) {
                loaded.StatusID(responseData.StatusID);
            }
            if (responseData.RequiredOptionID != undefined) {
                loaded.RequiredOptionID(responseData.RequiredOptionID);
            }
            if (responseData.StepStartDate != undefined) {
                loaded.StepStartDate(responseData.StepStartDate);
            }
            if (responseData.StepEndDate != undefined) {
                loaded.StepEndDate(responseData.StepEndDate);
            }
            if (responseData.NavigatorScreenPath != undefined) {
                loaded.NavigatorScreenPath(responseData.NavigatorScreenPath);
            }
            if (responseData.ExpectedStepEndDate != undefined) {
                loaded.ExpectedStepEndDate(responseData.ExpectedStepEndDate);
            }
            if (responseData.AdHoc != undefined) {
                loaded.AdHoc(responseData.AdHoc);
            }
            if (responseData.ProgressOveridden != undefined) {
                loaded.ProgressOveridden(responseData.ProgressOveridden);
            }
            if (responseData.ExternalStage != undefined) {
                loaded.ExternalStage(responseData.ExternalStage);
            }
            if (responseData.MinExternalData != undefined) {
                loaded.MinExternalData(responseData.MinExternalData);
            }
            if (responseData.MaxExternalData != undefined) {
                loaded.MaxExternalData(responseData.MaxExternalData);
            }
            if (responseData.DueDate != undefined) {
                loaded.DueDate(responseData.DueDate);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.PraxisTestScores != null && responseData.PraxisTestScores.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.PraxisTestScores.length; i++) {
                    items.push(new smapi.admissions.PraxisModel().LoadFromResponse(responseData.PraxisTestScores[i]));
                }
                loaded.PraxisTestScores(items);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }
            if (responseData.ProcessStage != null) {
                loaded.ProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.ProcessStage));
            }
            if (responseData.ReviewerComments != null && responseData.ReviewerComments.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ReviewerComments.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationCommentModel().LoadFromResponse(responseData.ReviewerComments[i]));
                }
                loaded.ReviewerComments(items);
            }
            if (responseData.ExternalData != null && responseData.ExternalData.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ExternalData.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepDataModel().LoadFromResponse(responseData.ExternalData[i]));
                }
                loaded.ExternalData(items);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.ChildSteps != null && responseData.ChildSteps.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ChildSteps.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.ChildSteps[i]));
                }
                loaded.ChildSteps(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.PraxisStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Comments.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProcessStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RequiredOptionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StepStartDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.StepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.NavigatorScreenPath.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ExpectedStepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AdHoc.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ExternalStage.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.MinExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MaxExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DueDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function RankingAlgorithmModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.RankingAlgorithm', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function RequestedLoginInformationModel(options) {
        var defaults = {
            RequestedID: '',
            Password: '',
            PersonID: 0,
            DataStepID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.RequestedID = ko.validatedObservable(settings.RequestedID);
        this.Password = ko.validatedObservable(settings.Password);
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.DataStepID = ko.validatedObservable(settings.DataStepID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.DataStep = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.RequestedID != undefined) {
                loaded.RequestedID(responseData.RequestedID);
            }
            if (responseData.Password != undefined) {
                loaded.Password(responseData.Password);
            }
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.DataStepID != undefined) {
                loaded.DataStepID(responseData.DataStepID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.DataStep != null) {
                loaded.DataStep(new smapi.admissions.RequestedLoginInformationStepModel().LoadFromResponse(responseData.DataStep));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.RequestedLoginInformation', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.RequestedID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Password.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DataStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function RequestedLoginInformationStepModel(options) {
        var defaults = {
            ClassType: 0,
            Comments: '',
            AdmissionsAttemptID: 0,
            ProcessStageID: null,
            ParentStepID: null,
            StatusID: 0,
            RequiredOptionID: null,
            StepStartDate: null,
            StepEndDate: null,
            NavigatorScreenPath: '',
            ExpectedStepEndDate: null,
            AdHoc: false,
            ProgressOveridden: false,
            ExternalStage: false,
            MinExternalData: 0,
            MaxExternalData: 0,
            DueDate: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.Comments = ko.validatedObservable(settings.Comments);
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.ProcessStageID = ko.validatedObservable(settings.ProcessStageID);
        this.ParentStepID = ko.validatedObservable(settings.ParentStepID);
        this.StatusID = ko.validatedObservable(settings.StatusID);
        this.RequiredOptionID = ko.validatedObservable(settings.RequiredOptionID);
        this.StepStartDate = ko.validatedObservable(settings.StepStartDate);
        this.StepEndDate = ko.validatedObservable(settings.StepEndDate);
        this.NavigatorScreenPath = ko.validatedObservable(settings.NavigatorScreenPath);
        this.ExpectedStepEndDate = ko.validatedObservable(settings.ExpectedStepEndDate);
        this.AdHoc = ko.validatedObservable(settings.AdHoc);
        this.ProgressOveridden = ko.validatedObservable(settings.ProgressOveridden);
        this.ExternalStage = ko.validatedObservable(settings.ExternalStage);
        this.MinExternalData = ko.validatedObservable(settings.MinExternalData);
        this.MaxExternalData = ko.validatedObservable(settings.MaxExternalData);
        this.DueDate = ko.validatedObservable(settings.DueDate);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.RequestedLoginDetails = ko.observableArray([]);
        this.AdmissionsAttempt = ko.observable();
        this.ProcessStage = ko.observable();
        this.ReviewerComments = ko.observableArray([]);
        this.ExternalData = ko.observableArray([]);
        this.Parent = ko.observable();
        this.ChildSteps = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.Comments != undefined) {
                loaded.Comments(responseData.Comments);
            }
            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.ProcessStageID != undefined) {
                loaded.ProcessStageID(responseData.ProcessStageID);
            }
            if (responseData.ParentStepID != undefined) {
                loaded.ParentStepID(responseData.ParentStepID);
            }
            if (responseData.StatusID != undefined) {
                loaded.StatusID(responseData.StatusID);
            }
            if (responseData.RequiredOptionID != undefined) {
                loaded.RequiredOptionID(responseData.RequiredOptionID);
            }
            if (responseData.StepStartDate != undefined) {
                loaded.StepStartDate(responseData.StepStartDate);
            }
            if (responseData.StepEndDate != undefined) {
                loaded.StepEndDate(responseData.StepEndDate);
            }
            if (responseData.NavigatorScreenPath != undefined) {
                loaded.NavigatorScreenPath(responseData.NavigatorScreenPath);
            }
            if (responseData.ExpectedStepEndDate != undefined) {
                loaded.ExpectedStepEndDate(responseData.ExpectedStepEndDate);
            }
            if (responseData.AdHoc != undefined) {
                loaded.AdHoc(responseData.AdHoc);
            }
            if (responseData.ProgressOveridden != undefined) {
                loaded.ProgressOveridden(responseData.ProgressOveridden);
            }
            if (responseData.ExternalStage != undefined) {
                loaded.ExternalStage(responseData.ExternalStage);
            }
            if (responseData.MinExternalData != undefined) {
                loaded.MinExternalData(responseData.MinExternalData);
            }
            if (responseData.MaxExternalData != undefined) {
                loaded.MaxExternalData(responseData.MaxExternalData);
            }
            if (responseData.DueDate != undefined) {
                loaded.DueDate(responseData.DueDate);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.RequestedLoginDetails != null && responseData.RequestedLoginDetails.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.RequestedLoginDetails.length; i++) {
                    items.push(new smapi.admissions.RequestedLoginInformationModel().LoadFromResponse(responseData.RequestedLoginDetails[i]));
                }
                loaded.RequestedLoginDetails(items);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }
            if (responseData.ProcessStage != null) {
                loaded.ProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.ProcessStage));
            }
            if (responseData.ReviewerComments != null && responseData.ReviewerComments.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ReviewerComments.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationCommentModel().LoadFromResponse(responseData.ReviewerComments[i]));
                }
                loaded.ReviewerComments(items);
            }
            if (responseData.ExternalData != null && responseData.ExternalData.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ExternalData.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepDataModel().LoadFromResponse(responseData.ExternalData[i]));
                }
                loaded.ExternalData(items);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.ChildSteps != null && responseData.ChildSteps.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ChildSteps.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.ChildSteps[i]));
                }
                loaded.ChildSteps(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.RequestedLoginInformationStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Comments.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProcessStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RequiredOptionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StepStartDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.StepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.NavigatorScreenPath.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ExpectedStepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AdHoc.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ExternalStage.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.MinExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MaxExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DueDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function RNLicenseModel(options) {
        var defaults = {
            LicenseNum: '',
            RNDocumentID: null,
            ExpirationDate: null,
            PersonID: 0,
            DataStepID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.LicenseNum = ko.validatedObservable(settings.LicenseNum);
        this.RNDocumentID = ko.validatedObservable(settings.RNDocumentID);
        this.ExpirationDate = ko.validatedObservable(settings.ExpirationDate);
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.DataStepID = ko.validatedObservable(settings.DataStepID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.RNDocument = ko.observable();
        this.Person = ko.observable();
        this.DataStep = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.LicenseNum != undefined) {
                loaded.LicenseNum(responseData.LicenseNum);
            }
            if (responseData.RNDocumentID != undefined) {
                loaded.RNDocumentID(responseData.RNDocumentID);
            }
            if (responseData.ExpirationDate != undefined) {
                loaded.ExpirationDate(responseData.ExpirationDate);
            }
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.DataStepID != undefined) {
                loaded.DataStepID(responseData.DataStepID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.RNDocument != null) {
                loaded.RNDocument(new smapi.admissions.AdmissionsDocumentModel().LoadFromResponse(responseData.RNDocument));
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.DataStep != null) {
                loaded.DataStep(new smapi.admissions.RNLicenseStepModel().LoadFromResponse(responseData.DataStep));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.RNLicense', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.LicenseNum.extend({
            maxLength: {
                params: 200,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '200')
            }
        });
        this.RNDocumentID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ExpirationDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DataStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function RNLicenseStepModel(options) {
        var defaults = {
            ClassType: 0,
            Comments: '',
            AdmissionsAttemptID: 0,
            ProcessStageID: null,
            ParentStepID: null,
            StatusID: 0,
            RequiredOptionID: null,
            StepStartDate: null,
            StepEndDate: null,
            NavigatorScreenPath: '',
            ExpectedStepEndDate: null,
            AdHoc: false,
            ProgressOveridden: false,
            ExternalStage: false,
            MinExternalData: 0,
            MaxExternalData: 0,
            DueDate: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.Comments = ko.validatedObservable(settings.Comments);
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.ProcessStageID = ko.validatedObservable(settings.ProcessStageID);
        this.ParentStepID = ko.validatedObservable(settings.ParentStepID);
        this.StatusID = ko.validatedObservable(settings.StatusID);
        this.RequiredOptionID = ko.validatedObservable(settings.RequiredOptionID);
        this.StepStartDate = ko.validatedObservable(settings.StepStartDate);
        this.StepEndDate = ko.validatedObservable(settings.StepEndDate);
        this.NavigatorScreenPath = ko.validatedObservable(settings.NavigatorScreenPath);
        this.ExpectedStepEndDate = ko.validatedObservable(settings.ExpectedStepEndDate);
        this.AdHoc = ko.validatedObservable(settings.AdHoc);
        this.ProgressOveridden = ko.validatedObservable(settings.ProgressOveridden);
        this.ExternalStage = ko.validatedObservable(settings.ExternalStage);
        this.MinExternalData = ko.validatedObservable(settings.MinExternalData);
        this.MaxExternalData = ko.validatedObservable(settings.MaxExternalData);
        this.DueDate = ko.validatedObservable(settings.DueDate);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.RNLicenses = ko.observableArray([]);
        this.AdmissionsAttempt = ko.observable();
        this.ProcessStage = ko.observable();
        this.ReviewerComments = ko.observableArray([]);
        this.ExternalData = ko.observableArray([]);
        this.Parent = ko.observable();
        this.ChildSteps = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.Comments != undefined) {
                loaded.Comments(responseData.Comments);
            }
            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.ProcessStageID != undefined) {
                loaded.ProcessStageID(responseData.ProcessStageID);
            }
            if (responseData.ParentStepID != undefined) {
                loaded.ParentStepID(responseData.ParentStepID);
            }
            if (responseData.StatusID != undefined) {
                loaded.StatusID(responseData.StatusID);
            }
            if (responseData.RequiredOptionID != undefined) {
                loaded.RequiredOptionID(responseData.RequiredOptionID);
            }
            if (responseData.StepStartDate != undefined) {
                loaded.StepStartDate(responseData.StepStartDate);
            }
            if (responseData.StepEndDate != undefined) {
                loaded.StepEndDate(responseData.StepEndDate);
            }
            if (responseData.NavigatorScreenPath != undefined) {
                loaded.NavigatorScreenPath(responseData.NavigatorScreenPath);
            }
            if (responseData.ExpectedStepEndDate != undefined) {
                loaded.ExpectedStepEndDate(responseData.ExpectedStepEndDate);
            }
            if (responseData.AdHoc != undefined) {
                loaded.AdHoc(responseData.AdHoc);
            }
            if (responseData.ProgressOveridden != undefined) {
                loaded.ProgressOveridden(responseData.ProgressOveridden);
            }
            if (responseData.ExternalStage != undefined) {
                loaded.ExternalStage(responseData.ExternalStage);
            }
            if (responseData.MinExternalData != undefined) {
                loaded.MinExternalData(responseData.MinExternalData);
            }
            if (responseData.MaxExternalData != undefined) {
                loaded.MaxExternalData(responseData.MaxExternalData);
            }
            if (responseData.DueDate != undefined) {
                loaded.DueDate(responseData.DueDate);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.RNLicenses != null && responseData.RNLicenses.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.RNLicenses.length; i++) {
                    items.push(new smapi.admissions.RNLicenseModel().LoadFromResponse(responseData.RNLicenses[i]));
                }
                loaded.RNLicenses(items);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }
            if (responseData.ProcessStage != null) {
                loaded.ProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.ProcessStage));
            }
            if (responseData.ReviewerComments != null && responseData.ReviewerComments.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ReviewerComments.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationCommentModel().LoadFromResponse(responseData.ReviewerComments[i]));
                }
                loaded.ReviewerComments(items);
            }
            if (responseData.ExternalData != null && responseData.ExternalData.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ExternalData.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepDataModel().LoadFromResponse(responseData.ExternalData[i]));
                }
                loaded.ExternalData(items);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.ChildSteps != null && responseData.ChildSteps.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ChildSteps.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.ChildSteps[i]));
                }
                loaded.ChildSteps(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.RNLicenseStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Comments.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProcessStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RequiredOptionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StepStartDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.StepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.NavigatorScreenPath.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ExpectedStepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AdHoc.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ExternalStage.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.MinExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MaxExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DueDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function SATModel(options) {
        var defaults = {
            PersonID: 0,
            TestDate: null,
            Reading: 0,
            Math: 0,
            Writing: 0,
            Essay: 0,
            Composite: 0,
            UseForPlacement: false,
            SourceID: null,
            GradeLevelID: null,
            RevisedScoreIndicator: false,
            TotalScore: 0,
            EvidenceBasedReadingAndWritingSectionScore: 0,
            MathSectionScore: 0,
            ReadingTestScore: 0,
            WritingAndLanguageTestScore: 0,
            MathTestScore: 0,
            AnalysisInScienceCrossTestScore: 0,
            AnalysisInHistorySocialScienceCrossTestScore: 0,
            RelevantWordsInContextSubscore: 0,
            CommandOfEvidenceSubscore: 0,
            ExpressionOfIdeasSubscore: 0,
            StandardEnglishConventionsSubscore: 0,
            HeartOfAlgebraSubscore: 0,
            PassportToAdvancedMathematicsSubscore: 0,
            ProblemSolvingAndDataAnalysisSubscore: 0,
            EssayReadingSubscore: 0,
            EssayAnalysisSubscore: 0,
            EssayWritingSubscore: 0,
            DataStepID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.TestDate = ko.validatedObservable(settings.TestDate);
        this.Reading = ko.validatedObservable(settings.Reading);
        this.Math = ko.validatedObservable(settings.Math);
        this.Writing = ko.validatedObservable(settings.Writing);
        this.Essay = ko.validatedObservable(settings.Essay);
        this.Composite = ko.validatedObservable(settings.Composite);
        this.UseForPlacement = ko.validatedObservable(settings.UseForPlacement);
        this.SourceID = ko.validatedObservable(settings.SourceID);
        this.GradeLevelID = ko.validatedObservable(settings.GradeLevelID);
        this.RevisedScoreIndicator = ko.validatedObservable(settings.RevisedScoreIndicator);
        this.TotalScore = ko.validatedObservable(settings.TotalScore);
        this.EvidenceBasedReadingAndWritingSectionScore = ko.validatedObservable(settings.EvidenceBasedReadingAndWritingSectionScore);
        this.MathSectionScore = ko.validatedObservable(settings.MathSectionScore);
        this.ReadingTestScore = ko.validatedObservable(settings.ReadingTestScore);
        this.WritingAndLanguageTestScore = ko.validatedObservable(settings.WritingAndLanguageTestScore);
        this.MathTestScore = ko.validatedObservable(settings.MathTestScore);
        this.AnalysisInScienceCrossTestScore = ko.validatedObservable(settings.AnalysisInScienceCrossTestScore);
        this.AnalysisInHistorySocialScienceCrossTestScore = ko.validatedObservable(settings.AnalysisInHistorySocialScienceCrossTestScore);
        this.RelevantWordsInContextSubscore = ko.validatedObservable(settings.RelevantWordsInContextSubscore);
        this.CommandOfEvidenceSubscore = ko.validatedObservable(settings.CommandOfEvidenceSubscore);
        this.ExpressionOfIdeasSubscore = ko.validatedObservable(settings.ExpressionOfIdeasSubscore);
        this.StandardEnglishConventionsSubscore = ko.validatedObservable(settings.StandardEnglishConventionsSubscore);
        this.HeartOfAlgebraSubscore = ko.validatedObservable(settings.HeartOfAlgebraSubscore);
        this.PassportToAdvancedMathematicsSubscore = ko.validatedObservable(settings.PassportToAdvancedMathematicsSubscore);
        this.ProblemSolvingAndDataAnalysisSubscore = ko.validatedObservable(settings.ProblemSolvingAndDataAnalysisSubscore);
        this.EssayReadingSubscore = ko.validatedObservable(settings.EssayReadingSubscore);
        this.EssayAnalysisSubscore = ko.validatedObservable(settings.EssayAnalysisSubscore);
        this.EssayWritingSubscore = ko.validatedObservable(settings.EssayWritingSubscore);
        this.DataStepID = ko.validatedObservable(settings.DataStepID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.GradeLevel = ko.observable();
        this.DataStep = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.TestDate != undefined) {
                loaded.TestDate(responseData.TestDate);
            }
            if (responseData.Reading != undefined) {
                loaded.Reading(responseData.Reading);
            }
            if (responseData.Math != undefined) {
                loaded.Math(responseData.Math);
            }
            if (responseData.Writing != undefined) {
                loaded.Writing(responseData.Writing);
            }
            if (responseData.Essay != undefined) {
                loaded.Essay(responseData.Essay);
            }
            if (responseData.Composite != undefined) {
                loaded.Composite(responseData.Composite);
            }
            if (responseData.UseForPlacement != undefined) {
                loaded.UseForPlacement(responseData.UseForPlacement);
            }
            if (responseData.SourceID != undefined) {
                loaded.SourceID(responseData.SourceID);
            }
            if (responseData.GradeLevelID != undefined) {
                loaded.GradeLevelID(responseData.GradeLevelID);
            }
            if (responseData.RevisedScoreIndicator != undefined) {
                loaded.RevisedScoreIndicator(responseData.RevisedScoreIndicator);
            }
            if (responseData.TotalScore != undefined) {
                loaded.TotalScore(responseData.TotalScore);
            }
            if (responseData.EvidenceBasedReadingAndWritingSectionScore != undefined) {
                loaded.EvidenceBasedReadingAndWritingSectionScore(responseData.EvidenceBasedReadingAndWritingSectionScore);
            }
            if (responseData.MathSectionScore != undefined) {
                loaded.MathSectionScore(responseData.MathSectionScore);
            }
            if (responseData.ReadingTestScore != undefined) {
                loaded.ReadingTestScore(responseData.ReadingTestScore);
            }
            if (responseData.WritingAndLanguageTestScore != undefined) {
                loaded.WritingAndLanguageTestScore(responseData.WritingAndLanguageTestScore);
            }
            if (responseData.MathTestScore != undefined) {
                loaded.MathTestScore(responseData.MathTestScore);
            }
            if (responseData.AnalysisInScienceCrossTestScore != undefined) {
                loaded.AnalysisInScienceCrossTestScore(responseData.AnalysisInScienceCrossTestScore);
            }
            if (responseData.AnalysisInHistorySocialScienceCrossTestScore != undefined) {
                loaded.AnalysisInHistorySocialScienceCrossTestScore(responseData.AnalysisInHistorySocialScienceCrossTestScore);
            }
            if (responseData.RelevantWordsInContextSubscore != undefined) {
                loaded.RelevantWordsInContextSubscore(responseData.RelevantWordsInContextSubscore);
            }
            if (responseData.CommandOfEvidenceSubscore != undefined) {
                loaded.CommandOfEvidenceSubscore(responseData.CommandOfEvidenceSubscore);
            }
            if (responseData.ExpressionOfIdeasSubscore != undefined) {
                loaded.ExpressionOfIdeasSubscore(responseData.ExpressionOfIdeasSubscore);
            }
            if (responseData.StandardEnglishConventionsSubscore != undefined) {
                loaded.StandardEnglishConventionsSubscore(responseData.StandardEnglishConventionsSubscore);
            }
            if (responseData.HeartOfAlgebraSubscore != undefined) {
                loaded.HeartOfAlgebraSubscore(responseData.HeartOfAlgebraSubscore);
            }
            if (responseData.PassportToAdvancedMathematicsSubscore != undefined) {
                loaded.PassportToAdvancedMathematicsSubscore(responseData.PassportToAdvancedMathematicsSubscore);
            }
            if (responseData.ProblemSolvingAndDataAnalysisSubscore != undefined) {
                loaded.ProblemSolvingAndDataAnalysisSubscore(responseData.ProblemSolvingAndDataAnalysisSubscore);
            }
            if (responseData.EssayReadingSubscore != undefined) {
                loaded.EssayReadingSubscore(responseData.EssayReadingSubscore);
            }
            if (responseData.EssayAnalysisSubscore != undefined) {
                loaded.EssayAnalysisSubscore(responseData.EssayAnalysisSubscore);
            }
            if (responseData.EssayWritingSubscore != undefined) {
                loaded.EssayWritingSubscore(responseData.EssayWritingSubscore);
            }
            if (responseData.DataStepID != undefined) {
                loaded.DataStepID(responseData.DataStepID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.GradeLevel != null) {
                loaded.GradeLevel(new smapi.admissions.ScoreGradeLevelModel().LoadFromResponse(responseData.GradeLevel));
            }
            if (responseData.DataStep != null) {
                loaded.DataStep(new smapi.admissions.SATStepModel().LoadFromResponse(responseData.DataStep));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.SAT', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TestDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.Reading.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Math.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Writing.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Essay.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Composite.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.UseForPlacement.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.SourceID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GradeLevelID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RevisedScoreIndicator.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.TotalScore.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EvidenceBasedReadingAndWritingSectionScore.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MathSectionScore.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ReadingTestScore.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.WritingAndLanguageTestScore.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MathTestScore.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AnalysisInScienceCrossTestScore.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AnalysisInHistorySocialScienceCrossTestScore.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RelevantWordsInContextSubscore.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CommandOfEvidenceSubscore.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ExpressionOfIdeasSubscore.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StandardEnglishConventionsSubscore.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.HeartOfAlgebraSubscore.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PassportToAdvancedMathematicsSubscore.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProblemSolvingAndDataAnalysisSubscore.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EssayReadingSubscore.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EssayAnalysisSubscore.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EssayWritingSubscore.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DataStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function SATStepModel(options) {
        var defaults = {
            ClassType: 0,
            Comments: '',
            AdmissionsAttemptID: 0,
            ProcessStageID: null,
            ParentStepID: null,
            StatusID: 0,
            RequiredOptionID: null,
            StepStartDate: null,
            StepEndDate: null,
            NavigatorScreenPath: '',
            ExpectedStepEndDate: null,
            AdHoc: false,
            ProgressOveridden: false,
            ExternalStage: false,
            MinExternalData: 0,
            MaxExternalData: 0,
            DueDate: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.Comments = ko.validatedObservable(settings.Comments);
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.ProcessStageID = ko.validatedObservable(settings.ProcessStageID);
        this.ParentStepID = ko.validatedObservable(settings.ParentStepID);
        this.StatusID = ko.validatedObservable(settings.StatusID);
        this.RequiredOptionID = ko.validatedObservable(settings.RequiredOptionID);
        this.StepStartDate = ko.validatedObservable(settings.StepStartDate);
        this.StepEndDate = ko.validatedObservable(settings.StepEndDate);
        this.NavigatorScreenPath = ko.validatedObservable(settings.NavigatorScreenPath);
        this.ExpectedStepEndDate = ko.validatedObservable(settings.ExpectedStepEndDate);
        this.AdHoc = ko.validatedObservable(settings.AdHoc);
        this.ProgressOveridden = ko.validatedObservable(settings.ProgressOveridden);
        this.ExternalStage = ko.validatedObservable(settings.ExternalStage);
        this.MinExternalData = ko.validatedObservable(settings.MinExternalData);
        this.MaxExternalData = ko.validatedObservable(settings.MaxExternalData);
        this.DueDate = ko.validatedObservable(settings.DueDate);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.SATTestScores = ko.observableArray([]);
        this.AdmissionsAttempt = ko.observable();
        this.ProcessStage = ko.observable();
        this.ReviewerComments = ko.observableArray([]);
        this.ExternalData = ko.observableArray([]);
        this.Parent = ko.observable();
        this.ChildSteps = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.Comments != undefined) {
                loaded.Comments(responseData.Comments);
            }
            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.ProcessStageID != undefined) {
                loaded.ProcessStageID(responseData.ProcessStageID);
            }
            if (responseData.ParentStepID != undefined) {
                loaded.ParentStepID(responseData.ParentStepID);
            }
            if (responseData.StatusID != undefined) {
                loaded.StatusID(responseData.StatusID);
            }
            if (responseData.RequiredOptionID != undefined) {
                loaded.RequiredOptionID(responseData.RequiredOptionID);
            }
            if (responseData.StepStartDate != undefined) {
                loaded.StepStartDate(responseData.StepStartDate);
            }
            if (responseData.StepEndDate != undefined) {
                loaded.StepEndDate(responseData.StepEndDate);
            }
            if (responseData.NavigatorScreenPath != undefined) {
                loaded.NavigatorScreenPath(responseData.NavigatorScreenPath);
            }
            if (responseData.ExpectedStepEndDate != undefined) {
                loaded.ExpectedStepEndDate(responseData.ExpectedStepEndDate);
            }
            if (responseData.AdHoc != undefined) {
                loaded.AdHoc(responseData.AdHoc);
            }
            if (responseData.ProgressOveridden != undefined) {
                loaded.ProgressOveridden(responseData.ProgressOveridden);
            }
            if (responseData.ExternalStage != undefined) {
                loaded.ExternalStage(responseData.ExternalStage);
            }
            if (responseData.MinExternalData != undefined) {
                loaded.MinExternalData(responseData.MinExternalData);
            }
            if (responseData.MaxExternalData != undefined) {
                loaded.MaxExternalData(responseData.MaxExternalData);
            }
            if (responseData.DueDate != undefined) {
                loaded.DueDate(responseData.DueDate);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.SATTestScores != null && responseData.SATTestScores.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.SATTestScores.length; i++) {
                    items.push(new smapi.admissions.SATModel().LoadFromResponse(responseData.SATTestScores[i]));
                }
                loaded.SATTestScores(items);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }
            if (responseData.ProcessStage != null) {
                loaded.ProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.ProcessStage));
            }
            if (responseData.ReviewerComments != null && responseData.ReviewerComments.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ReviewerComments.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationCommentModel().LoadFromResponse(responseData.ReviewerComments[i]));
                }
                loaded.ReviewerComments(items);
            }
            if (responseData.ExternalData != null && responseData.ExternalData.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ExternalData.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepDataModel().LoadFromResponse(responseData.ExternalData[i]));
                }
                loaded.ExternalData(items);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.ChildSteps != null && responseData.ChildSteps.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ChildSteps.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.ChildSteps[i]));
                }
                loaded.ChildSteps(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.SATStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Comments.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProcessStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RequiredOptionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StepStartDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.StepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.NavigatorScreenPath.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ExpectedStepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AdHoc.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ExternalStage.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.MinExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MaxExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DueDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ScoreGradeLevelModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            CollegeBoardID: '',
            BusinessMeaningName: '',
            SystemProtected: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.CollegeBoardID = ko.validatedObservable(settings.CollegeBoardID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.SystemProtected = ko.validatedObservable(settings.SystemProtected);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.CollegeBoardID != undefined) {
                loaded.CollegeBoardID(responseData.CollegeBoardID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.SystemProtected != undefined) {
                loaded.SystemProtected(responseData.SystemProtected);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.ScoreGradeLevel', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CollegeBoardID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 2,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '2')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.SystemProtected.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function SevisModel(options) {
        var defaults = {
            PersonID: 0,
            EnglishProficiencyRequired: false,
            EnglishNotRequiredReason: '',
            DataStepID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.EnglishProficiencyRequired = ko.validatedObservable(settings.EnglishProficiencyRequired);
        this.EnglishNotRequiredReason = ko.validatedObservable(settings.EnglishNotRequiredReason);
        this.DataStepID = ko.validatedObservable(settings.DataStepID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.DataStep = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.EnglishProficiencyRequired != undefined) {
                loaded.EnglishProficiencyRequired(responseData.EnglishProficiencyRequired);
            }
            if (responseData.EnglishNotRequiredReason != undefined) {
                loaded.EnglishNotRequiredReason(responseData.EnglishNotRequiredReason);
            }
            if (responseData.DataStepID != undefined) {
                loaded.DataStepID(responseData.DataStepID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.DataStep != null) {
                loaded.DataStep(new smapi.admissions.SevisStepModel().LoadFromResponse(responseData.DataStep));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.Sevis', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EnglishProficiencyRequired.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.EnglishNotRequiredReason.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.DataStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function SevisStepModel(options) {
        var defaults = {
            ClassType: 0,
            Comments: '',
            AdmissionsAttemptID: 0,
            ProcessStageID: null,
            ParentStepID: null,
            StatusID: 0,
            RequiredOptionID: null,
            StepStartDate: null,
            StepEndDate: null,
            NavigatorScreenPath: '',
            ExpectedStepEndDate: null,
            AdHoc: false,
            ProgressOveridden: false,
            ExternalStage: false,
            MinExternalData: 0,
            MaxExternalData: 0,
            DueDate: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.Comments = ko.validatedObservable(settings.Comments);
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.ProcessStageID = ko.validatedObservable(settings.ProcessStageID);
        this.ParentStepID = ko.validatedObservable(settings.ParentStepID);
        this.StatusID = ko.validatedObservable(settings.StatusID);
        this.RequiredOptionID = ko.validatedObservable(settings.RequiredOptionID);
        this.StepStartDate = ko.validatedObservable(settings.StepStartDate);
        this.StepEndDate = ko.validatedObservable(settings.StepEndDate);
        this.NavigatorScreenPath = ko.validatedObservable(settings.NavigatorScreenPath);
        this.ExpectedStepEndDate = ko.validatedObservable(settings.ExpectedStepEndDate);
        this.AdHoc = ko.validatedObservable(settings.AdHoc);
        this.ProgressOveridden = ko.validatedObservable(settings.ProgressOveridden);
        this.ExternalStage = ko.validatedObservable(settings.ExternalStage);
        this.MinExternalData = ko.validatedObservable(settings.MinExternalData);
        this.MaxExternalData = ko.validatedObservable(settings.MaxExternalData);
        this.DueDate = ko.validatedObservable(settings.DueDate);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.SevisTestScores = ko.observableArray([]);
        this.AdmissionsAttempt = ko.observable();
        this.ProcessStage = ko.observable();
        this.ReviewerComments = ko.observableArray([]);
        this.ExternalData = ko.observableArray([]);
        this.Parent = ko.observable();
        this.ChildSteps = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.Comments != undefined) {
                loaded.Comments(responseData.Comments);
            }
            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.ProcessStageID != undefined) {
                loaded.ProcessStageID(responseData.ProcessStageID);
            }
            if (responseData.ParentStepID != undefined) {
                loaded.ParentStepID(responseData.ParentStepID);
            }
            if (responseData.StatusID != undefined) {
                loaded.StatusID(responseData.StatusID);
            }
            if (responseData.RequiredOptionID != undefined) {
                loaded.RequiredOptionID(responseData.RequiredOptionID);
            }
            if (responseData.StepStartDate != undefined) {
                loaded.StepStartDate(responseData.StepStartDate);
            }
            if (responseData.StepEndDate != undefined) {
                loaded.StepEndDate(responseData.StepEndDate);
            }
            if (responseData.NavigatorScreenPath != undefined) {
                loaded.NavigatorScreenPath(responseData.NavigatorScreenPath);
            }
            if (responseData.ExpectedStepEndDate != undefined) {
                loaded.ExpectedStepEndDate(responseData.ExpectedStepEndDate);
            }
            if (responseData.AdHoc != undefined) {
                loaded.AdHoc(responseData.AdHoc);
            }
            if (responseData.ProgressOveridden != undefined) {
                loaded.ProgressOveridden(responseData.ProgressOveridden);
            }
            if (responseData.ExternalStage != undefined) {
                loaded.ExternalStage(responseData.ExternalStage);
            }
            if (responseData.MinExternalData != undefined) {
                loaded.MinExternalData(responseData.MinExternalData);
            }
            if (responseData.MaxExternalData != undefined) {
                loaded.MaxExternalData(responseData.MaxExternalData);
            }
            if (responseData.DueDate != undefined) {
                loaded.DueDate(responseData.DueDate);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.SevisTestScores != null && responseData.SevisTestScores.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.SevisTestScores.length; i++) {
                    items.push(new smapi.admissions.SevisModel().LoadFromResponse(responseData.SevisTestScores[i]));
                }
                loaded.SevisTestScores(items);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }
            if (responseData.ProcessStage != null) {
                loaded.ProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.ProcessStage));
            }
            if (responseData.ReviewerComments != null && responseData.ReviewerComments.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ReviewerComments.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationCommentModel().LoadFromResponse(responseData.ReviewerComments[i]));
                }
                loaded.ReviewerComments(items);
            }
            if (responseData.ExternalData != null && responseData.ExternalData.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ExternalData.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepDataModel().LoadFromResponse(responseData.ExternalData[i]));
                }
                loaded.ExternalData(items);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.ChildSteps != null && responseData.ChildSteps.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ChildSteps.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.ChildSteps[i]));
                }
                loaded.ChildSteps(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.SevisStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Comments.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProcessStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RequiredOptionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StepStartDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.StepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.NavigatorScreenPath.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ExpectedStepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AdHoc.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ExternalStage.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.MinExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MaxExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DueDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function StudentCategoryModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.StudentCategory', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function TOEFLModel(options) {
        var defaults = {
            PersonID: 0,
            TestDate: null,
            Score: 0,
            SourceID: null,
            DataStepID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.TestDate = ko.validatedObservable(settings.TestDate);
        this.Score = ko.validatedObservable(settings.Score);
        this.SourceID = ko.validatedObservable(settings.SourceID);
        this.DataStepID = ko.validatedObservable(settings.DataStepID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.DataStep = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.TestDate != undefined) {
                loaded.TestDate(responseData.TestDate);
            }
            if (responseData.Score != undefined) {
                loaded.Score(responseData.Score);
            }
            if (responseData.SourceID != undefined) {
                loaded.SourceID(responseData.SourceID);
            }
            if (responseData.DataStepID != undefined) {
                loaded.DataStepID(responseData.DataStepID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.DataStep != null) {
                loaded.DataStep(new smapi.admissions.TOEFLStepModel().LoadFromResponse(responseData.DataStep));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.TOEFL', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TestDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.Score.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SourceID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DataStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function TOEFLCBModel(options) {
        var defaults = {
            PersonID: 0,
            TestDate: null,
            Listening: 0,
            Writing: 0,
            Reading: 0,
            Total: 0,
            Essay: 0,
            SourceID: null,
            DataStepID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.TestDate = ko.validatedObservable(settings.TestDate);
        this.Listening = ko.validatedObservable(settings.Listening);
        this.Writing = ko.validatedObservable(settings.Writing);
        this.Reading = ko.validatedObservable(settings.Reading);
        this.Total = ko.validatedObservable(settings.Total);
        this.Essay = ko.validatedObservable(settings.Essay);
        this.SourceID = ko.validatedObservable(settings.SourceID);
        this.DataStepID = ko.validatedObservable(settings.DataStepID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.DataStep = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.TestDate != undefined) {
                loaded.TestDate(responseData.TestDate);
            }
            if (responseData.Listening != undefined) {
                loaded.Listening(responseData.Listening);
            }
            if (responseData.Writing != undefined) {
                loaded.Writing(responseData.Writing);
            }
            if (responseData.Reading != undefined) {
                loaded.Reading(responseData.Reading);
            }
            if (responseData.Total != undefined) {
                loaded.Total(responseData.Total);
            }
            if (responseData.Essay != undefined) {
                loaded.Essay(responseData.Essay);
            }
            if (responseData.SourceID != undefined) {
                loaded.SourceID(responseData.SourceID);
            }
            if (responseData.DataStepID != undefined) {
                loaded.DataStepID(responseData.DataStepID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.DataStep != null) {
                loaded.DataStep(new smapi.admissions.TOEFLCBStepModel().LoadFromResponse(responseData.DataStep));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.TOEFLCB', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TestDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.Listening.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Writing.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Reading.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Total.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Essay.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SourceID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DataStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function TOEFLCBStepModel(options) {
        var defaults = {
            ClassType: 0,
            Comments: '',
            AdmissionsAttemptID: 0,
            ProcessStageID: null,
            ParentStepID: null,
            StatusID: 0,
            RequiredOptionID: null,
            StepStartDate: null,
            StepEndDate: null,
            NavigatorScreenPath: '',
            ExpectedStepEndDate: null,
            AdHoc: false,
            ProgressOveridden: false,
            ExternalStage: false,
            MinExternalData: 0,
            MaxExternalData: 0,
            DueDate: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.Comments = ko.validatedObservable(settings.Comments);
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.ProcessStageID = ko.validatedObservable(settings.ProcessStageID);
        this.ParentStepID = ko.validatedObservable(settings.ParentStepID);
        this.StatusID = ko.validatedObservable(settings.StatusID);
        this.RequiredOptionID = ko.validatedObservable(settings.RequiredOptionID);
        this.StepStartDate = ko.validatedObservable(settings.StepStartDate);
        this.StepEndDate = ko.validatedObservable(settings.StepEndDate);
        this.NavigatorScreenPath = ko.validatedObservable(settings.NavigatorScreenPath);
        this.ExpectedStepEndDate = ko.validatedObservable(settings.ExpectedStepEndDate);
        this.AdHoc = ko.validatedObservable(settings.AdHoc);
        this.ProgressOveridden = ko.validatedObservable(settings.ProgressOveridden);
        this.ExternalStage = ko.validatedObservable(settings.ExternalStage);
        this.MinExternalData = ko.validatedObservable(settings.MinExternalData);
        this.MaxExternalData = ko.validatedObservable(settings.MaxExternalData);
        this.DueDate = ko.validatedObservable(settings.DueDate);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.TOEFLCBTestScores = ko.observableArray([]);
        this.AdmissionsAttempt = ko.observable();
        this.ProcessStage = ko.observable();
        this.ReviewerComments = ko.observableArray([]);
        this.ExternalData = ko.observableArray([]);
        this.Parent = ko.observable();
        this.ChildSteps = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.Comments != undefined) {
                loaded.Comments(responseData.Comments);
            }
            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.ProcessStageID != undefined) {
                loaded.ProcessStageID(responseData.ProcessStageID);
            }
            if (responseData.ParentStepID != undefined) {
                loaded.ParentStepID(responseData.ParentStepID);
            }
            if (responseData.StatusID != undefined) {
                loaded.StatusID(responseData.StatusID);
            }
            if (responseData.RequiredOptionID != undefined) {
                loaded.RequiredOptionID(responseData.RequiredOptionID);
            }
            if (responseData.StepStartDate != undefined) {
                loaded.StepStartDate(responseData.StepStartDate);
            }
            if (responseData.StepEndDate != undefined) {
                loaded.StepEndDate(responseData.StepEndDate);
            }
            if (responseData.NavigatorScreenPath != undefined) {
                loaded.NavigatorScreenPath(responseData.NavigatorScreenPath);
            }
            if (responseData.ExpectedStepEndDate != undefined) {
                loaded.ExpectedStepEndDate(responseData.ExpectedStepEndDate);
            }
            if (responseData.AdHoc != undefined) {
                loaded.AdHoc(responseData.AdHoc);
            }
            if (responseData.ProgressOveridden != undefined) {
                loaded.ProgressOveridden(responseData.ProgressOveridden);
            }
            if (responseData.ExternalStage != undefined) {
                loaded.ExternalStage(responseData.ExternalStage);
            }
            if (responseData.MinExternalData != undefined) {
                loaded.MinExternalData(responseData.MinExternalData);
            }
            if (responseData.MaxExternalData != undefined) {
                loaded.MaxExternalData(responseData.MaxExternalData);
            }
            if (responseData.DueDate != undefined) {
                loaded.DueDate(responseData.DueDate);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.TOEFLCBTestScores != null && responseData.TOEFLCBTestScores.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.TOEFLCBTestScores.length; i++) {
                    items.push(new smapi.admissions.TOEFLCBModel().LoadFromResponse(responseData.TOEFLCBTestScores[i]));
                }
                loaded.TOEFLCBTestScores(items);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }
            if (responseData.ProcessStage != null) {
                loaded.ProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.ProcessStage));
            }
            if (responseData.ReviewerComments != null && responseData.ReviewerComments.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ReviewerComments.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationCommentModel().LoadFromResponse(responseData.ReviewerComments[i]));
                }
                loaded.ReviewerComments(items);
            }
            if (responseData.ExternalData != null && responseData.ExternalData.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ExternalData.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepDataModel().LoadFromResponse(responseData.ExternalData[i]));
                }
                loaded.ExternalData(items);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.ChildSteps != null && responseData.ChildSteps.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ChildSteps.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.ChildSteps[i]));
                }
                loaded.ChildSteps(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.TOEFLCBStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Comments.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProcessStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RequiredOptionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StepStartDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.StepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.NavigatorScreenPath.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ExpectedStepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AdHoc.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ExternalStage.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.MinExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MaxExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DueDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function TOEFLPBModel(options) {
        var defaults = {
            PersonID: 0,
            TestDate: null,
            Listening: 0,
            Writing: 0,
            Reading: 0,
            Total: 0,
            TWE: 0,
            SourceID: null,
            DataStepID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.TestDate = ko.validatedObservable(settings.TestDate);
        this.Listening = ko.validatedObservable(settings.Listening);
        this.Writing = ko.validatedObservable(settings.Writing);
        this.Reading = ko.validatedObservable(settings.Reading);
        this.Total = ko.validatedObservable(settings.Total);
        this.TWE = ko.validatedObservable(settings.TWE);
        this.SourceID = ko.validatedObservable(settings.SourceID);
        this.DataStepID = ko.validatedObservable(settings.DataStepID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.DataStep = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.TestDate != undefined) {
                loaded.TestDate(responseData.TestDate);
            }
            if (responseData.Listening != undefined) {
                loaded.Listening(responseData.Listening);
            }
            if (responseData.Writing != undefined) {
                loaded.Writing(responseData.Writing);
            }
            if (responseData.Reading != undefined) {
                loaded.Reading(responseData.Reading);
            }
            if (responseData.Total != undefined) {
                loaded.Total(responseData.Total);
            }
            if (responseData.TWE != undefined) {
                loaded.TWE(responseData.TWE);
            }
            if (responseData.SourceID != undefined) {
                loaded.SourceID(responseData.SourceID);
            }
            if (responseData.DataStepID != undefined) {
                loaded.DataStepID(responseData.DataStepID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.DataStep != null) {
                loaded.DataStep(new smapi.admissions.TOEFLPBStepModel().LoadFromResponse(responseData.DataStep));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.TOEFLPB', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TestDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.Listening.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Writing.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Reading.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Total.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TWE.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SourceID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DataStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function TOEFLPBStepModel(options) {
        var defaults = {
            ClassType: 0,
            Comments: '',
            AdmissionsAttemptID: 0,
            ProcessStageID: null,
            ParentStepID: null,
            StatusID: 0,
            RequiredOptionID: null,
            StepStartDate: null,
            StepEndDate: null,
            NavigatorScreenPath: '',
            ExpectedStepEndDate: null,
            AdHoc: false,
            ProgressOveridden: false,
            ExternalStage: false,
            MinExternalData: 0,
            MaxExternalData: 0,
            DueDate: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.Comments = ko.validatedObservable(settings.Comments);
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.ProcessStageID = ko.validatedObservable(settings.ProcessStageID);
        this.ParentStepID = ko.validatedObservable(settings.ParentStepID);
        this.StatusID = ko.validatedObservable(settings.StatusID);
        this.RequiredOptionID = ko.validatedObservable(settings.RequiredOptionID);
        this.StepStartDate = ko.validatedObservable(settings.StepStartDate);
        this.StepEndDate = ko.validatedObservable(settings.StepEndDate);
        this.NavigatorScreenPath = ko.validatedObservable(settings.NavigatorScreenPath);
        this.ExpectedStepEndDate = ko.validatedObservable(settings.ExpectedStepEndDate);
        this.AdHoc = ko.validatedObservable(settings.AdHoc);
        this.ProgressOveridden = ko.validatedObservable(settings.ProgressOveridden);
        this.ExternalStage = ko.validatedObservable(settings.ExternalStage);
        this.MinExternalData = ko.validatedObservable(settings.MinExternalData);
        this.MaxExternalData = ko.validatedObservable(settings.MaxExternalData);
        this.DueDate = ko.validatedObservable(settings.DueDate);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.TOEFLPBTestScores = ko.observableArray([]);
        this.AdmissionsAttempt = ko.observable();
        this.ProcessStage = ko.observable();
        this.ReviewerComments = ko.observableArray([]);
        this.ExternalData = ko.observableArray([]);
        this.Parent = ko.observable();
        this.ChildSteps = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.Comments != undefined) {
                loaded.Comments(responseData.Comments);
            }
            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.ProcessStageID != undefined) {
                loaded.ProcessStageID(responseData.ProcessStageID);
            }
            if (responseData.ParentStepID != undefined) {
                loaded.ParentStepID(responseData.ParentStepID);
            }
            if (responseData.StatusID != undefined) {
                loaded.StatusID(responseData.StatusID);
            }
            if (responseData.RequiredOptionID != undefined) {
                loaded.RequiredOptionID(responseData.RequiredOptionID);
            }
            if (responseData.StepStartDate != undefined) {
                loaded.StepStartDate(responseData.StepStartDate);
            }
            if (responseData.StepEndDate != undefined) {
                loaded.StepEndDate(responseData.StepEndDate);
            }
            if (responseData.NavigatorScreenPath != undefined) {
                loaded.NavigatorScreenPath(responseData.NavigatorScreenPath);
            }
            if (responseData.ExpectedStepEndDate != undefined) {
                loaded.ExpectedStepEndDate(responseData.ExpectedStepEndDate);
            }
            if (responseData.AdHoc != undefined) {
                loaded.AdHoc(responseData.AdHoc);
            }
            if (responseData.ProgressOveridden != undefined) {
                loaded.ProgressOveridden(responseData.ProgressOveridden);
            }
            if (responseData.ExternalStage != undefined) {
                loaded.ExternalStage(responseData.ExternalStage);
            }
            if (responseData.MinExternalData != undefined) {
                loaded.MinExternalData(responseData.MinExternalData);
            }
            if (responseData.MaxExternalData != undefined) {
                loaded.MaxExternalData(responseData.MaxExternalData);
            }
            if (responseData.DueDate != undefined) {
                loaded.DueDate(responseData.DueDate);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.TOEFLPBTestScores != null && responseData.TOEFLPBTestScores.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.TOEFLPBTestScores.length; i++) {
                    items.push(new smapi.admissions.TOEFLPBModel().LoadFromResponse(responseData.TOEFLPBTestScores[i]));
                }
                loaded.TOEFLPBTestScores(items);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }
            if (responseData.ProcessStage != null) {
                loaded.ProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.ProcessStage));
            }
            if (responseData.ReviewerComments != null && responseData.ReviewerComments.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ReviewerComments.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationCommentModel().LoadFromResponse(responseData.ReviewerComments[i]));
                }
                loaded.ReviewerComments(items);
            }
            if (responseData.ExternalData != null && responseData.ExternalData.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ExternalData.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepDataModel().LoadFromResponse(responseData.ExternalData[i]));
                }
                loaded.ExternalData(items);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.ChildSteps != null && responseData.ChildSteps.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ChildSteps.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.ChildSteps[i]));
                }
                loaded.ChildSteps(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.TOEFLPBStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Comments.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProcessStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RequiredOptionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StepStartDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.StepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.NavigatorScreenPath.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ExpectedStepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AdHoc.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ExternalStage.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.MinExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MaxExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DueDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function TOEFLStepModel(options) {
        var defaults = {
            ClassType: 0,
            Comments: '',
            AdmissionsAttemptID: 0,
            ProcessStageID: null,
            ParentStepID: null,
            StatusID: 0,
            RequiredOptionID: null,
            StepStartDate: null,
            StepEndDate: null,
            NavigatorScreenPath: '',
            ExpectedStepEndDate: null,
            AdHoc: false,
            ProgressOveridden: false,
            ExternalStage: false,
            MinExternalData: 0,
            MaxExternalData: 0,
            DueDate: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.Comments = ko.validatedObservable(settings.Comments);
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.ProcessStageID = ko.validatedObservable(settings.ProcessStageID);
        this.ParentStepID = ko.validatedObservable(settings.ParentStepID);
        this.StatusID = ko.validatedObservable(settings.StatusID);
        this.RequiredOptionID = ko.validatedObservable(settings.RequiredOptionID);
        this.StepStartDate = ko.validatedObservable(settings.StepStartDate);
        this.StepEndDate = ko.validatedObservable(settings.StepEndDate);
        this.NavigatorScreenPath = ko.validatedObservable(settings.NavigatorScreenPath);
        this.ExpectedStepEndDate = ko.validatedObservable(settings.ExpectedStepEndDate);
        this.AdHoc = ko.validatedObservable(settings.AdHoc);
        this.ProgressOveridden = ko.validatedObservable(settings.ProgressOveridden);
        this.ExternalStage = ko.validatedObservable(settings.ExternalStage);
        this.MinExternalData = ko.validatedObservable(settings.MinExternalData);
        this.MaxExternalData = ko.validatedObservable(settings.MaxExternalData);
        this.DueDate = ko.validatedObservable(settings.DueDate);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.TOEFLTestScores = ko.observableArray([]);
        this.AdmissionsAttempt = ko.observable();
        this.ProcessStage = ko.observable();
        this.ReviewerComments = ko.observableArray([]);
        this.ExternalData = ko.observableArray([]);
        this.Parent = ko.observable();
        this.ChildSteps = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.Comments != undefined) {
                loaded.Comments(responseData.Comments);
            }
            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.ProcessStageID != undefined) {
                loaded.ProcessStageID(responseData.ProcessStageID);
            }
            if (responseData.ParentStepID != undefined) {
                loaded.ParentStepID(responseData.ParentStepID);
            }
            if (responseData.StatusID != undefined) {
                loaded.StatusID(responseData.StatusID);
            }
            if (responseData.RequiredOptionID != undefined) {
                loaded.RequiredOptionID(responseData.RequiredOptionID);
            }
            if (responseData.StepStartDate != undefined) {
                loaded.StepStartDate(responseData.StepStartDate);
            }
            if (responseData.StepEndDate != undefined) {
                loaded.StepEndDate(responseData.StepEndDate);
            }
            if (responseData.NavigatorScreenPath != undefined) {
                loaded.NavigatorScreenPath(responseData.NavigatorScreenPath);
            }
            if (responseData.ExpectedStepEndDate != undefined) {
                loaded.ExpectedStepEndDate(responseData.ExpectedStepEndDate);
            }
            if (responseData.AdHoc != undefined) {
                loaded.AdHoc(responseData.AdHoc);
            }
            if (responseData.ProgressOveridden != undefined) {
                loaded.ProgressOveridden(responseData.ProgressOveridden);
            }
            if (responseData.ExternalStage != undefined) {
                loaded.ExternalStage(responseData.ExternalStage);
            }
            if (responseData.MinExternalData != undefined) {
                loaded.MinExternalData(responseData.MinExternalData);
            }
            if (responseData.MaxExternalData != undefined) {
                loaded.MaxExternalData(responseData.MaxExternalData);
            }
            if (responseData.DueDate != undefined) {
                loaded.DueDate(responseData.DueDate);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.TOEFLTestScores != null && responseData.TOEFLTestScores.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.TOEFLTestScores.length; i++) {
                    items.push(new smapi.admissions.TOEFLModel().LoadFromResponse(responseData.TOEFLTestScores[i]));
                }
                loaded.TOEFLTestScores(items);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }
            if (responseData.ProcessStage != null) {
                loaded.ProcessStage(new smapi.admissions.AdmissionsProcessStageModel().LoadFromResponse(responseData.ProcessStage));
            }
            if (responseData.ReviewerComments != null && responseData.ReviewerComments.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ReviewerComments.length; i++) {
                    items.push(new smapi.admissions.ApplicationEvaluationCommentModel().LoadFromResponse(responseData.ReviewerComments[i]));
                }
                loaded.ReviewerComments(items);
            }
            if (responseData.ExternalData != null && responseData.ExternalData.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ExternalData.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepDataModel().LoadFromResponse(responseData.ExternalData[i]));
                }
                loaded.ExternalData(items);
            }
            if (responseData.Parent != null) {
                loaded.Parent(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.Parent));
            }
            if (responseData.ChildSteps != null && responseData.ChildSteps.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ChildSteps.length; i++) {
                    items.push(new smapi.admissions.AdmissionsAttemptStepModel().LoadFromResponse(responseData.ChildSteps[i]));
                }
                loaded.ChildSteps(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.TOEFLStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Comments.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProcessStageID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RequiredOptionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StepStartDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.StepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.NavigatorScreenPath.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ExpectedStepEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AdHoc.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ExternalStage.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.MinExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MaxExternalData.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DueDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function TranscriptDocumentModel(options) {
        var defaults = {
            SupportTransfer: false,
            AllAreTransferred: false,
            ClassType: 0,
            PersonID: 0,
            DocumentID: null,
            DocumentStatusID: null,
            CompletionDate: null,
            Comment: '',
            Reference: '',
            SourceID: null,
            DataStepID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.SupportTransfer = ko.validatedObservable(settings.SupportTransfer);
        this.AllAreTransferred = ko.validatedObservable(settings.AllAreTransferred);
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.DocumentID = ko.validatedObservable(settings.DocumentID);
        this.DocumentStatusID = ko.validatedObservable(settings.DocumentStatusID);
        this.CompletionDate = ko.validatedObservable(settings.CompletionDate);
        this.Comment = ko.validatedObservable(settings.Comment);
        this.Reference = ko.validatedObservable(settings.Reference);
        this.SourceID = ko.validatedObservable(settings.SourceID);
        this.DataStepID = ko.validatedObservable(settings.DataStepID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Courses = ko.observableArray([]);
        this.Person = ko.observable();
        this.Document = ko.observable();
        this.DataStep = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.SupportTransfer != undefined) {
                loaded.SupportTransfer(responseData.SupportTransfer);
            }
            if (responseData.AllAreTransferred != undefined) {
                loaded.AllAreTransferred(responseData.AllAreTransferred);
            }
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.DocumentID != undefined) {
                loaded.DocumentID(responseData.DocumentID);
            }
            if (responseData.DocumentStatusID != undefined) {
                loaded.DocumentStatusID(responseData.DocumentStatusID);
            }
            if (responseData.CompletionDate != undefined) {
                loaded.CompletionDate(responseData.CompletionDate);
            }
            if (responseData.Comment != undefined) {
                loaded.Comment(responseData.Comment);
            }
            if (responseData.Reference != undefined) {
                loaded.Reference(responseData.Reference);
            }
            if (responseData.SourceID != undefined) {
                loaded.SourceID(responseData.SourceID);
            }
            if (responseData.DataStepID != undefined) {
                loaded.DataStepID(responseData.DataStepID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Courses != null && responseData.Courses.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Courses.length; i++) {
                    items.push(new smapi.admissions.TranscriptEvaluateCourseModel().LoadFromResponse(responseData.Courses[i]));
                }
                loaded.Courses(items);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.Document != null) {
                loaded.Document(new smapi.community.DocumentModel().LoadFromResponse(responseData.Document));
            }
            if (responseData.DataStep != null) {
                loaded.DataStep(new smapi.admissions.AdmissionsDocumentStepModel().LoadFromResponse(responseData.DataStep));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.TranscriptDocument', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.SupportTransfer.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.AllAreTransferred.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DocumentID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DocumentStatusID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CompletionDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.Comment.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.Reference.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.SourceID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DataStepID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function TranscriptEvaluateCourseModel(options) {
        var defaults = {
            TranscriptDocumentID: null,
            PersonID: null,
            CollegeID: null,
            StartDate: null,
            EndDate: null,
            CourseID: '',
            CourseTitle: '',
            CourseMasterID: null,
            CourseEquivalenceID: null,
            CreditHours: 0,
            GradeID: null,
            IsTransfer: false,
            AttemptedHours: false,
            RepeatPolicyID: null,
            ShowGradeReport: false,
            ShowTranscript: false,
            ShowAdvisorTranscript: false,
            IgnoreRepeats: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.TranscriptDocumentID = ko.validatedObservable(settings.TranscriptDocumentID);
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.CollegeID = ko.validatedObservable(settings.CollegeID);
        this.StartDate = ko.validatedObservable(settings.StartDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.CourseID = ko.validatedObservable(settings.CourseID);
        this.CourseTitle = ko.validatedObservable(settings.CourseTitle);
        this.CourseMasterID = ko.validatedObservable(settings.CourseMasterID);
        this.CourseEquivalenceID = ko.validatedObservable(settings.CourseEquivalenceID);
        this.CreditHours = ko.validatedObservable(settings.CreditHours);
        this.GradeID = ko.validatedObservable(settings.GradeID);
        this.IsTransfer = ko.validatedObservable(settings.IsTransfer);
        this.AttemptedHours = ko.validatedObservable(settings.AttemptedHours);
        this.RepeatPolicyID = ko.validatedObservable(settings.RepeatPolicyID);
        this.ShowGradeReport = ko.validatedObservable(settings.ShowGradeReport);
        this.ShowTranscript = ko.validatedObservable(settings.ShowTranscript);
        this.ShowAdvisorTranscript = ko.validatedObservable(settings.ShowAdvisorTranscript);
        this.IgnoreRepeats = ko.validatedObservable(settings.IgnoreRepeats);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.TranscriptDocument = ko.observable();
        this.Person = ko.observable();
        this.College = ko.observable();
        this.CourseMaster = ko.observable();
        this.CourseEquivalence = ko.observable();
        this.Grade = ko.observable();
        this.RepeatPolicy = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.TranscriptDocumentID != undefined) {
                loaded.TranscriptDocumentID(responseData.TranscriptDocumentID);
            }
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.CollegeID != undefined) {
                loaded.CollegeID(responseData.CollegeID);
            }
            if (responseData.StartDate != undefined) {
                loaded.StartDate(responseData.StartDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.CourseID != undefined) {
                loaded.CourseID(responseData.CourseID);
            }
            if (responseData.CourseTitle != undefined) {
                loaded.CourseTitle(responseData.CourseTitle);
            }
            if (responseData.CourseMasterID != undefined) {
                loaded.CourseMasterID(responseData.CourseMasterID);
            }
            if (responseData.CourseEquivalenceID != undefined) {
                loaded.CourseEquivalenceID(responseData.CourseEquivalenceID);
            }
            if (responseData.CreditHours != undefined) {
                loaded.CreditHours(responseData.CreditHours);
            }
            if (responseData.GradeID != undefined) {
                loaded.GradeID(responseData.GradeID);
            }
            if (responseData.IsTransfer != undefined) {
                loaded.IsTransfer(responseData.IsTransfer);
            }
            if (responseData.AttemptedHours != undefined) {
                loaded.AttemptedHours(responseData.AttemptedHours);
            }
            if (responseData.RepeatPolicyID != undefined) {
                loaded.RepeatPolicyID(responseData.RepeatPolicyID);
            }
            if (responseData.ShowGradeReport != undefined) {
                loaded.ShowGradeReport(responseData.ShowGradeReport);
            }
            if (responseData.ShowTranscript != undefined) {
                loaded.ShowTranscript(responseData.ShowTranscript);
            }
            if (responseData.ShowAdvisorTranscript != undefined) {
                loaded.ShowAdvisorTranscript(responseData.ShowAdvisorTranscript);
            }
            if (responseData.IgnoreRepeats != undefined) {
                loaded.IgnoreRepeats(responseData.IgnoreRepeats);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.TranscriptDocument != null && responseData.TranscriptDocument != undefined ) {
                loaded.TranscriptDocument(new smapi.admissions.TranscriptDocumentModel().LoadFromResponse(responseData.TranscriptDocument));
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.College != null) {
                loaded.College(new smapi.academic.CollegeModel().LoadFromResponse(responseData.College));
            }
            if (responseData.CourseMaster != null) {
                loaded.CourseMaster(new smapi.academic.CourseMasterModel().LoadFromResponse(responseData.CourseMaster));
            }
            if (responseData.CourseEquivalence != null) {
                loaded.CourseEquivalence(new smapi.academic.CourseEquivalenceModel().LoadFromResponse(responseData.CourseEquivalence));
            }
            if (responseData.Grade != null) {
                loaded.Grade(new smapi.academic.GradeMasterModel().LoadFromResponse(responseData.Grade));
            }
            if (responseData.RepeatPolicy != null) {
                loaded.RepeatPolicy(new smapi.academic.RepeatPolicyModel().LoadFromResponse(responseData.RepeatPolicy));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.TranscriptEvaluateCourse', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.TranscriptDocumentID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PersonID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CollegeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StartDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.CourseID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.CourseTitle.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.CourseMasterID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CourseEquivalenceID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CreditHours.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GradeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.IsTransfer.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.AttemptedHours.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.RepeatPolicyID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ShowGradeReport.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ShowTranscript.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ShowAdvisorTranscript.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.IgnoreRepeats.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function LoadTemplates(basePath, targetDiv) {
        var uri = basePath + '/SMAPI.admissions.combined-1.0.0.html';
        jQuery.ajax({
            url: uri,
            type: 'GET',
            async: false,
            success: function (template) {
                jQuery("#" + targetDiv).append(template);
            }
        });
    }
    function AdmissionsAttemptEUAdditionalInfoModel(options) {
        var defaults = {
            AdmissionsAttemptID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
            HeardAboutInstituteFrom: '',
            InstituteCoursesPreviouslyTaken: '',
            InterviewViaSkype: false,
            InterviewSkypeNameOrEmail: '',
            InterviewViaPhone: false,
            InterviewPhoneNumber: '',
            InterviewInPerson: false,
            PreferredCommunicationTypeID: 0
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        this.HeardAboutInstituteFrom = ko.validatedObservable(settings.HeardAboutInstituteFrom);
        this.InstituteCoursesPreviouslyTaken = ko.validatedObservable(settings.InstituteCoursesPreviouslyTaken);
        this.InterviewViaSkype = ko.validatedObservable(settings.InterviewViaSkype);
        this.InterviewSkypeNameOrEmail = ko.validatedObservable(settings.InterviewSkypeNameOrEmail);
        this.InterviewViaPhone = ko.validatedObservable(settings.InterviewViaPhone);
        this.InterviewPhoneNumber = ko.validatedObservable(settings.InterviewPhoneNumber);
        this.InterviewInPerson = ko.validatedObservable(settings.InterviewInPerson);
        this.PreferredCommunicationTypeID = ko.validatedObservable(settings.PreferredCommunicationTypeID);

        // Relationships as Observables and ObservableArrays
        this.AdmissionsAttempt = ko.observable();

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.HeardAboutInstituteFrom != undefined) {
                loaded.DateModified(responseData.HeardAboutInstituteFrom);
            }
            if (responseData.InstituteCoursesPreviouslyTaken != undefined) {
                loaded.DateModified(responseData.InstituteCoursesPreviouslyTaken);
            }
            if (responseData.InterviewViaSkype != undefined) {
                loaded.DateModified(responseData.InterviewViaSkype);
            }
            if (responseData.InterviewSkypeNameOrEmail != undefined) {
                loaded.DateModified(responseData.InterviewSkypeNameOrEmail);
            }
            if (responseData.InterviewViaPhone != undefined) {
                loaded.DateModified(responseData.InterviewViaPhone);
            }
            if (responseData.InterviewPhoneNumber != undefined) {
                loaded.DateModified(responseData.InterviewPhoneNumber);
            }
            if (responseData.InterviewInPerson != undefined) {
                loaded.DateModified(responseData.InterviewInPerson);
            }
            if (responseData.PreferredCommunicationTypeID != undefined) {
                loaded.DateModified(responseData.PreferredCommunicationTypeID);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }

            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsAttempt', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.HeardAboutInstituteFrom.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.InstituteCoursesPreviouslyTaken.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.InterviewSkypeNameOrEmail.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.InterviewPhoneNumber.extend({
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            }
        });
        this.PreferredCommunicationTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }

    
    function AdmissionsAttemptUKAdditionalInfoModel(options) {
        var defaults = {
            AdmissionsAttemptID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
            InstituteRelationship: false,
            InstituteRelationshipName: '',
            InstituteRelationshipDescription: '',
            HeardAboutInstituteFrom: '',
            InstituteCoursesPreviouslyTaken: '',
            InterviewViaSkype: false,
            InterviewSkypeNameOrEmail: '',
            InterviewViaPhone: false,
            InterviewPhoneNumber: '',
            InterviewInPerson: false,
            PreferredCommunicationTypeID: 0
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        this.HeardAboutInstituteFrom = ko.validatedObservable(settings.HeardAboutInstituteFrom);
        this.InstituteCoursesPreviouslyTaken = ko.validatedObservable(settings.InstituteCoursesPreviouslyTaken);
        this.InstituteRelationship = ko.validatedObservable(settings.InstituteRelationship);
        this.InstituteRelationshipName = ko.validatedObservable(settings.InstituteRelationshipName);
        this.InstituteRelationshipDescription = ko.validatedObservable(settings.InstituteRelationshipDescription);
        this.InterviewViaSkype = ko.validatedObservable(settings.InterviewViaSkype);
        this.InterviewSkypeNameOrEmail = ko.validatedObservable(settings.InterviewSkypeNameOrEmail);
        this.InterviewViaPhone = ko.validatedObservable(settings.InterviewViaPhone);
        this.InterviewPhoneNumber = ko.validatedObservable(settings.InterviewPhoneNumber);
        this.InterviewInPerson = ko.validatedObservable(settings.InterviewInPerson);
        this.PreferredCommunicationTypeID = ko.validatedObservable(settings.PreferredCommunicationTypeID);

        // Relationships as Observables and ObservableArrays
        this.AdmissionsAttempt = ko.observable();

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.HeardAboutInstituteFrom != undefined) {
                loaded.DateModified(responseData.HeardAboutInstituteFrom);
            }
            if (responseData.InstituteCoursesPreviouslyTaken != undefined) {
                loaded.DateModified(responseData.InstituteCoursesPreviouslyTaken);
            }
            if (responseData.InstituteRelationship != undefined) {
                loaded.DateModified(responseData.InstituteRelationship);
            }
            if (responseData.InstituteRelationshipName != undefined) {
                loaded.DateModified(responseData.InstituteRelationshipName);
            }
            if (responseData.InstituteRelationshipDescription != undefined) {
                loaded.DateModified(responseData.InstituteRelationshipDescription);
            }
            if (responseData.InterviewViaSkype != undefined) {
                loaded.DateModified(responseData.InterviewViaSkype);
            }
            if (responseData.InterviewSkypeNameOrEmail != undefined) {
                loaded.DateModified(responseData.InterviewSkypeNameOrEmail);
            }
            if (responseData.InterviewViaPhone != undefined) {
                loaded.DateModified(responseData.InterviewViaPhone);
            }
            if (responseData.InterviewPhoneNumber != undefined) {
                loaded.DateModified(responseData.InterviewPhoneNumber);
            }
            if (responseData.InterviewInPerson != undefined) {
                loaded.DateModified(responseData.InterviewInPerson);
            }
            if (responseData.PreferredCommunicationTypeID != undefined) {
                loaded.DateModified(responseData.PreferredCommunicationTypeID);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }

            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsAttempt', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.HeardAboutInstituteFrom.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.InstituteCoursesPreviouslyTaken.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.InstituteRelationshipName.extend({
            maxLength: {
                params: 60,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '60')
            }
        });
        this.InstituteRelationshipDescription.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.InterviewSkypeNameOrEmail.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.InterviewPhoneNumber.extend({
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            }
        });
        this.PreferredCommunicationTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function AdmissionsAttemptUKPersonalStatementModel(options) {
        var defaults = {
            AdmissionsAttemptID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
            PersonalStatement: ''
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        this.PersonalStatement = ko.validatedObservable(settings.PersonalStatement);

        // Relationships as Observables and ObservableArrays
        this.AdmissionsAttempt = ko.observable();

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.PersonalStatement != undefined) {
                loaded.DateModified(responseData.PersonalStatement);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }

            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.AdmissionsAttempt', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.PersonalStatement.extend({
            maxLength: {
                params: 4000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '4000')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }


    function AdmissionsSpecialismModel(options) {
        var defaults = {
            AdmissionsAttemptID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            SpecialismID: 0,
            SpecialismCategoryID: 0,
            StaffID: 0,
            ReasonForStaffChange: '',
            APILink: ''
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.AdmissionsAttemptID = ko.validatedObservable(settings.AdmissionsAttemptID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        this.SpecialismID = ko.validatedObservable(settings.SpecialismID);
        this.SpecialismCategoryID = ko.validatedObservable(settings.SpecialismCategoryID);
        this.StaffID = ko.validatedObservable(settings.StaffID);
        this.ReasonForStaffChange = ko.validatedObservable(settings.ReasonForStaffChange);

        // Relationships as Observables and ObservableArrays
        this.AdmissionsAttempt = ko.observable();

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.AdmissionsAttemptID != undefined) {
                loaded.AdmissionsAttemptID(responseData.AdmissionsAttemptID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.SpecialismID != undefined) {
                loaded.SpecialismID(responseData.SpecialismID);
            }
            if (responseData.SpecialismCategoryID != undefined) {
                loaded.SpecialismCategoryID(responseData.SpecialismCategoryID);
            }
            if (responseData.StaffID != undefined) {
                loaded.StaffID(responseData.StaffID);
            }
            if (responseData.ReasonForStaffChange != undefined) {
                loaded.ReasonForStaffChange(responseData.ReasonForStaffChange);
            }
            if (responseData.AdmissionsAttempt != null) {
                loaded.AdmissionsAttempt(new smapi.admissions.AdmissionsAttemptModel().LoadFromResponse(responseData.AdmissionsAttempt));
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Admissions.Entity.ConservatoireAdmissionsSpecialism', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.AdmissionsAttemptID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.SpecialismID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SpecialismCategoryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StaffID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ReasonForStaffChange.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }
    
    
    $.extend(true, smapi.admissions, {
        ACTModel: ACTModel,
        ACTStepModel: ACTStepModel,
        AdmissionsAcademicLevelModel: AdmissionsAcademicLevelModel,
        AdmissionsApplicationRankModel: AdmissionsApplicationRankModel,
        AdmissionsAttemptModel: AdmissionsAttemptModel,
        AdmissionsAttemptInteractionModel: AdmissionsAttemptInteractionModel,
        AdmissionsAttemptMilestoneModel: AdmissionsAttemptMilestoneModel,
        AdmissionsAttemptProgramModel: AdmissionsAttemptProgramModel,
        AdmissionsAttemptStepModel: AdmissionsAttemptStepModel,
        AdmissionsAttemptStepDataModel: AdmissionsAttemptStepDataModel,
        AdmissionsCohortModel: AdmissionsCohortModel,
        AdmissionsConcentrationModel: AdmissionsConcentrationModel,
        AdmissionsDocumentModel: AdmissionsDocumentModel,
        AdmissionsDocumentStepModel: AdmissionsDocumentStepModel,
        AdmissionsEducationalGoalModel: AdmissionsEducationalGoalModel,
        AdmissionsEventTypeModel: AdmissionsEventTypeModel,
        AdmissionsEventTypeStepModel: AdmissionsEventTypeStepModel,
        AdmissionsModuleSettingsModel: AdmissionsModuleSettingsModel,
        AdmissionsPaymentInformationModel: AdmissionsPaymentInformationModel,
        AdmissionsPaymentInformationStepModel: AdmissionsPaymentInformationStepModel,
        AdmissionsPeriodModel: AdmissionsPeriodModel,
        AdmissionsProcessStageModel: AdmissionsProcessStageModel,
        AdmissionsProcessStageAttributesModel: AdmissionsProcessStageAttributesModel,
        AdmissionsProcessStageBehaviorModel: AdmissionsProcessStageBehaviorModel,
        AdmissionsProcessStagePrerequisiteModel: AdmissionsProcessStagePrerequisiteModel,
        AdmissionsProgramModel: AdmissionsProgramModel,
        AdmissionsProgramOfferingModel: AdmissionsProgramOfferingModel,
        AdmissionsProgramOfferingItemModel: AdmissionsProgramOfferingItemModel,
        AdmissionsRankingListModel: AdmissionsRankingListModel,
        AdmissionsStageModel: AdmissionsStageModel,
        AdmissionsTestNameModel: AdmissionsTestNameModel,
        AdmissionsTestStatusModel: AdmissionsTestStatusModel,
        AdmissionsTestSubjectModel: AdmissionsTestSubjectModel,
        AdmissionsTypeModel: AdmissionsTypeModel,
        ApplicationAthleticProgramsModel: ApplicationAthleticProgramsModel,
        ApplicationAthleticProgramsStepModel: ApplicationAthleticProgramsStepModel,
        ApplicationEvaluationModel: ApplicationEvaluationModel,
        ApplicationEvaluationCommentModel: ApplicationEvaluationCommentModel,
        ApplicationEvaluationCriteriaModel: ApplicationEvaluationCriteriaModel,
        ApplicationEvaluationReviewerStatusModel: ApplicationEvaluationReviewerStatusModel,
        ApplicationEvaluationRuleModel: ApplicationEvaluationRuleModel,
        ApplicationEvaluationSetupModel: ApplicationEvaluationSetupModel,
        ApplicationEvaluationSetupCommitteeSettingsModel: ApplicationEvaluationSetupCommitteeSettingsModel,
        ApplicationEvaluationStatusModel: ApplicationEvaluationStatusModel,
        ApplicationEvaluationWeightModel: ApplicationEvaluationWeightModel,
        ApplicationStudentSurveyModel: ApplicationStudentSurveyModel,
        ApplicationStudentSurveyStepModel: ApplicationStudentSurveyStepModel,
        AthleticProgramModel: AthleticProgramModel,
        CollegeInformationModel: CollegeInformationModel,
        CollegeInformationGoalModel: CollegeInformationGoalModel,
        CollegeInformationStepModel: CollegeInformationStepModel,
        CollegeSemesterTypeModel: CollegeSemesterTypeModel,
        CommitteeSettingsModel: CommitteeSettingsModel,
        CriterionModel: CriterionModel,
        CriterionStepModel: CriterionStepModel,
        EssayModel: EssayModel,
        EssayStepModel: EssayStepModel,
        ExternalAdmissionsProgramOfferingIDModel: ExternalAdmissionsProgramOfferingIDModel,
        ExternalAdmissionsProgramOfferingItemIDModel: ExternalAdmissionsProgramOfferingItemIDModel,
        GEDModel: GEDModel,
        GEDStepModel: GEDStepModel,
        GenericTestModel: GenericTestModel,
        GMATModel: GMATModel,
        GMATStepModel: GMATStepModel,
        GREGeneralModel: GREGeneralModel,
        GREGeneralStepModel: GREGeneralStepModel,
        HighSchoolModel: HighSchoolModel,
        HighSchoolCodeModel: HighSchoolCodeModel,
        HighSchoolInformationModel: HighSchoolInformationModel,
        HighSchoolInformationStepModel: HighSchoolInformationStepModel,
        PlacementTestModel: PlacementTestModel,
        PlacementTestExemptionModel: PlacementTestExemptionModel,
        PlacementTestExemptionStepModel: PlacementTestExemptionStepModel,
        PlacementTestStepModel: PlacementTestStepModel,
        PortalStepModel: PortalStepModel,
        PraxisModel: PraxisModel,
        PraxisIIModel: PraxisIIModel,
        PraxisIIStepModel: PraxisIIStepModel,
        PraxisStepModel: PraxisStepModel,
        RankingAlgorithmModel: RankingAlgorithmModel,
        RequestedLoginInformationModel: RequestedLoginInformationModel,
        RequestedLoginInformationStepModel: RequestedLoginInformationStepModel,
        RNLicenseModel: RNLicenseModel,
        RNLicenseStepModel: RNLicenseStepModel,
        SATModel: SATModel,
        SATStepModel: SATStepModel,
        ScoreGradeLevelModel: ScoreGradeLevelModel,
        SevisModel: SevisModel,
        SevisStepModel: SevisStepModel,
        StudentCategoryModel: StudentCategoryModel,
        TOEFLModel: TOEFLModel,
        TOEFLCBModel: TOEFLCBModel,
        TOEFLCBStepModel: TOEFLCBStepModel,
        TOEFLPBModel: TOEFLPBModel,
        TOEFLPBStepModel: TOEFLPBStepModel,
        TOEFLStepModel: TOEFLStepModel,
        TranscriptDocumentModel: TranscriptDocumentModel,
        TranscriptEvaluateCourseModel: TranscriptEvaluateCourseModel,
        LoadTemplates: LoadTemplates,
        AdmissionsAttemptEUAdditionalInfoModel : AdmissionsAttemptEUAdditionalInfoModel,
        AdmissionsAttemptUKAdditionalInfoModel: AdmissionsAttemptUKAdditionalInfoModel,
        AdmissionsAttemptUKPersonalStatementModel: AdmissionsAttemptUKPersonalStatementModel,
        AdmissionsSpecialismModel: AdmissionsSpecialismModel
    });
})(jQuery);
